var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __publicField = (obj, key, value2) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value2);
  return value2;
};
import { Notify, copyToClipboard, QCheckbox, useQuasar, QMenu, QList, QItemSection, QItem, QIcon, QBtn, ClosePopup, QToolbarTitle, QCardSection, QCardActions, QCard, QBar, QImg, QTooltip, QSelect, QInput, QChip, QPopupProxy, QDate, QTime, QTabs, QTabPanels, QTabPanel, QTab, QSeparator, Dialog, QPagination, debounce, Quasar, Loading, QTh, QTd, QTable, QField, QBtnToggle, useDialogPluginComponent, QDialog, QSpinner } from "quasar";
import { reactive, watch, defineComponent, computed, createBlock, openBlock, mergeProps, withCtx, renderSlot, createVNode, createElementBlock, createCommentVNode, toDisplayString, Fragment, renderList, withDirectives, createTextVNode, createElementVNode, ref, useModel, onMounted, mergeModels, normalizeClass, normalizeProps, createSlots, withModifiers, onBeforeMount, onBeforeUnmount, vShow, guardReactiveProps, resolveDynamicComponent, onUnmounted, nextTick as nextTick$1, markRaw, defineAsyncComponent, h } from "vue";
import { defaultLocale, languages } from "@editor/lib-i18n";
import { createI18n, useI18n } from "vue-i18n";
import { BrandList, CmsBrandMap, BrandCmsMap } from "@database/common-schema";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import { useQueryClient, useQuery, useMutation } from "@tanstack/vue-query";
function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
const { toString: toString$1 } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache2) => (thing) => {
  const str = toString$1.call(thing);
  return cache2[str] || (cache2[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray: isArray$1 } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction$1(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
const isString = typeOfTest("string");
const isFunction$1 = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject$2 = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate$1 = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$2(val) && isFunction$1(val.pipe);
const isFormData = (thing) => {
  const pattern = "[object FormData]";
  return thing && (typeof FormData === "function" && thing instanceof FormData || toString$1.call(thing) === pattern || isFunction$1(thing.toString) && thing.toString() === pattern);
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i2;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$1(obj)) {
    for (i2 = 0, l = obj.length; i2 < l; i2++) {
      fn.call(null, obj[i2], i2, obj);
    }
  } else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i2 = 0; i2 < len; i2++) {
      key = keys[i2];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function merge$1() {
  const result = {};
  const assignValue = (val, key) => {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$1(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  };
  for (let i2 = 0, l = arguments.length; i2 < l; i2++) {
    arguments[i2] && forEach(arguments[i2], assignValue);
  }
  return result;
}
const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction$1(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter2, propFilter) => {
  let props;
  let i2;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null)
    return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i2 = props.length;
    while (i2-- > 0) {
      prop = props[i2];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter2 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray$1 = (thing) => {
  if (!thing)
    return null;
  if (isArray$1(thing))
    return thing;
  let i2 = thing.length;
  if (!isNumber(i2))
    return null;
  const arr = new Array(i2);
  while (i2-- > 0) {
    arr[i2] = thing[i2];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;
  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[_-\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty$1 = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    const value2 = obj[name];
    if (!isFunction$1(value2))
      return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value2) => {
      obj[value2] = true;
    });
  };
  isArray$1(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value2, defaultValue2) => {
  value2 = +value2;
  return Number.isFinite(value2) ? value2 : defaultValue2;
};
const utils = {
  isArray: isArray$1,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$2,
  isPlainObject,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge: merge$1,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray: toArray$1,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$1,
  hasOwnProp: hasOwnProperty$1,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber
};
function AxiosError$1(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}
utils.inherits(AxiosError$1, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError$1.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError$1.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils.toFlatObject(error, axiosError, function filter2(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError$1.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser = typeof self === "object" ? self.FormData : window.FormData;
const FormData$2 = /* @__PURE__ */ getDefaultExportFromCjs(browser);
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}
function removeBrackets(key) {
  return utils.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path)
    return key;
  return path.concat(key).map(function each(token, i2) {
    token = removeBrackets(token);
    return !dots && i2 ? "[" + token + "]" : token;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function isSpecCompliant(thing) {
  return thing && utils.isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator];
}
function toFormData$1(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new (FormData$2 || FormData)();
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    return !utils.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && isSpecCompliant(formData);
  if (!utils.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value2) {
    if (value2 === null)
      return "";
    if (utils.isDate(value2)) {
      return value2.toISOString();
    }
    if (!useBlob && utils.isBlob(value2)) {
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    }
    if (utils.isArrayBuffer(value2) || utils.isTypedArray(value2)) {
      return useBlob && typeof Blob === "function" ? new Blob([value2]) : Buffer.from(value2);
    }
    return value2;
  }
  function defaultVisitor(value2, key, path) {
    let arr = value2;
    if (value2 && !path && typeof value2 === "object") {
      if (utils.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value2 = JSON.stringify(value2);
      } else if (utils.isArray(value2) && isFlatArray(value2) || (utils.isFileList(value2) || utils.endsWith(key, "[]") && (arr = utils.toArray(value2)))) {
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        });
        return false;
      }
    }
    if (isVisitable(value2)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value2));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value2, path) {
    if (utils.isUndefined(value2))
      return;
    if (stack.indexOf(value2) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack.push(value2);
    utils.forEach(value2, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData,
        el,
        utils.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$3(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match2) {
    return charMap[match2];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData$1(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value2) {
  this._pairs.push([name, value2]);
};
prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value2) {
    return encoder.call(this, value2, encode$3);
  } : encode$3;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode$2(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url2, params, options) {
  if (!params) {
    return url2;
  }
  const _encode = options && options.encode || encode$2;
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url2.indexOf("#");
    if (hashmarkIndex !== -1) {
      url2 = url2.slice(0, hashmarkIndex);
    }
    url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url2;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h2) {
      if (h2 !== null) {
        fn(h2);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = FormData;
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
})();
const platform = {
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob
  },
  isStandardBrowserEnv,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function toURLEncodedForm(data, options) {
  return toFormData$1(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value2, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value2)) {
        this.append(key, value2.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name) {
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map((match2) => {
    return match2[0] === "[]" ? "" : match2[1] || match2[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i2;
  const len = keys.length;
  let key;
  for (i2 = 0; i2 < len; i2++) {
    key = keys[i2];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value2, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value2];
      } else {
        target[name] = value2;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }
    const result = buildPath(path, value2, target[name], index);
    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};
    utils.forEachEntry(formData, (name, value2) => {
      buildPath(parsePropPath(name), value2, obj, 0);
    });
    return obj;
  }
  return null;
}
function settle(resolve, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$1(
      "Request failed with status code " + response.status,
      [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
const cookies = platform.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  /* @__PURE__ */ function standardBrowserEnv() {
    return {
      write: function write(name, value2, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + "=" + encodeURIComponent(value2));
        if (utils.isNumber(expires)) {
          cookie.push("expires=" + new Date(expires).toGMTString());
        }
        if (utils.isString(path)) {
          cookie.push("path=" + path);
        }
        if (utils.isString(domain)) {
          cookie.push("domain=" + domain);
        }
        if (secure === true) {
          cookie.push("secure");
        }
        document.cookie = cookie.join("; ");
      },
      read: function read(name) {
        const match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match2 ? decodeURIComponent(match2[3]) : null;
      },
      remove: function remove(name) {
        this.write(name, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  /* @__PURE__ */ function nonStandardBrowserEnv() {
    return {
      write: function write() {
      },
      read: function read() {
        return null;
      },
      remove: function remove() {
      }
    };
  }()
);
function isAbsoluteURL(url2) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url2);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const isURLSameOrigin = platform.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function standardBrowserEnv2() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    function resolveURL(url2) {
      let href = url2;
      if (msie) {
        urlParsingNode.setAttribute("href", href);
        href = urlParsingNode.href;
      }
      urlParsingNode.setAttribute("href", href);
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
      };
    }
    originURL = resolveURL(window.location.href);
    return function isURLSameOrigin2(requestURL) {
      const parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function nonStandardBrowserEnv2() {
    return function isURLSameOrigin2() {
      return true;
    };
  }()
);
function CanceledError$1(message, config, request) {
  AxiosError$1.call(this, message == null ? "canceled" : message, AxiosError$1.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: true
});
function parseProtocol(url2) {
  const match2 = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url2);
  return match2 && match2[1] || "";
}
const ignoreDuplicateOf = utils.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i2;
  rawHeaders && rawHeaders.split("\n").forEach(function parser2(line) {
    i2 = line.indexOf(":");
    key = line.substring(0, i2).trim().toLowerCase();
    val = line.substring(i2 + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
const $defaults = Symbol("defaults");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value2) {
  if (value2 === false || value2 == null) {
    return value2;
  }
  return utils.isArray(value2) ? value2.map(normalizeValue) : String(value2);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match2;
  while (match2 = tokensRE.exec(str)) {
    tokens[match2[1]] = match2[2];
  }
  return tokens;
}
function matchHeaderValue(context, value2, header, filter2) {
  if (utils.isFunction(filter2)) {
    return filter2.call(this, value2, header);
  }
  if (!utils.isString(value2))
    return;
  if (utils.isString(filter2)) {
    return value2.indexOf(filter2) !== -1;
  }
  if (utils.isRegExp(filter2)) {
    return filter2.test(value2);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
function findKey$1(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i2 = keys.length;
  let _key;
  while (i2-- > 0) {
    _key = keys[i2];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
function AxiosHeaders(headers, defaults2) {
  headers && this.set(headers);
  this[$defaults] = defaults2 || null;
}
Object.assign(AxiosHeaders.prototype, {
  set: function(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = findKey$1(self2, lHeader);
      if (key && _rewrite !== true && (self2[key] === false || _rewrite === false)) {
        return;
      }
      self2[key || _header] = normalizeValue(_value);
    }
    if (utils.isPlainObject(header)) {
      utils.forEach(header, (_value, _header) => {
        setHeader(_value, _header, valueOrRewrite);
      });
    } else {
      setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  },
  get: function(header, parser2) {
    header = normalizeHeader(header);
    if (!header)
      return void 0;
    const key = findKey$1(this, header);
    if (key) {
      const value2 = this[key];
      if (!parser2) {
        return value2;
      }
      if (parser2 === true) {
        return parseTokens(value2);
      }
      if (utils.isFunction(parser2)) {
        return parser2.call(this, value2, key);
      }
      if (utils.isRegExp(parser2)) {
        return parser2.exec(value2);
      }
      throw new TypeError("parser must be boolean|regexp|function");
    }
  },
  has: function(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = findKey$1(this, header);
      return !!(key && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  },
  delete: function(header, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = findKey$1(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  },
  clear: function() {
    return Object.keys(this).forEach(this.delete.bind(this));
  },
  normalize: function(format2) {
    const self2 = this;
    const headers = {};
    utils.forEach(this, (value2, header) => {
      const key = findKey$1(headers, header);
      if (key) {
        self2[key] = normalizeValue(value2);
        delete self2[header];
        return;
      }
      const normalized = format2 ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value2);
      headers[normalized] = true;
    });
    return this;
  },
  toJSON: function(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils.forEach(
      Object.assign({}, this[$defaults] || null, this),
      (value2, header) => {
        if (value2 == null || value2 === false)
          return;
        obj[header] = asStrings && utils.isArray(value2) ? value2.join(", ") : value2;
      }
    );
    return obj;
  }
});
Object.assign(AxiosHeaders, {
  from: function(thing) {
    if (utils.isString(thing)) {
      return new this(parseHeaders(thing));
    }
    return thing instanceof this ? thing : new this(thing);
  },
  accessor: function(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
});
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent"]);
utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== void 0 ? min : 1e3;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i2 = tail;
    let bytesCount = 0;
    while (i2 !== head) {
      bytesCount += bytes[i2++];
      i2 = i2 % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return (e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0
    };
    data[isDownloadStream ? "download" : "upload"] = true;
    listener(data);
  };
}
function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils.isFormData(requestData) && platform.isStandardBrowserEnv) {
      requestHeaders.setContentType(false);
    }
    let request = new XMLHttpRequest();
    if (config.auth) {
      const username = config.auth.username || "";
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
    }
    const fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
    request.timeout = config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value2) {
        resolve(value2);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError$1(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        config,
        request
      ));
      request = null;
    };
    if (platform.isStandardBrowserEnv) {
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
    }
    if (typeof config.onUploadProgress === "function" && request.upload) {
      request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
    }
    if (config.cancelToken || config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError$1(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol2 = parseProtocol(fullPath);
    if (protocol2 && platform.protocols.indexOf(protocol2) === -1) {
      reject(new AxiosError$1("Unsupported protocol " + protocol2 + ":", AxiosError$1.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
}
const adapters = {
  http: xhrAdapter,
  xhr: xhrAdapter
};
const adapters$1 = {
  getAdapter: (nameOrAdapter) => {
    if (utils.isString(nameOrAdapter)) {
      const adapter = adapters[nameOrAdapter];
      if (!nameOrAdapter) {
        throw Error(
          utils.hasOwnProp(nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Can not resolve adapter '${nameOrAdapter}'`
        );
      }
      return adapter;
    }
    if (!utils.isFunction(nameOrAdapter)) {
      throw new TypeError("adapter is not a function");
    }
    return nameOrAdapter;
  },
  adapters
};
const DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function getDefaultAdapter() {
  let adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = adapters$1.getAdapter("xhr");
  } else if (typeof process !== "undefined" && utils.kindOf(process) === "process") {
    adapter = adapters$1.getAdapter("http");
  }
  return adapter;
}
function stringifySafely(rawValue, parser2, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser2 || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils.isObject(data);
    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils.isFormData(data);
    if (isFormData2) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData$1(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (data && utils.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders.from(context.headers);
  let data = context.data;
  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data;
}
function isCancel$1(value2) {
  return !!(value2 && value2.__CANCEL__);
}
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1();
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders.from(config.headers);
  config.data = transformData.call(
    config,
    config.transformRequest
  );
  const adapter = config.adapter || defaults.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );
    response.headers = AxiosHeaders.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$1(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  const mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "beforeRedirect": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    const merge2 = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge2(prop);
    utils.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
const VERSION$1 = "1.1.3";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i2) => {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value2, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError$1(
        formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value2, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i2 = keys.length;
  while (i2-- > 0) {
    const opt = keys[i2];
    const validator2 = schema[opt];
    if (validator2) {
      const value2 = options[opt];
      const result = value2 === void 0 || validator2(value2, opt, options);
      if (result !== true) {
        throw new AxiosError$1("option " + opt + " must be " + result, AxiosError$1.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError$1("Unknown option " + opt, AxiosError$1.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
let Axios$1 = class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const { transitional: transitional2, paramsSerializer } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer !== void 0) {
      validator.assertOptions(paramsSerializer, {
        encode: validators.function,
        serialize: validators.function
      }, true);
    }
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    const defaultHeaders = config.headers && utils.merge(
      config.headers.common,
      config.headers[config.method]
    );
    defaultHeaders && utils.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      function cleanHeaderConfig(method) {
        delete config.headers[method];
      }
    );
    config.headers = new AxiosHeaders(config.headers, defaultHeaders);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i2 = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i2 < len) {
        promise = promise.then(chain[i2++], chain[i2++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i2 = 0;
    while (i2 < len) {
      const onFulfilled = requestInterceptorChain[i2++];
      const onRejected = requestInterceptorChain[i2++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i2 = 0;
    len = responseInterceptorChain.length;
    while (i2 < len) {
      promise = promise.then(responseInterceptorChain[i2++], responseInterceptorChain[i2++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
};
utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url2, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url: url2,
      data: (config || {}).data
    }));
  };
});
utils.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url2, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: url2,
        data
      }));
    };
  }
  Axios$1.prototype[method] = generateHTTPMethod();
  Axios$1.prototype[method + "Form"] = generateHTTPMethod(true);
});
let CancelToken$1 = class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;
    this.promise.then((cancel) => {
      if (!token._listeners)
        return;
      let i2 = token._listeners.length;
      while (i2-- > 0) {
        token._listeners[i2](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError$1(message, config, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
};
function spread$1(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError$1(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance2 = bind(Axios$1.prototype.request, context);
  utils.extend(instance2, Axios$1.prototype, context, { allOwnKeys: true });
  utils.extend(instance2, context, null, { allOwnKeys: true });
  instance2.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance2;
}
const axios = createInstance(defaults);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;
axios.AxiosError = AxiosError$1;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread$1;
axios.isAxiosError = isAxiosError$1;
axios.formToJSON = (thing) => {
  return formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
};
const {
  Axios: Axios2,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken: CancelToken2,
  VERSION,
  all: all2,
  Cancel,
  isAxiosError,
  spread,
  toFormData
} = axios;
const ROUTES = {
  articles: {
    path: "articles",
    hasTitlePropagation: true
  },
  images: {
    path: "images",
    hasTitlePropagation: true
  },
  videos: {
    path: "videos",
    hasTitlePropagation: true
  },
  galleries: {
    path: "galleries",
    hasTitlePropagation: true
  },
  staticPages: {
    path: "static-page",
    hasTitlePropagation: true
  },
  articleList: {
    path: "article-list",
    hasTitlePropagation: true
  },
  channels: {
    path: "channels",
    hasTitlePropagation: true
  },
  assembler: {
    path: "assembler",
    hasTitlePropagation: false
  },
  catTool: {
    path: "cat-tool",
    hasTitlePropagation: false
  },
  pushes: {
    path: "article-push",
    hasTitlePropagation: false
  },
  kim: {
    path: "kim",
    hasTitlePropagation: false
  }
};
var isMergeableObject = function isMergeableObject2(value2) {
  return isNonNullObject(value2) && !isSpecial(value2);
};
function isNonNullObject(value2) {
  return !!value2 && typeof value2 === "object";
}
function isSpecial(value2) {
  var stringValue = Object.prototype.toString.call(value2);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value2);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(value2) {
  return value2.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value2, options) {
  return options.clone !== false && options.isMergeableObject(value2) ? deepmerge(emptyTarget(value2), value2, options) : value2;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === "function" ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
}
function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function(key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  getKeys(source).forEach(function(key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error("first argument should be an array");
  }
  return array.reduce(function(prev2, next) {
    return deepmerge(prev2, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
const merge = /* @__PURE__ */ getDefaultExportFromCjs(cjs);
const de = {
  isoName: "de",
  nativeName: "Deutsch",
  label: {
    clear: "Leeren",
    ok: "Ok",
    cancel: "Abbrechen",
    close: "Schließen",
    set: "Setzen",
    select: "Auswählen",
    reset: "Zurücksetzen",
    remove: "Löschen",
    update: "Aktualisieren",
    create: "Erstellen",
    search: "Suche",
    filter: "Filter",
    refresh: "Aktualisieren",
    expand: (label) => label ? `Erweitern Sie "${label}"` : "Erweitern",
    collapse: (label) => label ? `"${label}" minimieren` : "Zusammenbruch"
  },
  date: {
    days: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
    daysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
    months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
    monthsShort: "Jan_Feb_März_Apr_Mai_Jun_Jul_Aug_Sep_Okt_Nov_Dez".split("_"),
    firstDayOfWeek: 1,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: true,
    pluralDay: "Tage",
    prevMonth: "Vorheriger Monat",
    nextMonth: "Nächster Monat",
    prevYear: "Vorheriges Jahr",
    nextYear: "Nächstes Jahr",
    today: "Heute",
    prevRangeYears: (range) => `Vorherige ${range} Jahre`,
    nextRangeYears: (range) => `Nächste ${range} Jahre`
  },
  table: {
    noData: "Keine Daten vorhanden.",
    noResults: "Keine Einträge gefunden",
    loading: "Lade...",
    selectedRecords: (rows) => rows > 1 ? rows + " ausgewählte Zeilen" : (rows === 0 ? "Keine" : "1") + " ausgewählt.",
    recordsPerPage: "Zeilen pro Seite",
    allRows: "Alle",
    pagination: (start, end, total) => start + "-" + end + " von " + total,
    columns: "Spalten"
  },
  pagination: {
    first: "Erste Seite",
    prev: "Vorherige Seite",
    next: "Nächste Seite",
    last: "Letzte Seite"
  },
  editor: {
    url: "URL",
    bold: "Fett",
    italic: "Kursiv",
    strikethrough: "Durchgestrichen",
    underline: "Unterstrichen",
    unorderedList: "Ungeordnete Liste",
    orderedList: "Geordnete Liste",
    subscript: "tiefgestellt",
    superscript: "hochgestellt",
    hyperlink: "Link",
    toggleFullscreen: "Vollbild umschalten",
    quote: "Zitat",
    left: "linksbündig",
    center: "zentriert",
    right: "rechtsbündig",
    justify: "Ausrichten",
    print: "Drucken",
    outdent: "ausrücken",
    indent: "einrücken",
    removeFormat: "Entferne Formatierung",
    formatting: "Formatiere",
    fontSize: "Schriftgröße",
    align: "Ausrichten",
    hr: "Horizontale Linie einfügen",
    undo: "Rückgänging",
    redo: "Wiederherstellen",
    heading1: "Überschrift 1",
    heading2: "Überschrift 2",
    heading3: "Überschrift 3",
    heading4: "Überschrift 4",
    heading5: "Überschrift 5",
    heading6: "Überschrift 6",
    paragraph: "Absatz",
    code: "Code",
    size1: "Sehr klein",
    size2: "klein",
    size3: "Normal",
    size4: "Groß",
    size5: "Größer",
    size6: "Sehr groß",
    size7: "Maximum",
    defaultFont: "Standard Schrift",
    viewSource: "Quelltext anzeigen"
  },
  tree: {
    noNodes: "Keine Knoten verfügbar",
    noResults: "Keine passenden Knoten gefunden"
  }
};
const en = {
  isoName: "en-GB",
  nativeName: "English (UK)",
  label: {
    clear: "Clear",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    set: "Set",
    select: "Select",
    reset: "Reset",
    remove: "Remove",
    update: "Update",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    expand: (label) => label ? `Expand "${label}"` : "Expand",
    collapse: (label) => label ? `Collapse "${label}"` : "Collapse"
  },
  date: {
    days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    firstDayOfWeek: 1,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: true,
    pluralDay: "days",
    prevMonth: "Previous month",
    nextMonth: "Next month",
    prevYear: "Previous year",
    nextYear: "Next year",
    today: "Today",
    prevRangeYears: (range) => `Previous ${range} years`,
    nextRangeYears: (range) => `Next ${range} years`
  },
  table: {
    noData: "No data available",
    noResults: "No matching records found",
    loading: "Loading...",
    selectedRecords: (rows) => rows === 1 ? "1 record selected." : (rows === 0 ? "No" : rows) + " records selected.",
    recordsPerPage: "Records per page:",
    allRows: "All",
    pagination: (start, end, total) => start + "-" + end + " of " + total,
    columns: "Columns"
  },
  pagination: {
    first: "First page",
    prev: "Previous page",
    next: "Next page",
    last: "Last page"
  },
  editor: {
    url: "URL",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    unorderedList: "Unordered List",
    orderedList: "Ordered List",
    subscript: "Subscript",
    superscript: "Superscript",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Toggle Fullscreen",
    quote: "Quote",
    left: "Left align",
    center: "Center align",
    right: "Right align",
    justify: "Justify align",
    print: "Print",
    outdent: "Decrease indentation",
    indent: "Increase indentation",
    removeFormat: "Remove formatting",
    formatting: "Formatting",
    fontSize: "Font Size",
    align: "Align",
    hr: "Insert Horizontal Rule",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    heading4: "Heading 4",
    heading5: "Heading 5",
    heading6: "Heading 6",
    paragraph: "Paragraph",
    code: "Code",
    size1: "Very small",
    size2: "A bit small",
    size3: "Normal",
    size4: "Medium-large",
    size5: "Big",
    size6: "Very big",
    size7: "Maximum",
    defaultFont: "Default Font",
    viewSource: "View Source"
  },
  tree: {
    noNodes: "No nodes available",
    noResults: "No matching nodes found"
  }
};
const it = {
  isoName: "it",
  nativeName: "Italiano",
  label: {
    clear: "Pulisci",
    ok: "OK",
    cancel: "Annulla",
    close: "Chiudi",
    set: "Imposta",
    select: "Seleziona",
    reset: "Ripristina",
    remove: "Rimuovi",
    update: "Aggiorna",
    create: "Crea",
    search: "Cerca",
    filter: "Filtra",
    refresh: "Aggiorna",
    expand: (label) => label ? `Espandi "${label}"` : "Espandere",
    collapse: (label) => label ? `Comprimi "${label}"` : "Crollo"
  },
  date: {
    days: "Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato".split("_"),
    daysShort: "Dom_Lun_Mar_Mer_Gio_Ven_Sab".split("_"),
    months: "Gennaio_Febbraio_Marzo_Aprile_Maggio_Giugno_Luglio_Agosto_Settembre_Ottobre_Novembre_Dicembre".split("_"),
    monthsShort: "Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic".split("_"),
    firstDayOfWeek: 1,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: true,
    pluralDay: "giorni",
    prevMonth: "Mese precedente",
    nextMonth: "Mese successivo",
    prevYear: "Anno precedente",
    nextYear: "Anno successivo",
    today: "Oggi",
    prevRangeYears: (range) => `${range} anni precedenti`,
    nextRangeYears: (range) => `${range} anni successivi`
  },
  table: {
    noData: "Nessun dato disponibile",
    noResults: "Nessuna corrispondenza trovata",
    loading: "Caricamento...",
    selectedRecords: (rows) => rows > 0 ? rows + " " + (rows === 1 ? "riga selezionata" : "righe selezionate") + "." : "Nessuna riga selezionata.",
    recordsPerPage: "Righe per pagina:",
    allRows: "Tutte",
    pagination: (start, end, total) => start + "-" + end + " di " + total,
    columns: "Colonne"
  },
  pagination: {
    first: "Prima pagina",
    prev: "Pagina precedente",
    next: "Prossima pagina",
    last: "Ultima pagina"
  },
  editor: {
    url: "URL",
    bold: "Grassetto",
    italic: "Corsivo",
    strikethrough: "Barrato",
    underline: "Sottolineato",
    unorderedList: "Lista non ordinata",
    orderedList: "Lista ordinata",
    subscript: "Pedice",
    superscript: "Apice",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Fullscreen on/off",
    quote: "Citazione",
    left: "A sinistra",
    center: "Centra",
    right: "A destra",
    justify: "Giustificato",
    print: "Stampa",
    outdent: "Diminuisci identazione",
    indent: "Aumenta identazione",
    removeFormat: "Rimuovi formattazione",
    formatting: "Formattazione",
    fontSize: "Dimensione del font",
    align: "Allinea",
    hr: "Inserisci righello orizzontale",
    undo: "Indietro",
    redo: "Avanti",
    heading1: "Intestazione 1",
    heading2: "Intestazione 2",
    heading3: "Intestazione 3",
    heading4: "Intestazione 4",
    heading5: "Intestazione 5",
    heading6: "Intestazione 6",
    paragraph: "Paragrafo",
    code: "Codice",
    size1: "Molto piccolo",
    size2: "Piccolo",
    size3: "Normale",
    size4: "Medio-largo",
    size5: "Grande",
    size6: "Molto grande",
    size7: "Massimo",
    defaultFont: "Font predefinito",
    viewSource: "Vedi la fonte"
  },
  tree: {
    noData: "Nessun nodo disponibile",
    noResults: "Nessuna corrispondenza trovata"
  }
};
const browserLang = () => {
  const lang = navigator.language;
  if (/^en\b/.test(lang)) {
    return "en";
  } else {
    return "de";
  }
};
const shouldBeOpenByDefault = window.innerWidth > 960;
const localStorageKey = "cms_language";
const DEFAULT_HEADER_NAV_HEIGHT = 50;
const DEFAULT_SIDEBAR_NAV_WIDTH = 257;
const DEFAULT_SHRUNK_SIDEBAR_NAV_WIDTH = 56;
const store$6 = reactive({
  headerNavigationHeight: DEFAULT_HEADER_NAV_HEIGHT,
  sidebarNavigationWidth: DEFAULT_SIDEBAR_NAV_WIDTH,
  sidebarNavigationOpen: JSON.parse(localStorage.getItem("sidebarNavigationOpen") || JSON.stringify(shouldBeOpenByDefault)),
  language: localStorage.getItem(localStorageKey) || browserLang(),
  internalLinks: [],
  toggleSidebarNavigation() {
    this.sidebarNavigationOpen = !this.sidebarNavigationOpen;
  },
  setLanguage(lang) {
    this.language = lang;
    localStorage.setItem(localStorageKey, lang);
  }
});
watch(
  () => store$6.sidebarNavigationOpen,
  (value2) => {
    var _a;
    localStorage.setItem("sidebarNavigationOpen", JSON.stringify(value2));
    store$6.headerNavigationHeight = ((_a = document.querySelector("#mainNavigationHeader")) == null ? void 0 : _a.clientHeight) || DEFAULT_HEADER_NAV_HEIGHT;
    store$6.sidebarNavigationWidth = store$6.sidebarNavigationOpen ? DEFAULT_SIDEBAR_NAV_WIDTH : DEFAULT_SHRUNK_SIDEBAR_NAV_WIDTH;
  },
  { immediate: true }
);
const useGlobalStore = () => store$6;
const bDe = {
  messages: {
    copyErrorToClipboard: "Details in die Zwischenablage kopieren",
    copiedToClipboard: "In die Zwischenablage kopiert"
  },
  changesWatch: {
    dialog: {
      title: "Du hast deine Änderungen nicht gespeichert",
      text: "Möchtest du die Änderungen verwerfen und die Seite verlassen?",
      inspect: "Inspizieren",
      downloadInitial: "Anfangswert herunterladen",
      downloadCurrent: "Aktuellen Wert herunterladen",
      stay: "Nein, bleiben",
      leave: "Ja, verwerfen"
    }
  },
  common: {
    error: "Unbekannter Fehler",
    close: "Schließen",
    scheduleBannerText: "Geplante Aktualisierungen dieses Artikels sind vorgesehen für",
    doneBy: "durchgeführt von",
    removeChange: "Änderung entfernen",
    editChange: "Änderung bearbeiten",
    yes: "ja",
    no: "nein",
    all: "Alle"
  },
  scheduledChanges: {
    remove: {
      changesTitle: "Geplante Änderung entfernen",
      changesText: "Möchten Sie geplante Änderungen entfernen?"
    },
    edit: {
      changesTitle: "Geplante Änderung",
      changesText: {
        articleScheduledOn: "Dieser Artikel hat geplante Ändergunen, vorgesehen für",
        warningScheduledChangesPresent: "Alle Änderungen, die Sie jetzt vornehmen, überschrieben die derzeit geplanten Änderungen.",
        questionScheduledChangesWillBeOverwritten: "Möchten Sie die geplanten Änderungen wirklich bearbeiten?",
        editingBannerInfo: " Sie bearbeiten derzeit eine geplante Änderung für den Artikel am"
      }
    }
  },
  entityState: {
    status: "Status",
    dpAll: "Alle",
    dpDraft: "Entwurf",
    dpSchedule: "Geplant",
    dpPublished: "Veröffentlicht",
    dpExpired: "Depubliziert",
    dpRescheduled: "Änderungen geplant"
  },
  login: {
    newUserNotification: "Willkommen beim Vibe-Editor. Sie haben nur das Benutzerrecht für die Ansicht. Schauen Sie sich um, ohne Angst zu haben, etwas zu zerbrechen."
  },
  pathSelector: {
    pathAutogenerate: "Pfad automatisch generieren",
    pathAutoselect: "Wird automatisch ausgefüllt",
    pathCopiedToClipboard: "Pfad in Zwischenablage kopiert.",
    pathInvalid: "Ungültiger Pfad",
    pathInputLabel: "Pfad"
  },
  cmsSelector: {
    label: "Verwaltet von ⓘ",
    hint: "CMS verantwortlich für die Artikelverwaltung",
    dpAll: "Alle"
  },
  legacySelector: {
    hint: "CMS verantwortlich für die Artikelverwaltung",
    dpAll: "Alle",
    yes: "Ja",
    no: "Nein"
  },
  noEditTooltip: {
    label: "Dieser {{record}} stammt ursprünglich aus dem {{source}}-Editor"
  },
  dateTimeSelector: {
    nowLabel: "auf jetzt eingestellt"
  },
  [ROUTES.articles.path]: {
    routeTitle: "Artikel",
    routeTitleDetail: "A: "
  },
  [ROUTES.images.path]: {
    routeTitle: "Bilder",
    routeTitleDetail: "B: "
  },
  [ROUTES.videos.path]: {
    routeTitle: "Videos",
    routeTitleDetail: "V: "
  },
  [ROUTES.galleries.path]: {
    routeTitle: "Galerien",
    routeTitleDetail: "G: "
  },
  [ROUTES.channels.path]: {
    routeTitle: "Kanäle",
    routeTitleDetail: "K: "
  },
  [ROUTES.staticPages.path]: {
    routeTitle: "Statische Seiten",
    routeTitleDetail: "S: "
  },
  [ROUTES.articleList.path]: {
    routeTitle: "Listen",
    routeTitleDetail: "L: "
  },
  [ROUTES.assembler.path]: {
    routeTitle: "Partner Content",
    routeTitleDetail: "P: "
  },
  [ROUTES.catTool.path]: {
    routeTitle: "Cat-Tool",
    routeTitleDetail: "C: "
  },
  [ROUTES.pushes.path]: {
    routeTitle: "Pushes",
    routeTitleDetail: "P: "
  },
  [ROUTES.kim.path]: {
    routeTitle: "Kim",
    routeTitleDetail: "K: "
  }
};
const bEn = {
  messages: {
    copyErrorToClipboard: "Copy details to clipboard",
    copiedToClipboard: "Copied to clipboard"
  },
  changesWatch: {
    dialog: {
      title: "You have unsaved changes",
      text: "Do you want to discard all changes and leave the page?",
      inspect: "Inspect",
      downloadInitial: "Download initial value",
      downloadCurrent: "Download current value",
      stay: "No, stay",
      leave: "Yes, discard"
    }
  },
  common: {
    error: "Unknown Error",
    close: "Close",
    scheduleBannerText: "Scheduled updates to this article are set for",
    doneBy: " done by",
    removeChange: "Remove change",
    editChange: "Edit Change",
    yes: "yes",
    no: "no",
    all: "All"
  },
  scheduledChanges: {
    remove: {
      changesTitle: "Remove scheduled change",
      changesText: "Do you want to remove scheduled changes?"
    },
    edit: {
      changesTitle: "Scheduled change",
      changesText: {
        articleScheduledOn: "This article has changes scheduled on",
        warningScheduledChangesPresent: "Any changes you do now will overwrite the changes scheduled for that time.",
        questionScheduledChangesWillBeOverwritten: "Do you really want to edit the scheduled changes?",
        editingBannerInfo: "You are currently editing an article change scheduled for "
      }
    }
  },
  entityState: {
    status: "State",
    dpAll: "All",
    dpDraft: "Draft",
    dpSchedule: "Scheduled",
    dpPublished: "Published",
    dpExpired: "Expired",
    dpRescheduled: "Rescheduled"
  },
  login: {
    newUserNotification: "Welcome to the Vibe editor. You have user right for the view only. Look around without fear of breaking anything."
  },
  pathSelector: {
    pathAutogenerate: "Automatically generate path",
    pathAutoselect: "Will be filled automatically",
    pathCopiedToClipboard: "Path copied to clipboard",
    pathInvalid: "Invalid path",
    pathInputLabel: "Path"
  },
  cmsSelector: {
    label: "Managed by ⓘ",
    hint: "CMS responsible for article management",
    dpAll: "All"
  },
  legacySelector: {
    hint: "CMS responsible for article management",
    dpAll: "All",
    yes: "Yes",
    no: "No"
  },
  noEditTooltip: {
    label: "This {{record}} is originally from the {{source}} editor"
  },
  dateTimeSelector: {
    nowLabel: "set to now"
  },
  [ROUTES.articles.path]: {
    routeTitle: "Articles",
    routeTitleDetail: "A: "
  },
  [ROUTES.images.path]: {
    routeTitle: "Images",
    routeTitleDetail: "I: "
  },
  [ROUTES.videos.path]: {
    routeTitle: "Videos",
    routeTitleDetail: "V: "
  },
  [ROUTES.galleries.path]: {
    routeTitle: "Galleries",
    routeTitleDetail: "G: "
  },
  [ROUTES.channels.path]: {
    routeTitle: "Channels",
    routeTitleDetail: "C: "
  },
  [ROUTES.staticPages.path]: {
    routeTitle: "Static Pages",
    routeTitleDetail: "S: "
  },
  [ROUTES.articleList.path]: {
    routeTitle: "Lists",
    routeTitleDetail: "L: "
  },
  [ROUTES.assembler.path]: {
    routeTitle: "Partner Content",
    routeTitleDetail: "P: "
  },
  [ROUTES.catTool.path]: {
    routeTitle: "Cat-tool",
    routeTitleDetail: "C: "
  },
  [ROUTES.pushes.path]: {
    routeTitle: "Pushes",
    routeTitleDetail: "P: "
  },
  [ROUTES.kim.path]: {
    routeTitle: "Kim",
    routeTitleDetail: "K: "
  }
};
let instance;
const quasarLocales = {
  en,
  de,
  it
};
const globalStore$1 = useGlobalStore();
const getQuasarLocale = () => quasarLocales[globalStore$1.language];
const createVueI18n = (messages) => {
  const locale2 = globalStore$1.language;
  instance = createI18n({
    locale: locale2,
    legacy: false,
    fallbackLocale: defaultLocale,
    messages: merge({ de: bDe, en: bEn }, merge(languages, messages))
  });
  return instance;
};
const getI18n = () => {
  if (!instance) {
    throw new Error("I18n is not initialized yet!");
  }
  return instance.global;
};
watch(globalStore$1, (value2) => {
  if (instance.mode === "legacy") {
    instance.global.locale = value2.language;
  } else {
    instance.global.locale.value = value2.language;
  }
});
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let i2 = 0; i2 < 256; ++i2) {
  byteToHex.push((i2 + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4(options, buf, offset) {
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const _CMSNotification = class _CMSNotification {
  constructor(message = getI18n().t("common.error"), severity = "negative", options) {
    __publicField(this, "message");
    __publicField(this, "timestamp");
    __publicField(this, "severity");
    __publicField(this, "dismissible");
    __publicField(this, "callbackFunc");
    __publicField(this, "callbackLabel");
    __publicField(this, "callbackNoDismiss");
    __publicField(this, "multiLine");
    __publicField(this, "timeout");
    __publicField(this, "progress");
    __publicField(this, "position");
    __publicField(this, "html");
    __publicField(this, "color");
    __publicField(this, "badgeStyle");
    __publicField(this, "id");
    const defaults2 = {
      dismissible: true,
      callbackFunc: void 0,
      callbackLabel: "Action",
      // TODO: this should either have no default or at least use translation
      callbackNoDismiss: false,
      timeout: _CMSNotification.DEFAULT_TIMEOUT,
      progress: true,
      position: "top",
      multiLine: false,
      html: false,
      badgeStyle: void 0,
      color: severity,
      id: v4()
    };
    const resolvedOptions = { ...defaults2, ...options };
    this.message = message;
    this.timestamp = Date.now();
    this.severity = severity;
    this.dismissible = resolvedOptions.dismissible;
    this.callbackFunc = resolvedOptions.callbackFunc;
    this.callbackLabel = resolvedOptions.callbackLabel;
    this.callbackNoDismiss = resolvedOptions.callbackNoDismiss;
    this.timeout = _CMSNotification._resolveTimeoutSettings(resolvedOptions.timeout);
    this.progress = resolvedOptions.progress;
    this.position = resolvedOptions.position;
    this.multiLine = resolvedOptions.multiLine;
    this.html = resolvedOptions.html;
    this.color = resolvedOptions.color;
    this.badgeStyle = resolvedOptions.badgeStyle;
    this.id = resolvedOptions.id || v4();
  }
  static _resolveTimeoutSettings(timeout) {
    if (timeout === null)
      return _CMSNotification.NO_TIMEOUT;
    if (timeout === void 0)
      return _CMSNotification.DEFAULT_TIMEOUT;
    return timeout;
  }
};
__publicField(_CMSNotification, "DEFAULT_TIMEOUT", 1e4);
__publicField(_CMSNotification, "NO_TIMEOUT", 0);
let CMSNotification = _CMSNotification;
const store$5 = reactive({
  notifications: /* @__PURE__ */ new Map(),
  latestNotification: null,
  notify: void 0,
  clearAndShowNotification(notification) {
    this.clearNotification();
    this.showNotification(notification);
  },
  /**
   * Displays a notification based on the provided configuration.
   *
   * @param {CMSNotification} notification - An object containing configuration for the notification such as message, timeout, severity, actions, and styles.
   * @return {QNotify} The created notification instance.
   */
  showNotification(notification) {
    const callback = {
      label: notification.callbackLabel,
      handler: notification.callbackFunc,
      noDismiss: notification.callbackNoDismiss
    };
    const actions = notification.callbackFunc ? [callback] : [];
    const options = {
      message: notification.message,
      timeout: (notification == null ? void 0 : notification.timeout) ?? CMSNotification.DEFAULT_TIMEOUT,
      type: notification == null ? void 0 : notification.severity,
      classes: notification == null ? void 0 : notification.severity,
      closeBtn: notification.dismissible,
      progress: notification == null ? void 0 : notification.progress,
      position: notification == null ? void 0 : notification.position,
      multiLine: notification.multiLine,
      html: notification.html,
      badgeStyle: notification.badgeStyle,
      color: notification == null ? void 0 : notification.color,
      actions
    };
    const qnot = Notify.create(options);
    if (!this.notifications.has(notification.id)) {
      this.notifications.set(notification.id, []);
    }
    this.notifications.get(notification.id).push(qnot);
    this.latestNotification = notification;
    return qnot;
  },
  /**
   * Clears all stored notifications and resets the latest notification.
   *
   * Iterates through the stored notifications, executing each notification's
   * clear function. Afterwards, it clears the notifications map and sets
   * the latest notification to null.
   *
   * @return {void} This method does not return a value.
   */
  clearNotification() {
    for (const [id, notifications] of this.notifications) {
      notifications.forEach((clearNotification) => clearNotification());
    }
    this.notifications.clear();
    this.latestNotification = null;
  },
  isNotificationVisible(id) {
    return this.notifications.has(id);
  },
  /**
   * Hides and clears all notifications associated with the given notification ID.
   *
   * @param {string} id - The unique identifier for the notification to hide.
   * @return {void} - Does not return any value.
   */
  hideNotification(id) {
    const notifications = this.notifications.get(id);
    if (!notifications) {
      console.error(`Attempted to hide notification with id ${id} that does not exist in notification store`);
      return;
    }
    notifications.forEach((clearNotification) => clearNotification());
    this.notifications.delete(id);
  }
});
store$5.clearNotification = store$5.clearNotification.bind(store$5);
store$5.showNotification = store$5.showNotification.bind(store$5);
store$5.clearAndShowNotification = store$5.clearAndShowNotification.bind(store$5);
store$5.hideNotification = store$5.hideNotification.bind(store$5);
store$5.isNotificationVisible = store$5.isNotificationVisible.bind(store$5);
const useNotificationStore = () => store$5;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
function isDate(value2) {
  requiredArgs(1, arguments);
  return value2 instanceof Date || typeof value2 === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
function buildLocalizeFn(args) {
  return function(dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value2;
    value2 = args.valueCallback ? args.valueCallback(key) : key;
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var locale = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}
var formatters$1 = {
  // Year
  y: function(date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M: function(date, token) {
    var month = date.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeWeekStartsOn = locale2 && locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
var dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  // Era
  G: function(date, token, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(date, token, localize2) {
    if (token === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$1.y(date, token);
  },
  // Local week-numbering year
  Y: function(date, token, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function(date, token, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token, localize2) {
    var month = date.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return formatters$1.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(date, token, localize2) {
    var month = date.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(date, token, localize2, options) {
    var week = getUTCWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function(date, token, localize2) {
    var isoWeek = getUTCISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$1.d(date, token);
  },
  // Day of year
  D: function(date, token, localize2) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function(date, token, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token, localize2) {
    if (token === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$1.h(date, token);
  },
  // Hour [0-23]
  H: function(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$1.H(date, token);
  },
  // Hour [0-11]
  K: function(date, token, localize2) {
    var hours = date.getUTCHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function(date, token, localize2) {
    var hours = date.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$1.m(date, token);
  },
  // Second
  s: function(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$1.s(date, token);
  },
  // Fraction of second
  S: function(date, token) {
    return formatters$1.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter;
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
function dateLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
}
function timeLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
}
function dateTimeLongFormatter(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale$1.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale$1.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters[firstCharacter];
    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}
function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  dirtyObject = dirtyObject || {};
  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }
  return target;
}
function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale2 = options.locale;
  var localeWeekStartsOn = locale2 && locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var MILLISECONDS_IN_HOUR = 36e5;
var MILLISECONDS_IN_MINUTE = 6e4;
var MILLISECONDS_IN_SECOND = 1e3;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);
  if (!matchResult) {
    return null;
  }
  var value2 = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value2) : value2,
    rest: string.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }
  var sign = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}
function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), string, valueCallback);
  }
}
function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), string, valueCallback);
  }
}
function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "G":
        case "GG":
        case "GGG":
          return match2.era(string, {
            width: "abbreviated"
          }) || match2.era(string, {
            width: "narrow"
          });
        case "GGGGG":
          return match2.era(string, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return match2.era(string, {
            width: "wide"
          }) || match2.era(string, {
            width: "abbreviated"
          }) || match2.era(string, {
            width: "narrow"
          });
      }
    },
    set: function(date, flags, value2, _options) {
      flags.era = value2;
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["R", "u", "t", "T"]
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function(string, token, match2, _options) {
      var valueCallback = function(year) {
        return {
          year,
          isTwoDigitYear: token === "yy"
        };
      };
      switch (token) {
        case "y":
          return parseNDigits(4, string, valueCallback);
        case "yo":
          return match2.ordinalNumber(string, {
            unit: "year",
            valueCallback
          });
        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function(_date, value2, _options) {
      return value2.isTwoDigitYear || value2.year > 0;
    },
    set: function(date, flags, value2, _options) {
      var currentYear = date.getUTCFullYear();
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function(string, token, match2, _options) {
      var valueCallback = function(year) {
        return {
          year,
          isTwoDigitYear: token === "YY"
        };
      };
      switch (token) {
        case "Y":
          return parseNDigits(4, string, valueCallback);
        case "Yo":
          return match2.ordinalNumber(string, {
            unit: "year",
            valueCallback
          });
        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function(_date, value2, _options) {
      return value2.isTwoDigitYear || value2.year > 0;
    },
    set: function(date, flags, value2, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function(string, token, _match, _options) {
      if (token === "R") {
        return parseNDigitsSigned(4, string);
      }
      return parseNDigitsSigned(token.length, string);
    },
    set: function(_date, _flags, value2, _options) {
      var firstWeekOfYear = /* @__PURE__ */ new Date(0);
      firstWeekOfYear.setUTCFullYear(value2, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  // Extended year
  u: {
    priority: 130,
    parse: function(string, token, _match, _options) {
      if (token === "u") {
        return parseNDigitsSigned(4, string);
      }
      return parseNDigitsSigned(token.length, string);
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "Q":
        case "QQ":
          return parseNDigits(token.length, string);
        case "Qo":
          return match2.ordinalNumber(string, {
            unit: "quarter"
          });
        case "QQQ":
          return match2.quarter(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(string, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return match2.quarter(string, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return match2.quarter(string, {
            width: "wide",
            context: "formatting"
          }) || match2.quarter(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(string, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 1 && value2 <= 4;
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "q":
        case "qq":
          return parseNDigits(token.length, string);
        case "qo":
          return match2.ordinalNumber(string, {
            unit: "quarter"
          });
        case "qqq":
          return match2.quarter(string, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(string, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return match2.quarter(string, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return match2.quarter(string, {
            width: "wide",
            context: "standalone"
          }) || match2.quarter(string, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(string, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 1 && value2 <= 4;
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  // Month
  M: {
    priority: 110,
    parse: function(string, token, match2, _options) {
      var valueCallback = function(value2) {
        return value2 - 1;
      };
      switch (token) {
        case "M":
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        case "MM":
          return parseNDigits(2, string, valueCallback);
        case "Mo":
          return match2.ordinalNumber(string, {
            unit: "month",
            valueCallback
          });
        case "MMM":
          return match2.month(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(string, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return match2.month(string, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return match2.month(string, {
            width: "wide",
            context: "formatting"
          }) || match2.month(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(string, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 11;
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function(string, token, match2, _options) {
      var valueCallback = function(value2) {
        return value2 - 1;
      };
      switch (token) {
        case "L":
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        case "LL":
          return parseNDigits(2, string, valueCallback);
        case "Lo":
          return match2.ordinalNumber(string, {
            unit: "month",
            valueCallback
          });
        case "LLL":
          return match2.month(string, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(string, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return match2.month(string, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return match2.month(string, {
            width: "wide",
            context: "standalone"
          }) || match2.month(string, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(string, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 11;
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "w":
          return parseNumericPattern(numericPatterns.week, string);
        case "wo":
          return match2.ordinalNumber(string, {
            unit: "week"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 1 && value2 <= 53;
    },
    set: function(date, _flags, value2, options) {
      return startOfUTCWeek(setUTCWeek(date, value2, options), options);
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "I":
          return parseNumericPattern(numericPatterns.week, string);
        case "Io":
          return match2.ordinalNumber(string, {
            unit: "week"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 1 && value2 <= 53;
    },
    set: function(date, _flags, value2, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value2, options), options);
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "d":
          return parseNumericPattern(numericPatterns.date, string);
        case "do":
          return match2.ordinalNumber(string, {
            unit: "date"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(date, value2, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH[month];
      }
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCDate(value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, string);
        case "Do":
          return match2.ordinalNumber(string, {
            unit: "date"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(date, value2, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value2 >= 1 && value2 <= 366;
      } else {
        return value2 >= 1 && value2 <= 365;
      }
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCMonth(0, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]
  },
  // Day of week
  E: {
    priority: 90,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "E":
        case "EE":
        case "EEE":
          return match2.day(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string, {
            width: "short",
            context: "formatting"
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return match2.day(string, {
            width: "short",
            context: "formatting"
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return match2.day(string, {
            width: "wide",
            context: "formatting"
          }) || match2.day(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string, {
            width: "short",
            context: "formatting"
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 6;
    },
    set: function(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function(string, token, match2, options) {
      var valueCallback = function(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        case "e":
        case "ee":
          return parseNDigits(token.length, string, valueCallback);
        case "eo":
          return match2.ordinalNumber(string, {
            unit: "day",
            valueCallback
          });
        case "eee":
          return match2.day(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string, {
            width: "short",
            context: "formatting"
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return match2.day(string, {
            width: "short",
            context: "formatting"
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return match2.day(string, {
            width: "wide",
            context: "formatting"
          }) || match2.day(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(string, {
            width: "short",
            context: "formatting"
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 6;
    },
    set: function(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function(string, token, match2, options) {
      var valueCallback = function(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        case "c":
        case "cc":
          return parseNDigits(token.length, string, valueCallback);
        case "co":
          return match2.ordinalNumber(string, {
            unit: "day",
            valueCallback
          });
        case "ccc":
          return match2.day(string, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(string, {
            width: "short",
            context: "standalone"
          }) || match2.day(string, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return match2.day(string, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return match2.day(string, {
            width: "short",
            context: "standalone"
          }) || match2.day(string, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return match2.day(string, {
            width: "wide",
            context: "standalone"
          }) || match2.day(string, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(string, {
            width: "short",
            context: "standalone"
          }) || match2.day(string, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 6;
    },
    set: function(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function(string, token, match2, _options) {
      var valueCallback = function(value2) {
        if (value2 === 0) {
          return 7;
        }
        return value2;
      };
      switch (token) {
        case "i":
        case "ii":
          return parseNDigits(token.length, string);
        case "io":
          return match2.ordinalNumber(string, {
            unit: "day"
          });
        case "iii":
          return match2.day(string, {
            width: "abbreviated",
            context: "formatting",
            valueCallback
          }) || match2.day(string, {
            width: "short",
            context: "formatting",
            valueCallback
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
        case "iiiii":
          return match2.day(string, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
        case "iiiiii":
          return match2.day(string, {
            width: "short",
            context: "formatting",
            valueCallback
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
        case "iiii":
        default:
          return match2.day(string, {
            width: "wide",
            context: "formatting",
            valueCallback
          }) || match2.day(string, {
            width: "abbreviated",
            context: "formatting",
            valueCallback
          }) || match2.day(string, {
            width: "short",
            context: "formatting",
            valueCallback
          }) || match2.day(string, {
            width: "narrow",
            context: "formatting",
            valueCallback
          });
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 1 && value2 <= 7;
    },
    set: function(date, _flags, value2, options) {
      date = setUTCISODay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "a":
        case "aa":
        case "aaa":
          return match2.dayPeriod(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match2.dayPeriod(string, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["b", "B", "H", "K", "k", "t", "T"]
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "b":
        case "bb":
        case "bbb":
          return match2.dayPeriod(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match2.dayPeriod(string, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["a", "B", "H", "K", "k", "t", "T"]
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "B":
        case "BB":
        case "BBB":
          return match2.dayPeriod(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match2.dayPeriod(string, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(string, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["a", "b", "t", "T"]
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, string);
        case "ho":
          return match2.ordinalNumber(string, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 1 && value2 <= 12;
    },
    set: function(date, _flags, value2, _options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else if (!isPM && value2 === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    },
    incompatibleTokens: ["H", "K", "k", "t", "T"]
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, string);
        case "Ho":
          return match2.ordinalNumber(string, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 23;
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCHours(value2, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, string);
        case "Ko":
          return match2.ordinalNumber(string, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 11;
    },
    set: function(date, _flags, value2, _options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    },
    incompatibleTokens: ["a", "b", "h", "H", "k", "t", "T"]
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, string);
        case "ko":
          return match2.ordinalNumber(string, {
            unit: "hour"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 1 && value2 <= 24;
    },
    set: function(date, _flags, value2, _options) {
      var hours = value2 <= 24 ? value2 % 24 : value2;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
  },
  // Minute
  m: {
    priority: 60,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, string);
        case "mo":
          return match2.ordinalNumber(string, {
            unit: "minute"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 59;
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCMinutes(value2, 0, 0);
      return date;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Second
  s: {
    priority: 50,
    parse: function(string, token, match2, _options) {
      switch (token) {
        case "s":
          return parseNumericPattern(numericPatterns.second, string);
        case "so":
          return match2.ordinalNumber(string, {
            unit: "second"
          });
        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function(_date, value2, _options) {
      return value2 >= 0 && value2 <= 59;
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCSeconds(value2, 0);
      return date;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function(string, token, _match, _options) {
      var valueCallback = function(value2) {
        return Math.floor(value2 * Math.pow(10, -token.length + 3));
      };
      return parseNDigits(token.length, string, valueCallback);
    },
    set: function(date, _flags, value2, _options) {
      date.setUTCMilliseconds(value2);
      return date;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function(string, token, _match, _options) {
      switch (token) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, string);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function(date, flags, value2, _options) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    },
    incompatibleTokens: ["t", "T", "x"]
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function(string, token, _match, _options) {
      switch (token) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, string);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function(date, flags, value2, _options) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    },
    incompatibleTokens: ["t", "T", "X"]
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function(string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function(_date, _flags, value2, _options) {
      return [new Date(value2 * 1e3), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: "*"
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function(string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function(_date, _flags, value2, _options) {
      return [new Date(value2), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: "*"
  }
};
var TIMEZONE_UNIT_PRIORITY = 10;
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse$1(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = {};
  var locale$1 = options.locale || locale;
  if (!locale$1.match) {
    throw new RangeError("locale must contain match property");
  }
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$1
  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i2;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter2 = substring[0];
    if (firstCharacter2 === "p" || firstCharacter2 === "P") {
      var longFormatter = longFormatters[firstCharacter2];
      return longFormatter(substring, locale$1.formatLong, subFnOptions);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  var usedTokens = [];
  for (i2 = 0; i2 < tokens.length; i2++) {
    var token = tokens[i2];
    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }
    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }
    var firstCharacter = token[0];
    var parser2 = parsers[firstCharacter];
    if (parser2) {
      var incompatibleTokens = parser2.incompatibleTokens;
      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;
        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;
          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }
        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser2.incompatibleTokens === "*" && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }
      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser2.parse(dateString, token, locale$1.match, subFnOptions);
      if (!parseResult) {
        return /* @__PURE__ */ new Date(NaN);
      }
      setters.push({
        priority: parser2.priority,
        subPriority: parser2.subPriority || 0,
        set: parser2.set,
        validate: parser2.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
      }
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }
      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return /* @__PURE__ */ new Date(NaN);
      }
    }
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a, b) {
    return b - a;
  }).filter(function(priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);
  if (isNaN(date)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  for (i2 = 0; i2 < uniquePrioritySetters.length; i2++) {
    var setter = uniquePrioritySetters[i2];
    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    var result = setter.set(utcDate, flags, setter.value, subFnOptions);
    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]);
    } else {
      utcDate = result;
    }
  }
  return utcDate;
}
function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }
  var convertedDate = /* @__PURE__ */ new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+-])(\d{2}):(\d{2}))$/;
const formatDate$1 = (date) => {
  return date ? format(new Date(date), "dd-MM-yy HH:mm") : "-";
};
const formatDateDots = (date) => {
  return date ? format(new Date(date), "dd.MM.yy HH:mm") : "-";
};
const formatDateddMMyy = (date) => {
  return date ? format(new Date(date), "dd.MM.yy") : "-";
};
const formatDateddMMyyyy = (date) => {
  return date ? format(new Date(date), "dd.MM.yyyy") : "-";
};
const formatTime = (date) => {
  return date ? format(new Date(date), "HH:mm") : "-";
};
const formatDateTimeSeconds = (date) => {
  return date ? format(new Date(date), "dd.MM.yy HH:mm:ss") : "-";
};
const serializeDates$2 = (value2) => {
  if (value2 instanceof Date)
    return value2.toISOString();
  if (typeof value2 === "boolean")
    return value2 ? "true" : "false";
  return value2;
};
const resetDateTimeUnits = (date, units = ["second", "millisecond"]) => {
  units.includes("hour") && date.setHours(0);
  units.includes("minute") && date.setMinutes(0);
  units.includes("second") && date.setSeconds(0);
  units.includes("millisecond") && date.setMilliseconds(0);
  return date;
};
const omitDateTimeSeconds = (date) => {
  return resetDateTimeUnits(date, ["second", "millisecond"]);
};
const deserializeDatesInObject = (data) => {
  function walkObject(o) {
    const result = {};
    for (const key of Object.keys(o)) {
      const value2 = o[key];
      if (typeof value2 === "string" && dateRegex.test(value2)) {
        result[key] = new Date(value2);
      } else if (typeof value2 === "object" && value2 !== null) {
        result[key] = walkObject(value2);
      } else {
        result[key] = value2;
      }
    }
    Object.assign(o, result);
    return o;
  }
  return walkObject(data);
};
const formatDuration = (duration) => {
  const minutes = Math.floor(duration / 60).toString().padStart(2, "0");
  const seconds = duration % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};
const globalStore = useGlobalStore();
const entityEndpoints = {};
const entityClients = {};
const getClientConfig = (baseURL = GLOBAL_CONFIG.API_HOST) => ({
  withCredentials: true,
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": globalStore.language ?? navigator.language
  },
  paramsSerializer: {
    serialize: (params) => Object.entries(params).map(([key, value2]) => {
      if (typeof value2 === "undefined" || value2 === "")
        return;
      if (Array.isArray(value2)) {
        return value2.map((v) => `${encodeURIComponent(key)}[]=${encodeURIComponent(`${serializeDates$2(v)}`)}`).join("&");
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(`${serializeDates$2(value2)}`)}`;
    }).filter(Boolean).join("&")
  }
});
const errorInterceptor = (error) => {
  var _a, _b, _c, _d, _e, _f;
  if (((_a = error.config) == null ? void 0 : _a.handleError) === false) {
    return Promise.reject(error);
  }
  const notificationStore2 = useNotificationStore();
  const check = (e) => error.isAxiosError;
  if (check()) {
    if (((_b = error.response) == null ? void 0 : _b.status) === 401 && ((_c = error.response.data) == null ? void 0 : _c.type) === "UnauthenticatedInCMSError") {
      return Promise.reject(error);
    }
    const { t } = getI18n();
    const severity = ((_d = error.response) == null ? void 0 : _d.status) === 404 ? "warning" : "negative";
    notificationStore2.showNotification(
      new CMSNotification(error.message + (((_e = error.response) == null ? void 0 : _e.data.message) ? `: ${(_f = error.response) == null ? void 0 : _f.data.message}` : ""), severity, {
        multiLine: true,
        timeout: null,
        dismissible: true,
        callbackLabel: t("messages.copyErrorToClipboard"),
        async callbackFunc() {
          await copyToClipboard(error.response ? JSON.stringify(error.response, void 0, 2) : JSON.stringify(error, void 0, 2));
          notificationStore2.showNotification(new CMSNotification(t("messages.copiedToClipboard"), "info"));
        }
      })
    );
  }
  return Promise.reject(error);
};
const dateInterceptor = (response) => {
  const body = response.data;
  if (body === null || body === void 0 || typeof body !== "object")
    return response;
  response.data = deserializeDatesInObject(body);
  return response;
};
const titleInterceptor = (response) => {
  const WHITELISTED_PATHS = Object.keys(ROUTES).filter((key) => ROUTES[key].hasTitlePropagation).map((key) => ROUTES[key].path);
  const paths = location.pathname.split("/").filter((p) => p.length > 0);
  const route = paths[0];
  const { _id, title: entityTitle, image } = response.data;
  const id = _id || (image == null ? void 0 : image._id);
  const title = entityTitle || (image == null ? void 0 : image.title);
  const isWhitelisted = route ? WHITELISTED_PATHS.includes(route) : false;
  const keyExists = getI18n().te(`${route}.routeTitleDetail`);
  if (isWhitelisted && title && keyExists && id === paths.pop()) {
    const routeDetailTitle = getI18n().t(`${route}.routeTitleDetail`);
    document.title = `${routeDetailTitle} ${title}`;
  }
  return response;
};
const defaultErrorInterceptors = [errorInterceptor];
const createAxiosClient = (config) => {
  const client2 = axios.create(config);
  for (const err of defaultErrorInterceptors) {
    client2.interceptors.response.use(void 0, err);
  }
  client2.interceptors.response.use(dateInterceptor);
  client2.interceptors.response.use(titleInterceptor);
  return client2;
};
const registerErrorInterceptor = (cb) => {
  defaultErrorInterceptors.push(cb);
};
let client;
const getEntityAPIClient = (klass) => {
  const accessor = entityEndpoints[klass];
  if (!accessor) {
    throw new Error(`Entity "${klass}" has no registered endpoint!`);
  }
  let api = entityClients[klass];
  if (!api) {
    api = entityClients[klass] = accessor();
  }
  return api;
};
const getClient = () => {
  if (!client) {
    client = createAxiosClient(getClientConfig());
  }
  return client;
};
const getEntity$2 = async (klass, id, config) => {
  if (!entityEndpoints[klass]) {
    throw new Error(`Entity "${klass}" has no registered endpoint!`);
  }
  const resp = await getEntityAPIClient(klass).get(`/${id}`, config);
  return resp.data;
};
const postEntity = async (klass, payload, config) => {
  if (!entityEndpoints[klass]) {
    throw new Error(`Entity "${klass}" has no registered endpoint!`);
  }
  const resp = await getEntityAPIClient(klass).post("", payload, config);
  return resp.data;
};
const putEntity$1 = async (klass, id, payload, config) => {
  if (!entityEndpoints[klass]) {
    throw new Error(`Entity "${klass}" has no registered endpoint!`);
  }
  const resp = await getEntityAPIClient(klass).put(`/${id}`, payload, config);
  return resp.data;
};
const deleteEntity = async (klass, id, config) => {
  if (!entityEndpoints[klass]) {
    throw new Error(`Entity "${klass}" has no registered endpoint!`);
  }
  const resp = await getEntityAPIClient(klass).delete(`/${id}`, config);
  return resp.data;
};
const listEntities$2 = async (klass, config) => {
  if (!entityEndpoints[klass]) {
    throw new Error(`Entity "${klass}" has no registered endpoint!`);
  }
  const resp = await getEntityAPIClient(klass).get("", config);
  return resp.data;
};
const registerEntityEndpoint = (klass, endpoint = `/cms/${klass.toLowerCase()}`) => {
  entityEndpoints[klass] = () => {
    const url2 = `${GLOBAL_CONFIG.API_HOST}${endpoint}`;
    return createAxiosClient(getClientConfig(url2));
  };
  return {
    getEntity: getEntity$2.bind(void 0, klass),
    listEntities: listEntities$2.bind(void 0, klass),
    postEntity: postEntity.bind(void 0, klass),
    putEntity: putEntity$1.bind(void 0, klass),
    deleteEntity: deleteEntity.bind(void 0, klass),
    getEntityAPIClient: getEntityAPIClient.bind(void 0, klass)
  };
};
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "bf-checkbox",
  props: {
    modelValue: { type: [Boolean, null], required: false, default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props = __props;
    const emit = __emit;
    const model = computed({
      get() {
        return !!props.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    const __returned__ = { props, emit, model, get QCheckbox() {
      return QCheckbox;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QCheckbox"], mergeProps({
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event)
  }, _ctx.$attrs), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
    /* FORWARDED */
  }, 16, ["modelValue"]);
}
const bfCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-checkbox.vue"]]);
const customIcons = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%3e%3csymbol%20id='javascript'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M14%201a1.01%201.01%200%200%201%20.25.031l.03.009c.03.009.061.02.091.031l.027.012a.914.914%200%200%201%20.195.112c.04.03.078.062.114.098l-.093-.082.011.009.082.073%206%206a1.006%201.006%200%200%201%20.21.309l.012.027c.012.03.022.06.031.091l.008.03A.921.921%200%200%201%2021%208l-.008-.126.001.01L21%208v12a3%203%200%200%201-3%203H6a3%203%200%200%201-3-3V4a3%203%200%200%201%203-3h8zm-1%202H6a1%201%200%200%200-1%201v16a1%201%200%200%200%201%201h12a1%201%200%200%200%201-1V9h-5a1%201%200%200%201-.993-.883L13%208V3zm-2.155%207.2v6.744c0%201.504-.675%202.256-2.026%202.256-.299%200-.525-.009-.679-.026v-1.282c.103.009.265.013.487.013.257%200%20.455-.062.596-.186.141-.124.212-.348.212-.673V10.2h1.41zm3.135-.112c.67%200%201.177.19%201.521.572.344.381.515.928.515%201.64v.277H14.71v-.365c0-.301-.059-.521-.176-.66-.117-.138-.289-.207-.515-.207-.227%200-.398.07-.516.207-.117.139-.176.359-.176.66%200%20.369.099.692.296.968.197.277.492.591.886.943.327.302.59.568.792.798.201.23.373.51.515.836.143.327.214.7.214%201.119%200%20.712-.176%201.259-.528%201.64-.352.381-.863.572-1.534.572-.67%200-1.181-.19-1.533-.572-.352-.381-.528-.928-.528-1.64v-.54h1.307v.628c0%20.57.24.854.717.854s.716-.284.716-.854c0-.369-.098-.692-.295-.968-.197-.277-.492-.591-.886-.943-.327-.302-.591-.568-.792-.798a3.212%203.212%200%200%201-.516-.836%202.775%202.775%200%200%201-.213-1.119c0-.712.171-1.259.515-1.64s.85-.572%201.521-.572zM15%204.415V7h2.585L15%204.415z'/%3e%3c/symbol%3e%3csymbol%20id='gallery'%20viewBox='0%200%2024%2024'%20fill='currentColor'%3e%3cpath%20d='M2%207a1%201%200%200%201%20.993.883L3%208v12a1%201%200%200%200%20.883.993L4%2021h12a1%201%200%200%201%20.117%201.993L16%2023H4a3%203%200%200%201-2.995-2.824L1%2020V8a1%201%200%200%201%201-1zm18-6a3%203%200%200%201%203%203v12a3%203%200%200%201-3%203H8a3.05%203.05%200%200%201-.14-.003%201.005%201.005%200%200%201-.375-.04A3.002%203.002%200%200%201%205%2016V4a3%203%200%200%201%203-3zm-2.445%208.636L10.191%2017H20a1%201%200%200%200%20.993-.883L21%2016v-2.919l-3.445-3.445zM20%203H8a1%201%200%200%200-1%201v12a1%201%200%200%200%20.498.865l9.35-9.35a1%201%200%200%201%201.32-.083l.095.083L21%2010.252V4a1%201%200%200%200-.883-.993L20%203zm-9.111%201.556a2.333%202.333%200%201%201%200%204.666%202.333%202.333%200%200%201%200-4.666zm0%202a.333.333%200%201%200%200%20.666.333.333%200%200%200%200-.666z'%20/%3e%3c/symbol%3e%3csymbol%20id='video-performance'%20viewBox='0%200%2024%2024'%20stroke='currentColor'%20fill='none'%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M1%204v6h6M23%2020v-6h-6'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M23%2014l-4.64%204.36c-1.075%201.075-2.405%201.86-3.865%202.283-1.46.423-3.004.468-4.487.133-1.483-.336-2.856-1.041-3.993-2.051C4.88%2017.715%204.017%2016.433%203.51%2015M2%208.998l4.64-4.36c1.075-1.076%202.405-1.861%203.865-2.284%201.46-.422%203.004-.468%204.487-.132%201.483.335%202.856%201.041%203.993%202.051%201.136%201.01%201.998%202.291%202.505%203.725'/%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='2'%20d='M11%209l4.5%203-4.5%203V9z'/%3e%3c/symbol%3e%3csymbol%20id='flag-de'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H24V24H0V0Z'%20fill='black'/%3e%3cpath%20d='M0%208H24V24H0V8Z'%20fill='%23DD0000'/%3e%3cpath%20d='M0%2016H24V24H0V16Z'%20fill='%23FFCE00'/%3e%3c/symbol%3e%3csymbol%20id='flag-en'%20viewBox='0%200%2024%2024'%3e%3cg%20clip-path='url(%23clip_a)'%3e%3cg%20clip-path='url(%23clip_b)'%3e%3cpath%20d='M-12%200V24H36V0H-12Z'%20fill='%23012169'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='white'%20stroke-width='6'/%3e%3cpath%20d='M-12%200L36%2024L-12%200ZM36%200L-12%2024Z'%20fill='black'/%3e%3cpath%20d='M36%200L-12%2024M-12%200L36%2024L-12%200Z'%20stroke='%23C8102E'%20stroke-width='4'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='white'%20stroke-width='10'/%3e%3cpath%20d='M12%200V24V0ZM-12%2012H36Z'%20fill='black'/%3e%3cpath%20d='M-12%2012H36M12%200V24V0Z'%20stroke='%23C8102E'%20stroke-width='6'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip_a'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip_b'%3e%3crect%20width='48'%20height='24'%20fill='white'%20transform='translate(-12)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/symbol%3e%3csymbol%20id='flag-it'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M0%200H8V24H0V0Z'%20fill='%23008C45'/%3e%3cpath%20d='M8%200H16V24H8V0Z'%20fill='white'/%3e%3cpath%20d='M16%200H24V24H16V0Z'%20fill='%23CD212A'/%3e%3c/symbol%3e%3c/svg%3e";
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "language-selector",
  props: {
    showLabel: { type: Boolean, required: false, default: true },
    menuPosition: { type: String, required: false, default: "top" },
    shrinked: { type: Boolean, required: false, default: false },
    flat: { type: Boolean, required: false, default: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const globalStore2 = useGlobalStore();
    const { t } = useI18n();
    const props = __props;
    const languages2 = {
      en: ["English", "flag-en"],
      de: ["Deutsch", "flag-de"]
      //,
      // not supported yet
      // it: ['Italiano', 'flag-it']
    };
    const q = useQuasar();
    const switchLang = (lang) => {
      globalStore2.setLanguage(lang);
      q.lang.set(quasarLocales[lang]);
    };
    const dropdownClass = computed(() => `dropdown-menu dropdown-menu-${props.menuPosition}`);
    const __returned__ = { globalStore: globalStore2, t, props, languages: languages2, q, switchLang, dropdownClass, get vClosePopup() {
      return ClosePopup;
    }, get QBtn() {
      return QBtn;
    }, get QIcon() {
      return QIcon;
    }, get QItem() {
      return QItem;
    }, get QItemSection() {
      return QItemSection;
    }, get QList() {
      return QList;
    }, get QMenu() {
      return QMenu;
    }, get customIcons() {
      return customIcons;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$8 = { key: 0 };
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QBtn"], mergeProps({
    class: $props.shrinked && "shrinked",
    depressed: "",
    text: "",
    flat: $props.flat
  }, _ctx.$attrs), {
    default: withCtx(() => [
      createVNode($setup["QIcon"], { name: "globe" }),
      $props.showLabel ? (openBlock(), createElementBlock(
        "span",
        _hoisted_1$8,
        toDisplayString($setup.t("common.language")),
        1
        /* TEXT */
      )) : createCommentVNode("v-if", true),
      createVNode($setup["QMenu"], {
        bottom: $props.menuPosition === "bottom",
        "content-class": $setup.dropdownClass,
        top: $props.menuPosition === "top",
        left: "",
        "offset-y": ""
      }, {
        default: withCtx(() => [
          createVNode($setup["QList"], { class: "text-body1" }, {
            default: withCtx(() => [
              (openBlock(), createElementBlock(
                Fragment,
                null,
                renderList($setup.languages, (item, key) => {
                  return withDirectives(createVNode($setup["QItem"], {
                    key,
                    clickable: "",
                    ripple: "",
                    onClick: ($event) => $setup.switchLang(key)
                  }, {
                    default: withCtx(() => [
                      createVNode(
                        $setup["QItemSection"],
                        { avatar: "" },
                        {
                          default: withCtx(() => [
                            createVNode($setup["QIcon"], {
                              "custom-icon": true,
                              name: item[1],
                              src: $setup.customIcons,
                              class: "icon"
                            }, null, 8, ["name", "src"])
                          ]),
                          _: 2
                          /* DYNAMIC */
                        },
                        1024
                        /* DYNAMIC_SLOTS */
                      ),
                      createVNode(
                        $setup["QItemSection"],
                        null,
                        {
                          default: withCtx(() => [
                            createTextVNode(
                              toDisplayString(item[0]),
                              1
                              /* TEXT */
                            )
                          ]),
                          _: 2
                          /* DYNAMIC */
                        },
                        1024
                        /* DYNAMIC_SLOTS */
                      )
                    ]),
                    _: 2
                    /* DYNAMIC */
                  }, 1032, ["onClick"]), [
                    [$setup["vClosePopup"]]
                  ]);
                }),
                64
                /* STABLE_FRAGMENT */
              ))
            ]),
            _: 1
            /* STABLE */
          })
        ]),
        _: 1
        /* STABLE */
      }, 8, ["bottom", "content-class", "top"])
    ]),
    _: 1
    /* STABLE */
  }, 16, ["class", "flat"]);
}
const languageSelector = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q], ["__scopeId", "data-v-a15c86ad"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/language-selector.vue"]]);
const logo = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2023.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20800%20118.2'%20style='enable-background:new%200%200%20800%20118.2;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%2395C11F;}%20.st1{fill:%23F39200;}%20.st2{fill:%231D1D1B;}%20%3c/style%3e%3cpath%20class='st0'%20d='M0,0h344.1v118.2H0V0z'/%3e%3cpath%20class='st1'%20d='M344.1,0H800v118.2H344.1V0z'/%3e%3cpath%20class='st2'%20d='M41.7,20.2h39.2c7.5,0,12.9,1.9,17,4.8c4.7,3.6,7.3,9,7.2,14.9c0,7.2-3.1,11.8-9.5,14.5v0.3%20c7.9,2.5,13.4,10,13.1,18.2c0,8.1-3.3,14.3-8.7,18.2c-4.5,3.1-10.6,4.8-18.4,4.8h-40C41.7,96.1,41.7,20.2,41.7,20.2L41.7,20.2z%20M77.3,49.8c4.2,0,7.2-2,7.2-6.1s-3-6.2-7.2-6.2H63.6v12.3L77.3,49.8L77.3,49.8z%20M79.3,78.9c4.8,0,8.1-2.8,8.1-7.5%20c0-4.8-3.6-7.3-8.1-7.3H63.6v14.8C63.6,78.9,79.3,78.9,79.3,78.9z%20M149.5,96.1v-7h-0.3c-3.7,5.6-10.1,8.9-16.8,8.6%20c-12.9,0-19.3-8.6-19.3-20.8V42h20.1v30.2c0,5.6,2.5,8.6,7.2,8.6c5.1,0,8.2-3.7,8.2-9.5V42.1h20.1v54L149.5,96.1L149.5,96.1z%20M194.8,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6V96h-20.1V42h19.1%20L194.8,50.2L194.8,50.2z%20M217,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2%20c-3.1,5.8-9.3,9.3-15.9,9.3C227.5,97.8,217,87.7,217,69.1z%20M257.2,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8%20c0,8.2,3.7,14.2,9.8,14.2S257.2,76.5,257.2,68.7z%20M316.9,89.9h-0.2c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2%20c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4%20c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3v11.4c-2.8,1.1-5.8,1.6-8.9,1.6%20C322.4,97.1,318.2,94.9,316.9,89.9L316.9,89.9z%20M316.1,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5c-5.9,1.2-7.6,3-7.6,6.2%20c0,3.6,3,5.1,6.2,5.1C311.6,85.5,316.1,83.1,316.1,76.5L316.1,76.5z%20M344.1,20.2h58.5v18.7h-36.3v12.4h30v17.1h-30v27.5h-22.1%20C344.1,96.1,344.1,20.2,344.1,20.2z%20M401.4,69.2c0-16.5,11.7-28.8,29.7-28.8s29.6,12.3,29.6,28.8s-11.5,28.6-29.6,28.6%20S401.4,85.5,401.4,69.2z%20M440.3,69.2c0-9.2-3.1-15.2-9.3-15.2c-6.2,0-9.2,6.2-9.2,15.2s3,15.2,9.2,15.2%20C437.2,84.5,440.3,78.4,440.3,69.2z%20M484.6,50.2h0.3c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.3%20c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L484.6,50.2L484.6,50.2z%20M507.2,42h20.7l5.3,19.6c1.2,4.2,2.5,10.9,2.5,10.9h0.2%20c0,0,1.4-6.7,2.5-11.2l4.6-19.2h17l4.7,19.1c1.2,4.7,2.5,11.5,2.5,11.5h0.2c0,0,1.6-6.8,2.6-11l5-19.6h20.2l-17.1,54.1h-19.3%20l-5.4-22.6c-1.1-4.2-2.2-10.1-2.2-10.1H551c0,0-1.2,5.9-2.2,10.1L543.4,96h-19L507.2,42L507.2,42z%20M629.5,89.9h-0.2%20c-3.4,4.8-9,7.6-17.3,7.6c-10.4,0-18-5.6-18-16.2c0-12,9.2-15.6,19.6-16.6c11.5-1.2,14.5-2.6,14.5-6.1c0-3-1.4-5.1-5.8-5.1%20s-6.5,2.5-7.2,6.5h-19c0.5-10.7,8.7-19.4,25.7-19.4c8.2,0,15.2,1.7,19.6,5c4.5,3.3,6.5,7.6,6.5,14.8v20.4c0,3.4,1.4,3.9,3.4,3.4h0.3%20v11.4c-2.8,1.1-5.8,1.6-8.9,1.6C635.1,97.1,630.9,94.9,629.5,89.9L629.5,89.9z%20M628.7,76.5v-4.8c-2.5,1.2-5.1,2-7.8,2.5%20c-5.9,1.2-7.6,3-7.6,6.2c0,3.6,3,5.1,6.2,5.1C624.2,85.5,628.7,83.1,628.7,76.5L628.7,76.5z%20M674.8,50.2h0.3%20c4.4-6.8,9.5-9.3,16.5-9.3c1.1,0,2.2,0.2,3.3,0.5v17.1h-0.5c-11.8-2-18.7,3.3-18.7,15.6v22h-20.1V42h19.1L674.8,50.2L674.8,50.2z%20M697,69.1c0-17,9.8-28.6,24.1-28.6c7.8,0,11.5,2.8,15.1,7.5h0.3V20.3h20.1v75.8h-19.1v-7.5h-0.2c-3.1,5.8-9.3,9.3-15.9,9.3%20C707.4,97.8,697,87.7,697,69.1L697,69.1z%20M737.1,68.7c0-7.8-4-13.8-10-13.8s-9.8,5.6-9.8,13.8s3.7,14.2,9.8,14.2%20S737.1,76.5,737.1,68.7z'/%3e%3c/svg%3e";
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "modal-reload",
  props: {
    reloadMsg: { type: String, required: false, default: "" },
    offline: { type: Boolean, required: false, default: false },
    forceUpdate: { type: Boolean, required: false, default: false }
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit = __emit;
    const { t } = useI18n();
    const reload = () => window.location.reload();
    const cancel = () => emit("close");
    const __returned__ = { emit, t, reload, cancel, get QBar() {
      return QBar;
    }, get QBtn() {
      return QBtn;
    }, get QCard() {
      return QCard;
    }, get QCardActions() {
      return QCardActions;
    }, get QCardSection() {
      return QCardSection;
    }, get QToolbarTitle() {
      return QToolbarTitle;
    }, get logo() {
      return logo;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$7 = { class: "d-flex flex-column justify-center align-center" };
const _hoisted_2$4 = ["src"];
const _hoisted_3$3 = { class: "text-center mb-4" };
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    createVNode($setup["QCard"], {
      class: "pa-8",
      style: { "width": "435px" }
    }, {
      default: withCtx(() => [
        createVNode($setup["QBar"], { class: "text-center bg-white" }, {
          default: withCtx(() => [
            !$props.offline ? (openBlock(), createBlock($setup["QToolbarTitle"], { key: 0 }, {
              default: withCtx(() => [
                createElementVNode("img", {
                  src: $setup.logo,
                  style: { "height": "40px" },
                  class: "align-self-center"
                }, null, 8, _hoisted_2$4)
              ]),
              _: 1
              /* STABLE */
            })) : createCommentVNode("v-if", true),
            !$props.offline && !$props.forceUpdate ? (openBlock(), createBlock($setup["QBtn"], {
              key: 1,
              class: "float-right",
              flat: "",
              round: "",
              dense: "",
              icon: "close",
              onClick: $setup.cancel
            })) : createCommentVNode("v-if", true)
          ]),
          _: 1
          /* STABLE */
        }),
        createVNode($setup["QCardSection"], { class: "pt-4 text-center" }, {
          default: withCtx(() => [
            createElementVNode(
              "h2",
              _hoisted_3$3,
              toDisplayString($props.reloadMsg),
              1
              /* TEXT */
            )
          ]),
          _: 1
          /* STABLE */
        }),
        createVNode($setup["QCardActions"], { align: "center" }, {
          default: withCtx(() => [
            !$props.offline ? (openBlock(), createBlock($setup["QBtn"], {
              key: 0,
              color: "primary",
              block: "",
              onClick: $setup.reload
            }, {
              default: withCtx(() => [
                createTextVNode(
                  toDisplayString($setup.t("pingApi.reload")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            })) : createCommentVNode("v-if", true)
          ]),
          _: 1
          /* STABLE */
        })
      ]),
      _: 1
      /* STABLE */
    })
  ]);
}
const modalReload = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/modal-reload.vue"]]);
const bunte$1 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='32'%20height='32'%20fill='url(%23pattern0_5166_57)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_5166_57'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_5166_57'%20transform='scale(0.015625)'/%3e%3c/pattern%3e%3cimage%20id='image0_5166_57'%20width='64'%20height='64'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e";
const chip$1 = "data:image/svg+xml,%3csvg%20width='256'%20height='256'%20viewBox='0%200%20256%20256'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_2439_7279)'%3e%3cg%20clip-path='url(%23clip1_2439_7279)'%3e%3crect%20width='256'%20height='256'%20fill='%23E6252C'/%3e%3cpath%20d='M36.0444%2045.5V60.1C35.9444%2060%2036.0444%2045.5%2036.0444%2045.5ZM218.744%20211C218.144%20223.5%20209.344%20225.5%20204.244%20225.5C199.144%20225.5%2052.0444%20225.4%2050.6444%20225.5C49.1444%20225.7%2036.2444%20224.1%2036.1444%20211C36.0444%20197.9%2036.1444%20110.3%2036.1444%2060V45.5C37.1444%2031.7%2048.6444%2031%2050.4444%2031H204.244C210.744%2031%20218.744%2035.9%20218.744%2045.6V88.7C218.144%2095.8%20211.544%2095.8%20211.444%2095.8H187.944C180.544%2095.2%20180.644%2088.5%20180.644%2088.5V77.8C180.644%2077.8%20181.144%2065.7%20167.944%2065.1C155.644%2065.1%2087.1444%2065.2%2086.6444%2065.1C85.5444%2065.1%2074.9444%2065.8%2074.5444%2077.2C74.4444%2088.8%2074.5444%20109.1%2074.5444%20109.1L107.544%20141.8V178.6C107.444%20180.9%20108.844%20189.7%20118.544%20190.7C127.644%20190.8%20165.744%20190.7%20168.644%20190.7C171.544%20190.7%20180.344%20188.8%20180.744%20178.6C180.844%20176.5%20180.744%20175.1%20180.844%20171.3C180.944%20167.5%20182.544%20163.4%20187.944%20163.1H211.444C218.344%20163.4%20218.744%20169.6%20218.744%20170.4C218.644%20171.2%20218.844%20198.8%20218.744%20211Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_2439_7279'%3e%3crect%20width='256'%20height='256'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_2439_7279'%3e%3crect%20width='256'%20height='256'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const focus$1 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='32'%20height='32'%20fill='url(%23pattern0_5166_45)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_5166_45'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_5166_45'%20transform='scale(0.03125)'/%3e%3c/pattern%3e%3cimage%20id='image0_5166_45'%20width='32'%20height='32'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e";
let _router;
const setDefaultRouter = (router) => _router = router;
const useDefaultRouter = () => {
  if (!_router)
    throw new Error("Router not yet initialized!");
  return _router;
};
const CmsUserModelName = "CmsUserModelName ";
const UserService = registerEntityEndpoint(CmsUserModelName, "/cms/users");
const { getEntity: getEntity$1, listEntities: listEntities$1, putEntity } = UserService;
const getUser = async (id) => getEntity$1(id);
const getUsers = async (search) => {
  return listEntities$1({ params: { search, page: 1 } });
};
const getCurrentUser = async (handleError = true) => {
  const resp = await getClient().get("/cms/session/currentUser", { handleError });
  return resp.data;
};
const updateUser = async (user) => {
  const { _id, ...payload } = user;
  return putEntity(_id, payload);
};
const authenticate = async (code) => {
  const resp = await getClient().post("/cms/session/authenticate", { code }, { handleError: false });
  return resp.data;
};
const logout = async () => {
  const resp = await getClient().delete("/cms/session/logout");
  return resp.data;
};
const { getEntity } = registerEntityEndpoint("authors");
const notificationStore = useNotificationStore();
const defaultValue = {
  loaded: false,
  loggedIn: false,
  firstName: "",
  lastName: "",
  userId: "",
  group: "External",
  isEnabled: false,
  avatarUuid: "",
  authorUuid: "",
  email: "",
  rights: [],
  wasLoggedIn: false,
  expiredToken: false,
  seenUpdateModal: false,
  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  },
  // Actions
  hasRight(right) {
    return this.rights.includes(right);
  },
  resetCurrentUser(expiredToken = false) {
    Object.assign(store$4, defaultValue);
    if (expiredToken) {
      this.expiredToken = true;
    }
    this.wasLoggedIn = true;
  },
  async loadAvatarUuid(authorUuid) {
    const author = await getEntity(authorUuid);
    this.avatarUuid = author.imageUuid || "";
  },
  async loadCurrentUser() {
    try {
      this.loaded = false;
      const resp = await getCurrentUser(false);
      this.loaded = true;
      this.wasLoggedIn = true;
      this.loggedIn = true;
      this.expiredToken = false;
      this.applyUser(resp);
      if (this.group === "NewUser") {
        notificationStore.showNotification(new CMSNotification(getI18n().t("login.newUserNotification"), "info", { multiLine: true }));
      }
      if (resp.authorUuid) {
        this.authorUuid = resp.authorUuid;
        await this.loadAvatarUuid(resp.authorUuid);
      }
    } catch (e) {
      console.log(e);
      this.loaded = true;
    }
    return this;
  },
  async logoutCurrentUser() {
    await logout();
    this.userId = "";
    this.loggedIn = false;
    this.wasLoggedIn = false;
    this.firstName = "";
    this.group = "External";
    window.localStorage.clear();
    await useDefaultRouter().push("/");
  },
  async authenticate(code) {
    const user = await authenticate(code);
    this.applyUser(user);
    this.loggedIn = true;
  },
  applyUser(user) {
    this.isEnabled = user.isEnabled;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.group = user.group;
    this.userId = user._id;
    this.rights = user.rights;
  }
};
const store$4 = reactive({ ...defaultValue });
const useUserStore = () => store$4;
const userErrorInterceptor = (error) => {
  var _a, _b, _c;
  if (((_a = error.config) == null ? void 0 : _a.handleError) === false) {
    return Promise.reject(error);
  }
  if (error instanceof AxiosError) {
    const notificationStore2 = useNotificationStore();
    const isUnauthenticatedInCMSError = (e) => {
      var _a2, _b2;
      return ((_a2 = error.response) == null ? void 0 : _a2.status) === 401 && ((_b2 = error.response) == null ? void 0 : _b2.data.type) === "UnauthenticatedInCMSError";
    };
    if (isUnauthenticatedInCMSError()) {
      if (!store$4.expiredToken && store$4.loggedIn) {
        notificationStore2.showNotification(
          new CMSNotification(getI18n().t("login.sessionExpired"), "negative", { timeout: CMSNotification.NO_TIMEOUT })
        );
        store$4.resetCurrentUser(true);
        store$4.loaded = true;
      }
    }
    if (((_b = error.response) == null ? void 0 : _b.status) === 403) {
      notificationStore2.showNotification(new CMSNotification((_c = error.response) == null ? void 0 : _c.data.message));
    }
  }
  return Promise.reject(error);
};
const sanitizePathUrl = (path) => {
  return path.replace(/\s/g, "-").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ä/g, "ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue").replace(/Ä/g, "Ae").replace(/ß/g, "ss").replace(/[^\w\d\s-]/g, "").replace(/-+/g, "-").replace(/-+$/g, "");
};
function validateEmail(email) {
  const re2 = /^(?:(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*)|(?:".+"))@(?:(?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?:(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re2.test(String(email).toLowerCase());
}
function validateContainsNumber(value2) {
  return /\d/.test(value2);
}
function validateContainsUppercase(value2) {
  return /[A-Z]/.test(value2);
}
function validateContainsLowercase(value2) {
  return /[a-z]/.test(value2);
}
function validatePath(value2) {
  return /^[\w\d/-]+$/g.test(value2);
}
function isNumeric(value2) {
  return /^\d+$/.test(value2);
}
function isRelativePath(value2) {
  return /^\/.*$/.test(value2);
}
function lessThan11(value2) {
  return /^\d+$/.test(value2) && parseInt(value2) < 11;
}
function higherorEqualto0(value2) {
  return /^\d+$/.test(value2) && parseInt(value2) > -1;
}
function validUrl(value2) {
  if (value2) {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
      value2
    );
  }
  return true;
}
function validateDate(value2) {
  const parsedDate = parse$1(value2, "dd.MM.yyyy", 0);
  return isValid(parsedDate);
}
function validateDateNotInFuture(value2) {
  const parsedDate = parse$1(value2, "dd.MM.yyyy", 0);
  const today = /* @__PURE__ */ new Date();
  return isValid(parsedDate) && parsedDate <= today;
}
function validateDateTime(value2) {
  const parsedDate = parse$1(value2, "dd.MM.yyyy HH:mm", 0);
  return isValid(parsedDate);
}
function checkWhiteSpace(value2) {
  return value2[0] !== " ";
}
function validateRequiredValue(value2) {
  if (Array.isArray(value2)) {
    return !!(value2 == null ? void 0 : value2.length);
  }
  if (typeof value2 === "object") {
    return !!(value2 == null ? void 0 : value2.uuid) || !!(value2 == null ? void 0 : value2._id);
  }
  return !!(value2 == null ? void 0 : value2.length);
}
const validateContainsSubstring = (substring, value2) => !substring || !value2 || value2.includes(substring);
const VuetifyValidationRules = {
  required: (value2) => validateRequiredValue(value2) || getI18n().t("validation.required"),
  validateRequiredRichTextValue: (value2) => !!value2 && value2.trim() !== "<p></p>",
  numberRequired: (value2) => !!value2 || getI18n().t("validation.required"),
  equalOrMoreThan: (min) => (value2) => value2 >= min || `${getI18n().t("validation.moreThan")} ${min}`,
  equalOrLessThan: (max) => (value2) => value2 <= max || `${getI18n().t("validation.lessThan")} ${max}`,
  minLength: (min) => (value2) => value2.length >= min || `${getI18n().t("validation.minLength1")} ${min} ${getI18n().t("validation.minLength2")}`,
  maxLength: (max) => (value2) => !value2 || value2.length <= max || `${getI18n().t("validation.maxLength1")} ${max} ${getI18n().t("validation.maxLength2")}`,
  exactLengthNumbers: (num) => (value2) => value2.length >= num || `${getI18n().t("validation.exactLengthNumber1")} ${num} ${getI18n().t("validation.exactLengthNumber2")}`,
  containNumber: (value2) => validateContainsNumber(value2) || getI18n().t("validation.containNumber"),
  containLowercase: (value2) => validateContainsLowercase(value2) || getI18n().t("validation.containLowercase"),
  containUppercase: (value2) => validateContainsUppercase(value2) || getI18n().t("validation.containUppercase"),
  containSubstring: (substring, message) => (value2) => validateContainsSubstring(substring, value2) || getI18n().t(message || "validation.containSubstring"),
  validEmail: (value2) => validateEmail(value2) || getI18n().t("validation.validEmail"),
  validEmailOptional: (value2) => !value2 || validateEmail(value2) || getI18n().t("validation.validEmail"),
  validPath: (value2) => validatePath(value2) || getI18n().t("validation.validPath"),
  validDate: (value2) => validateDate(value2) || getI18n().t("validation.validDate"),
  validateDateNotInFuture: (value2) => !value2 || validateDateNotInFuture(value2) || getI18n().t("validation.validDateNotInFuture"),
  validDateTime: (value2) => validateDateTime(value2) || getI18n().t("validation.validDateTime"),
  validDateTimeOptional: (value2) => !value2 || validateDateTime(value2) || getI18n().t("validation.validDateTime"),
  notContainHTML: (value2) => !value2.includes(".html") || getI18n().t("validation.notContainHTML"),
  isNumeric: (value2) => isNumeric(value2) || getI18n().t("validation.isNumeric"),
  isRelativePath: (value2) => isRelativePath(value2) || getI18n().t("validation.isRelativePath"),
  lessThan11: (value2) => lessThan11(value2) || getI18n().t("validation.lessThan11"),
  validUrl: (value2) => validUrl(value2) || getI18n().t("validation.validURL"),
  higherorEqualto0: (value2) => higherorEqualto0(value2) || getI18n().t("validation.higherEqual0"),
  positiveNumberOrUndefined: (value2) => !value2 || higherorEqualto0(value2) || getI18n().t("validation.higherEqual0"),
  noStartingWhiteSpace: (value2) => checkWhiteSpace(value2) || getI18n().t("channels.checkWhiteSpace"),
  hasCorrectBrandLicense: (asset, brand) => {
    var _a;
    return !brand || !(asset == null ? void 0 : asset._id) || ((_a = asset == null ? void 0 : asset.license) == null ? void 0 : _a.includes(brand)) || (asset == null ? void 0 : asset.brand) === brand || getI18n().t("articles.errorAssetLicense");
  },
  slugValidation: (slug, channel) => {
    if (channel.isRootChannel) {
      return true;
    }
    return !!slug || getI18n().t("validation.required");
  },
  validPublishState: (asset) => (asset == null ? void 0 : asset.state) === "publish" || getI18n().t("validation.validPublishState")
};
const bunte = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20241.7%2092.5'%20style='enable-background:new%200%200%20241.7%2092.5;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{opacity:0.6;fill:%23AA0000;enable-background:new%20;}%20%3c/style%3e%3cpath%20class='st0'%20d='M27.3,36.4c0.9-0.1,1.7-0.5,2.3-1.1c0.6-0.6,1-1.4,1-2.3V20.5c0-2.2-0.5-3.7-3.5-3.7h-9.6v19.6L27.3,36.4%20L27.3,36.4z%20M30.8,58.5c0-2.6-0.7-5.1-3.8-5.1h-9.3v22.4h9.8c0.5,0,0.9-0.1,1.4-0.3c0.4-0.2,0.8-0.5,1.1-0.8%20c0.3-0.4,0.5-0.8,0.7-1.2c0.1-0.4,0.2-0.9,0.1-1.4V58.4L30.8,58.5z%20M48,53.6v30.1c0,4.8-4.7,8.7-8,8.7H0V0.2h38.2%20c2.6,0,5.1,1.1,7,2.9c1.8,1.9,2.9,4.4,2.9,7v27.2c0,3.4-4.7,6.8-8.3,7.6v0.2C43.5,45.5,47.9,48.4,48,53.6L48,53.6z%20M99.2,84.7%20c0,4.2-3.5,7.3-8.7,7.7H61c-4.6,0.1-9-3.9-9.1-8v-8.1L52,0h17.5l0.1,71.2c0,3.1,2,4.6,6.4,4.7c4.1,0,5.9-1.7,5.9-4.6L81.9,69V0h17.3%20L99.2,84.7z%20M153,92.4h-17.3l-14-43.5v43.5h-17.5V0.1h17.5l13.9,42.4V0.1H153V92.4L153,92.4z%20M197.7,16.7H186l-0.1,75.8h-17.4V16.7%20h-11.9V0h41.1L197.7,16.7L197.7,16.7z%20M241.6,92.4h-40.2V0.1h39.4v16.4h-22v19.9h18.3v16.7L219,53.2v22.6h22.7L241.6,92.4%20L241.6,92.4z'/%3e%3c/svg%3e";
const chip = "data:image/svg+xml,%3csvg%20width='81'%20height='26'%20viewBox='0%200%2081%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_2440_7370)'%3e%3cpath%20d='M81%2019V0H0V26H70V19'%20fill='%23E6252C'/%3e%3cpath%20d='M56.244%2021C56.244%2022.104%2055.348%2023%2054.244%2023H51C49.896%2023%2049%2022.104%2049%2021V4C49%203.45%2049.447%203%2050%203H51.877C52.43%203%2052.877%203.45%2052.877%204V11.05L56.244%2014.42V21ZM66.674%2021C66.674%2022.104%2065.777%2023%2064.674%2023H61.224C60.12%2023%2059.224%2022.104%2059.224%2021V5C59.224%203.896%2060.12%203%2061.224%203H76C77.104%203%2078%203.896%2078%205V13.435C78%2014.539%2077.104%2015.435%2076%2015.435H67.673C67.12%2015.435%2066.673%2015.882%2066.673%2016.435V21H66.674ZM63.097%2010.557C63.097%2011.109%2063.544%2011.557%2064.097%2011.557H73.115C73.668%2011.557%2074.115%2011.109%2074.115%2010.557V7.877C74.115%207.327%2073.668%206.877%2073.115%206.877H64.097C63.544%206.877%2063.097%207.327%2063.097%207.877V10.557ZM41%203C40.447%203%2040%203.448%2040%204V9.47C40%2010.573%2039.103%2011.47%2038%2011.47H30.876C29.772%2011.47%2028.876%2010.573%2028.876%209.47V4C28.876%203.448%2028.428%203%2027.876%203H26C25.447%203%2025%203.448%2025%204V21C25%2022.104%2025.895%2023%2027%2023H30.346C31.45%2023%2032.346%2022.104%2032.346%2021V17.347C32.346%2016.243%2033.242%2015.347%2034.346%2015.347H38C39.103%2015.347%2040%2016.243%2040%2017.347V22C40%2022.553%2040.447%2023%2041%2023H42.876C43.429%2023%2043.876%2022.553%2043.876%2022V4C43.876%203.448%2043.429%203%2042.876%203H41ZM21.572%2021C21.572%2022.104%2020.676%2023%2019.572%2023H5C3.896%2023%203%2022.104%203%2021V5C3%203.895%203.896%203%205%203H19.572C20.676%203%2021.572%203.895%2021.572%205V8.73C21.572%209.283%2021.124%209.73%2020.572%209.73H18.55C18.077%209.73%2017.694%209.348%2017.694%208.876V7.876C17.694%207.324%2017.246%206.876%2016.694%206.876H8.877C7.773%206.876%206.877%207.772%206.877%208.876V11.05L10.245%2014.417V17.121C10.245%2018.228%2011.141%2019.121%2012.245%2019.121H16.695C17.245%2019.121%2017.695%2018.677%2017.695%2018.121V17.628C17.695%2017.075%2018.142%2016.628%2018.695%2016.628H20.572C21.124%2016.628%2021.572%2017.075%2021.572%2017.628V21Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_2440_7370'%3e%3crect%20width='81'%20height='26'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const fitforfun = "data:image/svg+xml,%3csvg%20viewBox='0%200%20148%20104'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_737_7551)'%3e%3cpath%20d='M76.751%2041.472H63.6061C64.1818%2037.8252%2066.5805%2035.0276%2070.5144%2035.0276C73.201%2035.0276%2075.3598%2035.8269%2077.2788%2038.7744L80.9248%2015.8943C75.9355%2014.3456%2073.153%2013.9959%2069.6989%2013.9959C54.3472%2013.9959%2042.9773%2024.4868%2040.3867%2041.522H34.7737L32.6149%2054.2609H38.2279L34.9656%2074.3934H58.1851L61.4473%2054.2609H74.5922L76.751%2041.472ZM147.993%2027.0346H138.302L140.844%2013.7462L103.473%2040.373H112.923L110.621%2056.0593C108.414%2069.6975%20117.337%2074.1936%20127.316%2075.4425C132.065%2076.042%20137.582%2073.8938%20141.18%2071.5958L144.203%2053.2118C142.38%2055.36%20140.269%2056.0593%20138.11%2056.0593C135.279%2056.0593%20134.032%2054.3109%20134.56%2051.0137L136.143%2040.373H145.834L147.993%2027.0346ZM105.535%2027.734C102.417%2029.4825%2098.4833%2030.3317%2093.7818%2030.2818C89.2723%2030.2318%2084.9546%2029.3826%2082.5079%2027.734L74.7361%2074.7431H97.9556L105.535%2027.734Z'%20fill='%23009FE3'%20/%3e%3cpath%20d='M90.1838%2023.088C90.8074%2013.8461%2090.3277%201.1571%2062.071%204.05458C43.457%205.95293%2019.518%2021.6393%203.49463%2031.181C3.44666%2031.2309%202.53515%2031.7805%202.53515%2031.7805C1.5277%2032.3799%200.61619%2032.5298%200.184423%2031.7305C-0.247343%2030.9312%20-0.151395%2029.7322%203.06287%2027.9838C19.5659%2018.0424%2042.8813%202.40601%2062.023%200.457709C91.7189%20-2.58964%2098.4353%2010.0993%2097.7637%2023.088C97.6677%2025.386%2095.8447%2028.3335%2093.9737%2028.3335C91.671%2028.2335%2090.0398%2025.436%2090.1838%2023.088Z'%20fill='%23009FE3'%20/%3e%3cpath%20d='M68.3076%2084.6845C68.3556%2083.4855%2068.3556%2082.4364%2068.3556%2082.3365C69.459%2081.6371%2071.1381%2081.5372%2071.8097%2082.0867C73.2489%2083.2357%2071.3779%2086.4829%2068.2117%2087.532C68.2117%2087.532%2068.2596%2086.0333%2068.3076%2084.6845ZM75.0719%2093.3769C75.0719%2093.3769%2070.1306%2090.8291%2070.2266%2090.7792C74.976%2088.5311%2077.7585%2082.2865%2073.5847%2079.0394C69.8428%2076.1419%2063.6061%2078.4898%2061.3993%2081.8869C59.8642%2084.2349%2063.0305%2086.383%2064.7575%2084.8843L63.6541%2095.3752C63.2223%2098.0229%2067.1562%2098.9221%2067.588%2096.2744L67.6839%2093.8765L73.153%2097.2235C75.5517%2098.5224%2077.5186%2094.6758%2075.0719%2093.3769Z'%20fill='%23009FE3'%20/%3e%3cpath%20d='M58.233%2095.0754C57.2736%2097.1736%2055.6424%2098.4225%2054.635%2097.9229C53.6275%2097.4234%2053.5796%2095.2752%2054.539%2093.227C55.4985%2091.1288%2057.1296%2089.8799%2058.1371%2090.3795C59.1446%2090.8791%2059.1925%2092.9772%2058.233%2095.0754ZM60.5838%2087.3321C59.1446%2086.383%2057.6094%2086.333%2056.1702%2086.9325L47.9186%2089.8799L48.974%2084.085L55.8823%2081.6371C58.4729%2080.7379%2057.1776%2076.2917%2054.587%2077.191C54.587%2077.191%2051.0849%2078.7396%2044.8963%2080.8877C39.4272%2082.7861%2034.7737%2084.3847%2034.7737%2084.3847C32.2791%2085.3339%2033.6703%2089.3804%2036.2609%2088.4811L44.4165%2085.6836L43.553%2091.3786C43.553%2091.3786%2041.5381%2092.078%2040.2428%2092.4777C39.1873%2092.8274%2037.5562%2093.277%2037.5562%2093.277C35.1095%2094.0763%2036.4048%2098.0728%2038.8515%2097.2235C38.8515%2097.2235%2040.0029%2096.7739%2040.7225%2096.5241C41.5381%2096.2244%2042.8813%2095.8248%2042.8813%2095.8248C42.8813%2095.8248%2042.5935%2098.1228%2042.3057%2099.6215C42.1617%20100.321%2041.9219%20101.42%2041.9219%20101.42C41.4901%20104.167%2045.6159%20104.817%2046.0476%20102.069C46.0476%20102.069%2046.2395%20100.72%2046.3355%2099.8712C46.6713%2097.7231%2047.295%2094.426%2047.295%2094.426L50.7011%2093.277C49.6457%2096.2244%2049.8376%2099.4216%2052.4282%20101.12C58.8087%20105.217%2067.0123%2091.5285%2060.5838%2087.3321Z'%20fill='%23009FE3'%20/%3e%3cpath%20d='M107.79%2091.0789L107.694%2090.3795L107.502%2089.2804C107.502%2089.2804%20107.263%2089.83%20107.071%2090.1797C106.831%2090.5793%20106.399%2091.1788%20106.399%2091.1788C104%2094.6258%2097.7637%2092.6275%2097.6198%2087.0824L95.2211%2087.8317C95.2211%2087.8317%2094.6933%2090.6792%2094.4535%2092.4777C94.3575%2093.227%2094.2136%2094.3261%2094.2136%2094.3261C93.7818%2097.1236%2089.8%2096.4242%2090.1838%2093.6766C90.1838%2093.6766%2090.4716%2092.4777%2090.6155%2091.6784C90.8074%2090.7292%2090.9993%2089.1805%2090.9993%2089.1805C90.9993%2089.1805%2089.6561%2089.6301%2088.7925%2089.8799C88.3608%2090.0298%2087.6411%2090.2796%2087.6411%2090.2796C85.1945%2091.0789%2084.0431%2087.2322%2086.4898%2086.4329C86.4898%2086.4329%2087.6411%2086.0832%2088.3608%2085.8334C89.6561%2085.4338%2091.7189%2084.7344%2091.7189%2084.7344L92.5825%2079.0893C92.5825%2079.0893%2088.7925%2080.2383%2086.3938%2081.1375C84.4269%2081.8369%2084.4269%2081.8369%2084.4269%2081.8369C81.8363%2082.7361%2080.541%2078.6897%2083.1316%2077.7904C83.1316%2077.7904%2083.8032%2077.5906%2084.187%2077.4407C87.6411%2076.2917%2090.1358%2075.1927%2093.0142%2074.2435C96.1326%2073.1944%2098.0035%2072.4451%20101.17%2071.1462C101.793%2070.8964%20102.801%2070.4968%20102.801%2070.4968C105.392%2069.5976%20106.687%2074.0937%20104.096%2074.9429C104.096%2074.9429%20102.993%2075.2926%20102.321%2075.5424C100.21%2076.2917%2096.9001%2077.4907%2096.9001%2077.4907L95.8927%2083.2357L99.4907%2082.0867C99.4907%2082.0867%20100.834%2081.4872%20101.65%2082.2865C102.561%2083.1857%20101.889%2085.6836%20101.889%2085.6836C101.506%2087.3321%20101.937%2088.0815%20102.849%2088.4312C103.712%2088.7809%20105.008%2088.2314%20105.583%2086.8326C105.583%2086.8326%20106.543%2084.4347%20106.639%2084.1349C107.311%2082.3864%20107.982%2081.6371%20109.373%2081.9868C109.997%2082.1866%20110.573%2082.6862%20110.669%2083.6354C110.669%2083.6354%20110.813%2085.5337%20110.957%2086.7327C111.148%2088.1314%20111.628%2090.3295%20111.628%2090.3295C111.964%2093.1771%20108.126%2093.7266%20107.79%2091.0789Z'%20fill='%23009FE3'%20/%3e%3cpath%20d='M111.964%2087.0324C111.964%2087.0324%20112.54%2083.7353%20112.923%2081.4373C113.451%2078.29%20113.595%2075.8421%20113.595%2075.8421C113.931%2073.5441%20116.138%2072.8447%20117.145%2074.843C117.145%2074.843%20117.337%2075.2426%20117.481%2075.4924C118.297%2077.0411%20118.584%2077.5906%20119.64%2079.439C121.271%2082.2865%20122.135%2083.5854%20122.135%2083.5854L124.101%2072.8947C124.341%2071.5958%20125.445%2069.2479%20126.26%2069.2479C127.364%2069.2479%20127.556%2071.2961%20127.124%2073.8439C126.692%2076.5915%20126.404%2078.6897%20126.068%2081.1375C125.445%2085.5337%20125.013%2089.4303%20125.013%2089.4303C124.581%2091.6784%20122.614%2092.078%20121.463%2090.0797C121.463%2090.0797%20120.024%2087.3821%20119.064%2085.6836C118.201%2084.1849%20116.761%2081.9368%20116.761%2081.9368C116.761%2081.9368%20116.282%2086.0333%20115.706%2088.2813C114.986%2090.8291%20111.58%2089.6801%20111.964%2087.0324Z'%20fill='%23009FE3'%20/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_737_7551'%3e%3crect%20width='147.993'%20height='103.834'%20fill='white'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const focus = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20341.4%20127.8'%3e%3cstyle%3e.st0{fill:url(%23SVGID_1_)}.st1{fill:url(%23SVGID_2_)}.st2{fill:none;stroke:%23008abf;stroke-width:.4;stroke-linecap:round;stroke-miterlimit:3.8637}.st3,.st4{fill-rule:evenodd;clip-rule:evenodd}.st4{fill:%23fff}%3c/style%3e%3cg%20id='Ebene_1'%3e%3cradialGradient%20id='SVGID_1_'%20cx='86.571'%20cy='79.346'%20r='56.42'%20gradientTransform='matrix(1.0234%200%200%201.0172%20-3.95%20-6.538)'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0'%20stop-color='%23fff'/%3e%3cstop%20offset='.084'%20stop-color='%23ecf7fe'/%3e%3cstop%20offset='.517'%20stop-color='%236fb2dd'/%3e%3cstop%20offset='.786'%20stop-color='%23007fb8'/%3e%3cstop%20offset='.933'%20stop-color='%2300538c'/%3e%3cstop%20offset='1'%20stop-color='%236fb2dd'/%3e%3c/radialGradient%3e%3cpath%20class='st0'%20d='M58%2088c0-21.8%2017.8-39.4%2039.7-39.4%2021.9%200%2039.7%2017.7%2039.7%2039.4%200%2021.8-17.8%2039.4-39.7%2039.4C75.8%20127.5%2058%20109.8%2058%2088z'/%3e%3cradialGradient%20id='SVGID_2_'%20cx='85.571'%20cy='72.455'%20r='68.206'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='.006'%20stop-color='%232ea860'/%3e%3cstop%20offset='.86'%20stop-color='%23002f1b'/%3e%3cstop%20offset='1'%20stop-color='%23445947'/%3e%3c/radialGradient%3e%3cpath%20class='st1'%20d='M88.4%2060.8l.4-.3.5-.1.2-.1.3.1h.2l.5.3-.2.1h-.7l-.8.5-.5.1-.1-.2.2-.4zm1.5-6.6l-.6.2-.1.3c.5%200%201%20.6%201.2%201l.4-.1c.2-.3.6-.5.9-.7l.1-.3c0-.1%200-.1-.1-.2h-.2s-.1%200-.1.1l-.4-.1-1.1-.2zm.2%205.4l-.4.1-.6.2h.2l.4-.1.3.2.3.2.2-.3.2-.3-.3-.2-.3.2zm-.1-.4l.3.3.4-.3-.3-.4c-.2.1-.7.3-.9.1l.2-.3-.7.2c-.1.3-.6.5-.8.5.2.2.5.4.8.4.3-.1.7-.3%201-.5zm2.5%202.4c.1-.2.1-.5%200-.7l-.3-.3.2-.7.6-.2.2-.9c-.1%200-.2%200-.3.1v.1h-.1c-.1%200-.1.1-.2.1%200%20.2-.2.5-.3.6l-.5.1c-.7.5-.1%201.5.2%202l.5-.2zm.4-2.9l.2-.1-.2-.1c-.1%200-.1-.1-.2-.1%200%200%200-.1-.1-.1s-.1.1-.2.1h-.1l-.1-.2-.3.2h-.1l-.2.1-.2.3.5.1h-.1c.2-.3.4-.4.7-.6H92.8l-.2.1-.1.3-.5.1c.3.1.6.1.9.1%200%200%20.1%200%20.1-.1l-.1-.1zm11.2%204.8c-.1-.1-.4%200-.5.1l-.3-1.3-.1-.2c-.4.2-1-.1-1.4-.1v.2l-.3.2-.1.1s-.1%200-.1-.1c-1-.6-1.1-.2-1.7%200-.2.1-.5.1-.8.2l-.1.3c-.8.7-1.1%200-1.7.3l-.2.3.1.2-.6.2.1.2-.3.5.3.1c.1.2.3.4.4.5.2.3.1.7%200%201.1-.4.9-1.3%201.8-1.3%202.4l.5.1-.4.2-.7.1-.2.9.5.3c-.6.9-1.1.8-1.6%201.4-.4.5-.7%201.3-1.2%203.1-.2.8-.2%201.3-.1%201.7.1.4.2.8.3%201.6l.5.3.4-.1c.1-.2.6-1%201.2-1.8.7-.9%201.4-1.9%201.6-2.1.5-.1.9%200%201.4.1.5-.2.9-1.1%201.6-1.4l.3.2c.6.1%201.7-.8%202.2-1.1-.2-.1-.4-.3-.4-.6%200-.1-.1-.2-.1-.2l.3-.5.1.4.3.2.3-.5c-.1-.6.1-1.3.3-1.9l.5-.4.3-1.2-.2-.6.6-.4c-.2-.2-.3-.4-.3-.7-.1-.8.6-1.6%201.1-2.2l-.5-.1zm-4.6%2014.2l.5-.1.6-.4.4-.6.1-.1-.4-.8-.2.1h-.7l-.3-.2H99l.1.6-.1.3v.9l.5.3zm-1.3%2011.2l1.1-.3.5-.8v-.7l.5-.6-.6-.7-.5-.1-.5.4-.7.6.1.5.1.4-.7.9.7.4zm-8.4-31.1v-.2c-.1-.1-.3-.1-.4-.1.2%200%20.5-.1.7-.2-.1%200-.3-.1-.3-.2.1-.2.4-.5.7-.6-.3%200-.7-.3-.8-.5-.2-.1-.5-.1-.7%200l-.2.3.1-.3h-.5c-.2.1-.3.4-.3.6l-.4.3.2-.7h-.2c-.4.3-.8.6-1.4.6.3.5-.2.6.2%201.3-.1.1-.1.2-.2.3-.1.2-.2.3-.2.5.2.4.7.3%201%20.2.1-.3.3-.5.5-.8.8%200%201.5-.3%202.2-.5zm11.5-9l-1%20.1%201.2.3%201.6.6%201.7.4%201.4.1%201.5.5%201.1.6%201.7%201v.2l1.7%201.1%201.5.5.4.3.7.6-.3.6%201%201%20.9%201.5-.8-.2-.6-.5-.5.1v.7l.1.1.8%201%20.9%201.5%201.3%201.3.5%201%20.6-.2.6.5-.4.1.1.9-.3-.1-.3-.1%201.5%201.3.3.2.5.1%201%201.2-.5-.6-.3-.2-.3-.1-.3-.3-.3.1-.5-.3-2.1-1%20.1.2.3.4.3.2.6.4%201.7%201.2-.1.3-1.7.3-.2.3.9.9-.9%201.6-.2%201.1-.1.6-.3-.6-.1-.2h-.9l.1.2.4.8.3.3.1.6-.4.8.2.8-.8.4.7.7-1-.2h-.2l-.4-.6-1.1-.8h.9l.9-.1.4-.8-.9-.9-.5-.1-.8-.4h-.9l-.6.2h-.2l-.4-.4-.3-.3h-.9l-.3.3-.3.3-.7.6-.2.9-.6%201-.4%201.2-.2.9v.2l-.2%201-.5.8-.9.9-.2.3-.8%201.1v1.3l.1%201.1.8.5.8-.5.8-.4.5%201%20.5%201%20.4%201.4h.7l.2-.7.7-.6.1-.3-.1-.6.1-1.1.2-.3.3-.5-.4-.6-.5-1.9.4-1%20.4-1%20.1-.9v-.3h.9v.3l.1.8-.6%201-.1%201.1v.2l.7%201.4%201%20.3.9-.1.6-.4.1.3-.4.1-.5.1-.2.2h.1-.1l-.2.1-.4.3.1.6.5.3v-.2l.1.6.2.6-.4.3-.6-.7-.3.5-.1.5.2.8.2.8-.5.4-.1.3-.4.3-.3-.4-1.1.8-.6.4-.9-.4h-.1l-.6.5-.4-.5-.1-.1v-1.6l-.1-1.1-.3-.1-.7.9.1%201.3.3.8.1.4-.8.4h-.9l-.7.9-.4%201-.7.6-.7.6-.8.5-.9.1-.3.3-.2.3-1-.2-.7.6.6.5.3.1.8%201.3-.1%201.2-.3%201.1v.1l-.9.1-.9-.2h-.1l-.3-.1-1.2-.1-1-.2-.5.4-.4-.7.1.9-.2%201-.6%201.1.2.8v.9l.8.2.5.5.3.4h.7l.5-.1h1.4l.4-.3.4-.2.7-.6.4-1%20.7-.9%201-.7.7-.7.1-.5.8-.4%201.3-.1.8-.4.6-.4.2-.2.2.2.7.4.4.6.4.6%201.1.6.8.5.8.2.3.8-.2%201%20.7-.9-.2-.8.8-.4.4-.3-1-.4-.5-.3.1-.3-.3-.3-.5.1-.8-.5-.6-.7-.1-.1-.4-.7-.1-.4.7-.6.3.2.2.4.6.5.8.5.1.1.5.3.8.5.6.5.1.9.6.5.7.9.1.4.3%201h.7l-.1-.6.2-.9.5-.6-.7-.2-.1-.4-.2-.8.6-.4.8-.4h1.9l.1-.3.1-.2-.6-.7.2-1-.1-1.3.5-1.3.1-.3.1-.2.4-.1.9-.1-.2.5-.1.3.5.3.4.3.5-.9.1-.2v-.2l-.4-.6.5-.8.5-.8.3.2v.6l-.2.9.4.5%201%20.4h.7v.1l.3.6.1.4-.4.8-.7.6-.4.1h-.9l-.8.2-.8.5-.8%201.1-.8.5v.1l-.5.9-.8.2-.2.9.2.8.5.3.5.8h.7l.9-.7%201-.3.8-.2.7-.7h.2l.1.2.1.9-.1.5v1.6l-.2.6-.2.4c-.3.1-.5.4-.7.6l-.7-.2c-1%201.8-3%201.1-3.6%201.7-1.2-.6-4.1-.2-3.6%201.9l-.5.4-1.1-.6-.6.2c-.5%200-1.1-.3-1.2-.8-.7-.2-2%200-2.4-.2l-.3-.4-.5.1c0-.6.5-.9.5-1.5l-.2-.6.2-.7-.4.1-.5-.3c-.3.1-.7.2-1%20.3-.4-.2-1.5%200-2%20.1-1-.4-4.5.6-5.4%201.3l-.3-.1-.1-.2c-.7%200-1.3-.1-1.9-.3l-.3-.4c-.4.1-1%201.1-1.2%201.5-.9-.1-1.8.4-2.4%201.1%200%20.4-.3.8-.5%201.3v.2c-.3.6-1.5.7-2.2.9l-.3-.1c-.5.1-4.1%202.8-4.7%203.7-.1.1-.1.2-.1.2.2.2.4.4.6.7-.2.3-.4.6-.4%201l.3.4c-.1.3-.8.9-.8%201.1-.2.2-.5.3-.8.4%200%20.3.2.6.3.8-.4%201%20.6%201.6%201.3%201.9l.1.4c.4.2.5.7.9.9-.2.2.2.4.1.6l.3.4c.8%200%202.3%202.3%204.5%202.3%201.4%200%202.6.3%204%20.4%202.2.1%203.7-.8%205.9-.2l.3.4c.5.2%201.9%200%202.4-.2l.3.2.4-.1c.6.5-1.7%201.8-1.1%201.9l.3.1.1.2%201.2.3-.2.3.4-.1v.1c9.9-2.2%2018.5-8%2024.1-16%20.1-.3.2-.5.3-.6.2-.3.3-.7.5-1%20.2-.2.1-.4.3-.6.1-.1.1-.2.1-.3l.1-.2.1-.2-.1.1-.2.2-.3.5-.5.6c-.4.4-.6.8-1%201.2l-.7.9c-.2.3-.3%200-.4-.1.7-.8-1.1-.4-1.2-.5-.6-.5%200-.7-.9-.9l-.1-.2c.3-.7-.1-1.3-.7-1.4-.1-.2-.2-.4-.3-.5-.1-.1-.1-.3-.1-.5h-.2c-.3-.5-.6-1.2-1.1-1.5l-.2-.8c.3.2.4.5.7.7l.2-.1.3-1.2.3%201%20.7.7.4.6.5.1.4.5-.1.5.3.2v.2l.5.1.4.5v.2l.4.5.1.6v.7-.2l.9-.7.5-.8.2-.3.7-1%20.1-.1.6-1.1.6-.9.4-1.2.2-.3.6-1.1.3-.8.3-1.2.1-.3.3-1.2.3-1.2-.1-.2-.4.3-.3-.1-.2-.8-.3%201.2-.3%201.2-.5.8-.3-.1-.1-.2-.2.3-.3-.4h-.2l-.4-.5-.1-.2v-.3l.6-.7h.3l.5.3.6-.4.5-.8.4-.4.4-.1.3-.6.5-.6v-.2l.4-1.2.1-.5.4-1%20.1.2v-.4l.1.2.1.2.2-.3-.1-.4v-.2l.1-.5.1.1c.1-1.1.2-2.2.2-3.3-.1-20.8-16.1-38-36.1-39.8zm-23.1%2073.5v-.2c0-.2-.4-.7-.5-.8v-.2c-1.6-1%20.2-1.7.5-2.9-.6-1-3.5-3.1-3.5-3.2-1.6-.7-3.1-1.6-4.5-2.8-.4-.3-.8-.7-1.2-1.1-.1.1-.4.2-.6.2l.1-.5-.3-.2c-.3-.2-.7-.4-.9-.6-.1-.1-.1-.4.1-.3l.1-.3c-.2-.3-.6-1-1.1-1.9-.8-1.5-1.9-3.4-2.7-3.3-.2-.2-.3-.5-.4-.8l-.3-.4v-.4c-.1-.2-.2-.3-.3-.5-.4-.7-1.8-3.5-2.7-5.2-.4-.7-.7-1.2-.7-1.3v.4c-.1-.7-.4-2.5-.6-3.8-.1-.6-.2-1.1-.2-1.3.7-1%20.5-2.3.3-3.5-.1-.3-.1-.5-.1-.8.1-.2.6-1%20.8-1.1%200-.4.4-.6.4-1l-.3-.4c.2-.6%200-1.2-.1-1.8-.2.2-.4.1-.5.1.1-.2.1-.4.2-.7.2-1%20.2-2.3.6-3.2.2-.7.5-1.1.8-1.6.1-.2.3-.4.4-.7.1-.1.1-.4.1-.5l.5-.4c.2-.1.3.3.4.5-.1.3-.1.7-.1%201.2%200%20.7%200%201.5.1%202l.2-.1c.1.1.2%201.8.2%202%20.2.2.4.6.5.9-.1%201-.9%202.5-1.2%203.6l.3.4c1-1%20.8-2.9%201.8-3.9l.4-.1c.6.5%201.5.3%202.1.9.3%200%20.7-.3.8-.5%200-.1%200-.3.1-.4.1-.3.3-.6.4-1%20.2-.2.4-.4.6-.5-.3.3-.4.8-.5%201.2-.1.1-.3.2-.4.2%200%200%20.7-.3.8-.4%200-.3.2-.7.4-1l-.1.5.3.3c1.1-.7.6-.6%201.4.1l.1-.3.1.4c.2.2.6.5.8.2.2-.2%200-.1-.1-.1.8-1%20.3-.5%201.4-.7.3.1%201.4.6%201.4.9.1%200%20.2.1.2.2h1.2v-.6c.3-.3.7-.9.6-1.3l.7.2.2-.7-.4-.6-2.8-.8c.6-.3%201.4-.4%202.1-.4l.1.2%201.1.1c.7.7%201.2%201.6%202.2%202%20.4-.1.8-.1%201.3-.1l.6.5c.4-.3.9-.7%201.2-1.2l-.2-.6.3-.6-.3-1.2s0-.1-.1-.1c0-1.2%201.3-2.5%201.4-3.8l.5-.4c-.7-.1-1.3.6-2.1.4-.1-.2-.1-.5%200-.8%200-.2.1-.4.2-.6l1.5-1.3c-.2-.4.1-1.1.3-1.4l-.5-.8v-.7c-1.2.1-2.2%201.5-3.5%201.9l-.2.7c-.7.9-1.9.8-2.8.8-.3.4-.8%201.1-1.3%201.4-.1.1-.3.1-.4.1V72l-.2-.4c.8-.7.8-1.5%201.9-2.1l.3-.6-.4-.9c.2-.7.4-1.3.5-2%20.1-.5.1-.9.1-1.5.5-.2.9-.6%201.3-1l.1-.3c.6-.4%203-.7%203.7-.4l.2-.1.5.3v.2l.6.3c.6-.2%201.1-.4%201.7-.5v.7l.7.2c.5-.2.9-.4%201.4-.6l.3-.5-.1-.4c-.4.1-.9.2-1.3.2l-.5-.3c.2-.1.4-.1.5-.2.3-.1.5-.3.7-.6l-.3-.2c.7-.5%201.5-.9%202.1-1.5-.5-.1-1%200-1.5.2l-.5.6c-.3.2-1.2.1-1.6%200l.8-.4.3.1.6-.4c-.1-.2-.4-.3-.6-.3l-.6.2-.3-.3c0-.5.4-.9.5-1.3V58l-.5-.3.5-.4c.1-.2.1-.5%200-.7l.4-.3.5-.1c.2-.5.8-1%201.3-1.1l.1-.3.4-.3-.2-.2-.1-.1.8-.2v-.2l.4-.3c-.3-.7.3-.9.3-1.2%201.9-.5%203.4-1.4%205.3-1.5l.1-.3c.2-.1%201-.7.9-1-1%20.1-1.2-.3-1.2-.3l.2-.3-.4.1-.6.3c-.1-.2-.3-.3-.5-.3v-.2C73.8%2050.9%2058%2067.7%2058%2088c0%2014.6%208.2%2027.4%2020.2%2034.3zm10.7-60.2l-.5-.1c.1-.4-.5-.2-.5.1v.2c.1.3.2.5.3.8l.3.2c0%20.2.1.4.2.6-.2.3-.5.5-.9.7l.3.4-.1.5c-.4%200-.7.4-1%20.6h-.1l-.5.1-.3.5-1-.2.2-.3.1-.1-.5-.1h-.5l-.2.1c.8.4.7%201.6.2%202.2.1.7.2%201.4.2%202%20.3-.3.4-.8.4-1.2l.3.1.1.4.6.3c.4-.3.4-1%20.3-1.4.3-.1.7-.8.9-1l.3.2c-.1.5-.3%201.1-.2%201.6.4-.3%201-.4%201.4-.8-.1-.7.3-1.5.1-2.1.4%200%20.7-.3.9-.6.1-.1.1-.2.1-.3-.1-.5.2-1%200-1.4.4-.7.8-1%201.2-1.5.1-.1%200-.4%200-.6v-.4c-.1-.6-1.6%200-2.1.5zm-6.3%202.6c0%20.2-.1.5-.3.6l1%20.2-.3.5.1.4c.2-.1.3-.3.4-.4.5-.6.6-1.3%201-2-.6.3-1.3.6-1.9.7zm11-7.2l-.4.1-.2.3c.4%200%201.2-.2%201.4-.6-.1-.6-.6-.1-.8.2zm7.4%2033.1l1%20.1%201.1-.1.5-.4.5-.6-.1-.9-.7-.9-.3-.6-.2-.4-.3-1.1-.4-.6.6-.9-1-.4.4-.8-.5-.1h-.2l-.5.8-.2%201%20.1%201.1.3%201%20.4.7.1.1-.5.4-.4%201v.7l-.1.3-.9.7.3.2%201-.3zm-7.7-35.5c-.2%200-.4.1-.6.2l.5.3v.2c.1.2.4.3.6.3l.1-.5c-.2%200-.6-.2-.6-.5zm14.9%209.5l-.3-.1-.5.1v.7h.9l-.1-.7zm-.9%201.4l.4.5.5.8.5.3v-.7l.1-.5-.2-.4-.2-.4-.7-.2-.6.2.2.4zm11.6%2036.5h.1l.7-.2-.5-.3-.4.1-.8.2.9.2zm-7.2-43.6l-.1.3.6.3.7.2.3-.5-.6-.3h-.9zm-.9-5.2l-.2.3.4.5.3.1.3.1v-.1l.1-.3-.5-.1-.4-.5zM115%2066l.2.4.1.2.1.4.5.8.3.2.8.4.6-.2-.5-.3-.7-.7-.7-.9-.1-.3-.2-.7-.2-.8-.1-.4-.4-.8-.4.3v.7l.3%201%20.4.7zm-3.2%2036.7l.2-.1.5-.4-.4-.6-.6.2-.3-.1-.3.6.6.3.3.1zm1.7-44.3l-.6.2h-.2l.3.2.8.2-.3-.6zM81%2080.7l-.1-.2c-.2%200-1.1.5-1.9.9h1c.4-.1.8-.3%201-.7zM72.9%2082l.4.5.5-.1c.4.4%201%20.4%201.5.6%200-.4-.2-.9-.5-1.2v-.3h-1.2c.1.1.3.3.3.5-.1-.2-.7-.1-1%200zm21.2-22.4c.7.1%201.8-.5%202.2-1.1-.4.1-2.9-.3-2.2%201.1zm14.4%2038.1l-.4.3-.1.3.4.5.1-1.1zm-12-38l-.5.2-.3-.3-.2.4c-.3.1-.7.1-1.1-.1l-.2.3-.5.1.4-.3c-.3.1-.7.1-1.1-.1-.1.2-.1.5%200%20.7l.3.2-.1.3.3.2c.3-.1.7-.2%201-.3.8.4%203.4-.4%204.4.1l.2-.1c.4-.8-.6-1.2-.8-1.8-.6%200-1.9-.8-1.8.5zM79.8%2082.2l.2-.8h-1c-.6.3-1.1.6-1.3.7-.1%201.1.8%201%201%201.7l-.2.7h.5c.1.3.1.6.1.9.3%200%20.7-.3.8-.5%200-.2%200-.6-.2-.8l.5-.4-.1-.4.2-.3c.1-.3-.2-.7-.5-.8zm28.2%2019.1l.6-.4.1-1.1-.4-.6-.2.3-.2.7.1%201.1zm-46.6-9.9l.3.1-.1-.2c0-.3-.3-2.5-.6-4.1-.2-.9-.3-1.6-.3-1.6.2-.3-.5-.7-.5-.8%200%20.4.1.8.3%201.1-.1.2-.1.9%200%201.4%200%20.2.1.4.2.4%200%20.3.3.8.2%201.1l.2.6-.3.6c.1.1.6%201.3.6%201.4zm.5%203.2c.2%200%20.4.2.5.3l.1.4c.3.1.5.6.5.8l.1-.3c-.4-.9-.5-2.6-1.2-3.4-.1.2-.2.6%200%20.9h-.2c-.1-.3-.2-.6-.4-.8l-.1.5c.4.2.6%201.2.7%201.6z'/%3e%3cpath%20class='st2'%20d='M92%2058.2c1-4.5%207.5-6.9%2014.3-5.3%206.9%201.6%2011.5%206.8%2010.4%2011-1.1%204.5-7.4%206.9-14.2%205.3-6.9-1.5-11.6-6.5-10.5-11zm-12%202.5c2-8.7%2013.4-13.2%2026.9-10.4%2012.1%202.5%2021.5%2012.2%2019.4%2020.9-2%208.7-13.9%2013.7-26.8%2010.7-13-3-21.6-12.5-19.5-21.2zm55.2%2040.7c-6.2%2013.1-25.1%2020.4-44.1%2015.8-21.4-5.1-35-21.6-32-37.4m61.8%2040.3c-8.2%204.6-19.5%206.2-31.1%203.6-15.6-3.5-26.5-14-30-24.9m77.4-15.7c-.1%202.1-.3%204.8-.5%205.6-3.6%2015-22.6%2023.5-42.9%2018.9-20.4-4.6-34-21.3-30.6-35.9.5-2.3%201.3-4.9%202.6-6.9m64.5.8c2.6%204.5%203.9%2010.1%202.8%2014.6-2.9%2012.1-19.3%2018.7-36.8%2014.8-17.4-3.9-28.8-16.9-26.2-29.5.7-3.5%203.5-7.3%206.3-9.9.8-.7%201.6-1.5%202.5-2.2m25.9%209.1c0%2017.6-2.3%2054.1-8.6%2065m9.8-65c4.2%2012%2011.6%2050.4%202.1%2063.7m-.9-63.8c7.6%2010.8%2022.3%2045%2011.2%2059.4M108.1%2062c12.7%2011.6%2027.3%2037%2020.3%2051.1m-18.9-53.3c9.5%201.8%2020%205.9%2026%2016.3M109%2061.5c14.2%208.1%2029.5%2027.3%2025.5%2041.6m-25.1-42.4c11.1%204.3%2024.8%2012%2028%2028.2M109%2058.8c6.9-.3%2015.7%201.5%2022.1%207.9m-23-8.7c4.7-1.2%2012-1.3%2017.1%201.9m-18-2.6c3.4-2.2%208.3-3.3%2011.9-2.3m-12.9%201.8c1.8-2.8%204.7-4.6%207.1-4.9m-8.1%204.6c.8-2.5.8-5.5.2-7.1m-1.3%206.9c-.6-3.2-2.7-6.5-5.3-7.7m4%207.6c-2.6-3.4-6-6.6-11.2-7.1m8.6%208c-6-2.8-16.2-5-26.1-.5m25.5%201.3c-8.6-1.9-24.5-3-34.4%207.8m34.3-6.8c-14.3-.3-34.4%204.1-40%2019.3m40.4-18.4c-18.6%203.3-41.2%2015-41.6%2031.5m42.2-30.7c-14.6%205.6-39.9%2021.6-39.8%2041.2m40.7-40.6C86.6%2071.3%2063.2%2096.7%2067%20112.7m35.4-50.9c-10.2%2012.9-29%2044.1-27.1%2058.6m28.2-58.2c-4.5%2012.7-16.7%2048.9-18.1%2063.1m16.1-68.9c-4.5-3.6-12-6.4-18.6-4.8'/%3e%3cpath%20class='st3'%20d='M0%20126.5h39.5v-7.9H27.9V82h14.9v10.2h7.9V65.4h-7.9v9.4H27.9V45.6h29.7v9.7h7.9V36.1H0V44h9.7v74.6H0zM291.4%20126.5h6l2-4.4c6.1%204.3%2011.7%205.3%2017.4%205.3%2016.1%200%2024.5-9.3%2024.5-24.1%200-25.6-40-22.2-40-38.3%200-4.9%204.8-9.5%2012.3-9.5%208%20.1%2016.8%206.1%2016.8%2015.5h6.6V51h-5.9l-.5%204.4c-3.6-3.4-11.8-5.3-18.2-5.3-10.8%200-21.9%206.1-21.9%2021.6%200%2027.6%2038.2%2020.8%2038.2%2039.3%200%207.6-6.8%2011.1-12.8%2011.1-10.6%200-18-8.4-18-16.1h-6.6v20.5zM209.3%2051.1h-6l-1.8%206.7c-5.9-5.9-13.7-7.5-21.4-7.5-22.6%200-36.8%2018.5-36.8%2038.7%200%2020.2%2013%2038.7%2039.1%2038.7%208%200%2017.8-1.2%2029.3-13.3v-.9l-4.1-4.3h-.9c-5.6%207.8-12.8%2012.5-21.2%2012.5-15.1%200-24.9-14-24.9-31.8%200-15.4%204.9-32.9%2021.6-32.9%2010.9%200%2018.4%206.4%2020.5%2016.2h6.5V51.1zM215%2057.8h8.1V101c0%2019.7%2015.8%2026.9%2030%2026.8%2019.7-.2%2026.6-11.5%2026.6-28.5V57.8h8.1v-6.7h-22.2v6.7h8.1v40c0%2019.1-8.9%2023.3-18.6%2023.3-9.3%200-16.7-4.8-16.7-17.9V57.8h8.1v-6.7H215v6.7z'/%3e%3cg%3e%3cpath%20class='st4'%20d='M276.6%2036.1V18.9c0-1.4-.2-2.9-.5-4.5l-.3-1.3c1%202.2%201.2%202.8%201.7%203.5l1.1%202%201%201.9%209.7%2015.7h8.9V.6h-8.9v10.5c0%202.9.3%206%20.9%209.3-.9-1.9-2.2-4.4-3.7-6.8l-8.3-13h-10.3v35.5h8.7zM303.6%2018.7c0%2010.8%206.9%2018%2017.3%2018%205.1%200%208.9-1.5%2012-4.8%202-2.1%202.8-3.6%204.1-7.4l-9.4-.7c-.7%203.7-2.8%205.6-6.3%205.6-4.1%200-6.8-3-6.8-7.6%200-.5.1-1%20.1-1.6h22.6c-.1-6.6-.6-8.9-2.9-12.6-1.9-3.4-5.3-5.8-9.3-6.8h-9c-7.5%201.8-12.4%208.6-12.4%2017.9zm17.5-12c3.8%200%205.5%202.1%205.9%207.3h-12.4c.5-5%202.6-7.3%206.5-7.3zM243.6%2036.1v-8.7h-10.7V.6h-11v35.5zM248.8.6h11v35.5h-11zM143.4%2018.4c0%2010.9%206.8%2018.3%2016.9%2018.3%2010.1%200%2016.9-7.5%2016.9-18.6%200-9.1-4.6-15.5-12-17.4h-9.5c-7.6%201.8-12.3%208.4-12.3%2017.7zm17-10.3c3.4%200%205%203%205%209.3v1c-.1%202.9-.4%205.3-.8%206.8-.6%202.1-2.2%203.4-4.4%203.4-3.5%200-5.2-3.2-5.2-9.9%200-6.9%201.9-10.6%205.4-10.6zM192.4%2036.1V18.9c0-1.4-.2-2.9-.5-4.5l-.3-1.3c1%202.2%201.2%202.8%201.6%203.5l1.1%202%201%201.9%209.7%2015.7h8.9V.6H205v10.5c0%202.9.3%206%20.9%209.3-.9-1.9-2.2-4.4-3.7-6.8l-8.3-13h-10.3v35.5h8.8z'/%3e%3cpath%20class='st4'%20d='M330.4%203.1c-2.7-2-6.1-3.1-9.9-3.1-3.8%200-7.2%201.1-9.8%203.1h19.7zM170.5%203.1c-2.8-2-6.2-3.1-10.2-3.1-3.9%200-7.4%201.1-10.1%203.1h20.3z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "bf-brand.icon",
  props: {
    brand: { type: null, required: true },
    small: { type: Boolean, required: false, default: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const sources = {
      bunte,
      chip,
      focus,
      fitforfun
    };
    const src = computed(() => sources[props.brand]);
    const classes = computed(() => ({ small: props.small }));
    const __returned__ = { props, sources, src, classes };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$6 = ["src", "alt"];
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("img", mergeProps({
    src: $setup.src,
    alt: $setup.props.brand,
    class: $setup.classes
  }, _ctx.$attrs), null, 16, _hoisted_1$6);
}
const bfBrand_icon = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o], ["__scopeId", "data-v-0dcc3bfb"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-brand.icon.vue"]]);
const bunteDisabled = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAX1JREFUeF7tW8ENgzAQCxswAiMwApvDCIzACGzQ6qqeVFWQQ5Gj6HKOhHhEqD3H9gUDw7qurxR4DASADKAE6AGBPTDRBNkFwF1gWRa4os7zTMdxJDmjB1wCNQDQogWAfd+hGLgCQCoXJsiBGu4AkMK3bUPVj+8CNSWgVYsMUH7gkgEEgAxwLoErFx/H8SNxPedczr0EcgU8MVEC4N0Dcis4z7Mpg64ZQADIAEqAHmDtBbo1QSlcTNAaXQDwX6QUr0f3AFgFWvPuGWAVaM2HDkSQqy9AuwlE0FmgsswFABqJo2KwX4m5AED/cA0WuAKAsfiXCu67wJ2WrS2wSsE9AHetbJqmJIc1kK2wiQcwE8xkekyEmAgxEWIiZLXDrrsATZAmGNgEw4Sici9wdT/wZBss22T3Jmjt9a15AuD98bi1wtY8GRCdAe4DEYviuXl0MNokECkFIPTL0uiVr/ZgpHR1W10Hl0CrQkp/lwDwmyHwN0OlVGx1HSVACQSXwBswHm1fUrZVeQAAAABJRU5ErkJggg==";
const bunteActive = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAZBJREFUeF7tW7EOgkAMPRKVjc3Nb4FF/0odxL/SBX5FNzc24qCpkcRIoOQouZS+W0xUIn3te9e+k+i2Wryc4RUBAFQAKAANMKyBDiKIXUB4F9jUT3FG1WXhqjx39Cq9xCkwBQBN0ATAY7cVxUAVABR5dc5dlZ/EQFAHAEV+j5e2ASAaSOmBygoAAKgA5RQgJf9fcZp+3orTjBU49RToC2BIHwEAtGtAXwbXlytLg1lXAABABYAC0ACuF5itCFLgJILcmgUArU4wyxx1g1z26Tr1AHAZ5j43D4BpQ0Qy+1RpagwRaS+woZkKACj4uijEbLBfjVEBQHPDU1SBKgBgi39LQf0u0GVpD2mCZnEu0LWVJYejS/YHrg/S3wnCE+zx9OAIwRGCI8SOxJLzQJBGCLY4RLD7cBO7gOVdwIwpSrNAXZatlndIGwxTFK4wbHH90yA77zJfUN8JjgVAvSM0BgBpYzTILOALgOk/S0tnfrKDEd/shrpOnAKhAvH9XQCAZ4aEnxnyLcVQ14ECoIBxCrwBIWkZX8lngV8AAAAASUVORK5CYII=";
const chipDisabled = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAe9JREFUeF7tm9sNwyAMRekGGSEjZIRsnoyQETJCNmjlD6SqUnOvVeNi4Uj5ggZ8/MBg+ti27VkGfh4JIC0gXSBjwMAxsKiC4DRNIVhd10XPkwIwz3ORN9JznmeRFz0QQEThq9AMBAhgWZYSxfQ/tS2ucBzHrRFAAOu6Iivqun3f9wRwRyAtAO0F0gUyBuiCYE1CNMkIG0VlNdKuSK5BUJacFoK/AxIAkpuwINwAMEkHq2nUT4SX/IR53AB4aP9dYDY4uwFAAzHa0vRJAOTqhBRjlgihgTTaZfoObwHMJo0JzGEtQKzk7oxClmNmSQ4NgHEV1CcBWG2GvIMg0izbbmYBTMBhJ+XZzwyATDoiBFMAESGYA4gGoQmASBCaAYgCoSmACBCaA+gdgguAniG4AWDKVJ4JUB0rAVjtBZD20gKISi2C2KI9XSCqC6ACiWzMmFOhsBbAnAkycScsgO5OhVGAYrSBvtF1ZQhNfngAAsiqfqi5uYbOKt1igACwsAJNZVjG7ApAdROmYPHNpdh7AfX3XQJA8cKyPQHkPcG8KHnrUa6rgKVvs9/6OQYwOTc7Ge9+zLILLUCTdHgLiMZjSnUQgAwSEQIjvMhGAaiktUkI0lCrdk2ipQLQasL//G4CQEdi/9SOx9hpAWkBg/95+gUEaApf5SQvGgAAAABJRU5ErkJggg==";
const chipActive = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAhNJREFUeF7tm71RgzEMhp0iTRoa5oBsAAWMAZcRKBiDghFyMAYNIwBrQEOTJgWcCt/lOPK9r0BWrLO+1o5tPfr1T2bvF2dfZeBvlgDSAtIFMgYMHAOLKgjOT5chWG1fX+h1UgAW16uyuFrRg/bQcfO4LpuHNVwKBBBR+Co1AwECOLq7L1FM/6e6xRU+b28mrQACOH56hmbUc4ePy/MEMEUgLQDtBdIFMgbogmAtQrZvfDHCBtH5yVKdkVyDoKQcTRXGCr7bT1KyFGVsanYDwBQdfxH4t9+I8FKfMJ8bAA/t7wrMBmc3AGgiRluaPgmAzE5IMWaFEJpIo12m7/AWwGzSmMAc1gLESmSrvu+TdMyk5NAAGFdBfRKA1WbIOwgizbLtZhbABBx2UZ79zADIoiNCMAUQEYI5gGgQmgCIBKEZgCgQmgKIAKE5gN4huADoGYIbAOaayrMAqnMlAKu9ANJeWgBxU4sgtmhPF4jqAuiCRDZmzKlQWAtgzgSZuBMWQHenwihAMdpAY3R9M4QWPzwAAWR1f6h5uYbOKt1igACwsALNzbDM2RWA6ibMhcU+l2LfBdTfdwkAxQvL9gSQ7wTzoeSkR7lmAUvfZsf6dwxgam52Md79mLQLLUBTdHgLiOZjruogAJkkIgRGeJGNAlBJa4sQpKFW7ZpCSwWg1YIPOW4CQEdih9SOx9xpAWkBg/95+htg0taQyY/tqAAAAABJRU5ErkJggg==";
const fitforfunDisabled = "data:image/png;base64,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";
const fitforfunActive = "data:image/png;base64,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";
const focusDisabled = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAABRpJREFUeF7tm61PJEEQxecSBAKBQCAQCAQCgUAgEPzpSAQCiUAgEAgEAoEg4fKb5F0qff1R1dPDXcJMMmGX7Znu9+rVR9fs/vr6+vqafvDxayNgU8DmAlsM+MExcNqC4JYFvjELvL29TZyvr6/T5+fntLOzM5/22N/fnz4+PqbDw8OJ12sfq7sAgB8fH2fAALPH8fHxxGkPxnO8vLzMJ0Ts7u7+NW4UMasRAJCHh4d5nRY4VgW017rPz88Tp1Rxeno6Cvt8n+EECDhWkzXtis/Pz+f/p5YvoWIsZD09Pc0nr0XiCCaGEsACkW0qdS1UVo8owIK8v7+fyYNc7jVCDcMIYHEAL4HHlyEn5/deS0oFllAUteRYTAAWYWEEuff39+JaclZnPNdx1FxC0tdcdhLUcHl52c3BYgKwfAs8q5PfAppzb29vTofWLRgnny8hkhuMImERATWfl0UFiL8HBwdzSrRuoNqAe0kJrQB5c3PzFz8Q2eMO3QTUwKeLsSRgwevr6z8A+Iz/pX6tDCKF2Pc5FXA9cSYaGLsIALwsl5MqlrB5Xr6r9GctnBJgr2UeO1bva/Onc7eCQzcBkmyNAEVtLI5sczk8tWYNQKqk3NzRoBgmoGV9BTsbsSEgF9xS6wPIukckEKbFlrfSDBOQC0B2ciRr1VGzaGr9UiCzFWCOtJSoiApCBLSsn7NYCVQKpFQgpSSlBJdU4o0FYQKo9KjovEcLmD73uEiaEWpr8KogRADyh1mbtlpElCzBPeymRvdOs4fG5TZW30qA0h4LrBEgUBpTIqBV8QFO8vfKPiXE4wZuBdhApECotGZrdU0KQEreo6Ojlkiyn1vf7yXAUx2GCKB9BSAL2BYqNC6o8aWS3m0vjNhsox5CrfaIBGA71k2AfFE+2sqzqY97ZABo1QF2j9BLgCcQugm4u7ubTk5O3LL2+LglRWnRFkJ2g1Sq/5cGwhABFxcXs/xbuzWPtVPwAmszg1xN9Uf0vrjs1dVV9bIwAdFFeMYrxdnMEUm1tTlapXWYgKi0PQRojA1ynoDXKoyGKgCL9DQcvASkjZHWdamr5AqloUEQAujokAbXUkHa9PRI2/Ya0vGeBqzbBVic6oCWdXo/zxGQk7kKnFpmwPp0iFoB200ATPOkZ0kHNkeM0h+gbNuL9xBODzGtAwBV60gxD+A9zxfdBHDT29tbF6sRBeS2u7ahqj2BSJD7KUXyufV/VZ9p77G0phABWmwrtfQSUKvdBVzBuNUe8zZIQwQwKb2AkU9rFcS0sbKuAJF6Xyq9S88JPP7P/UMEcAElMbs8z1bTowRLAONt/s8pwrpALQ54VRomwKYd7yQlIjxpT7WHlJBWiIoXIs4b/bWmMAEKShDhybNLwHsUxBhI0n7B0wOw9+0iQCmR/mBUBR6re4FrnAxBloKAyNOhLgLkqzYgtvoDusZT40cJYDzS54yW690EWFfgtccdWs8UeoDrmqj0F8UAu1Bkpy9FtPL4qC1uSpRn1zekEMrdJPekJpci17I+4M/OztxfukoxLHIBezPVB/pfGhzXCH6e7W7LrYYRwERsllBEKRiNJKHX51dTgG4skK1HYi3LlD4f+Q0x5hiqALvoGhEqYe32l2vtri7X4fFucCLkrkaAVYTA2Q1PbZG4kh7Ajrb46i5QA6YiKGddex3fOsPavY/V/isFRBbzL8au7gL/AlRkzo2A7Rcj3/iLkYg0v2vs5gKbC2wusP109kf/dPY37FbFfXn++ucAAAAASUVORK5CYII=";
const focusActive = "data:image/png;base64,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";
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "bf-brand-based-state",
  props: {
    brandStates: { type: Array, required: true },
    brandIconSizePx: { type: Number, required: false, default: 35 }
  },
  emits: ["brand:click"],
  setup(__props, { expose: __expose }) {
    __expose();
    const iconMap = {
      bunteDisabled,
      bunteActive,
      chipDisabled,
      chipActive,
      fitforfunDisabled,
      fitforfunActive,
      focusDisabled,
      focusActive
    };
    const props = __props;
    const brandStateImages = computed(() => {
      return props.brandStates.map((brandState) => ({
        image: brandState.active ? iconMap[`${brandState.brand}Active`] : iconMap[`${brandState.brand}Disabled`],
        brand: brandState.brand,
        isActive: brandState.active
      }));
    });
    const __returned__ = { iconMap, props, brandStateImages, get QImg() {
      return QImg;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    mergeProps({ class: "row inline no-wrap" }, _ctx.$attrs),
    [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($setup.brandStateImages, (brandStateImage) => {
          return openBlock(), createBlock($setup["QImg"], {
            key: brandStateImage.image,
            src: brandStateImage.image,
            position: "center",
            width: `${$props.brandIconSizePx}px`,
            height: `${$props.brandIconSizePx}px`,
            "data-qa-state-icon-active": `${brandStateImage.brand}:${brandStateImage.isActive}`,
            fit: "cover",
            ratio: "1/1",
            class: "q-mr-sm",
            onClick: ($event) => _ctx.$emit("brand:click", brandStateImage.brand)
          }, null, 8, ["src", "width", "height", "data-qa-state-icon-active", "onClick"]);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ],
    16
    /* FULL_PROPS */
  );
}
const bfBrandBasedState = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-brand-based-state.vue"]]);
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "bf-entity-no-edit-icon",
  props: {
    tooltipLabel: { type: String, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = { get QIcon() {
      return QIcon;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(
    $setup["QIcon"],
    mergeProps({
      color: "primary",
      name: "mdi-pencil-off-outline",
      size: "x-large"
    }, _ctx.$attrs),
    {
      default: withCtx(() => [
        $props.tooltipLabel ? (openBlock(), createBlock($setup["QTooltip"], {
          key: 0,
          anchor: "top middle",
          class: "text-caption",
          self: "center left",
          style: {
            backgroundColor: "var(--tooltip-bg)"
          }
        }, {
          default: withCtx(() => [
            createTextVNode(
              toDisplayString($props.tooltipLabel),
              1
              /* TEXT */
            )
          ]),
          _: 1
          /* STABLE */
        })) : createCommentVNode("v-if", true)
      ]),
      _: 1
      /* STABLE */
    },
    16
    /* FULL_PROPS */
  );
}
const bfEntityNoEditIcon = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-entity-no-edit-icon.vue"]]);
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "bf-entity-state.icon",
  props: {
    state: { type: null, required: true, default: "draft" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const stateColorMap = {
      draft: "grey-7",
      schedule: "blue",
      publish: "green",
      unpublish: "red"
    };
    const stateIconMap = {
      draft: "edit",
      schedule: "clock",
      publish: "check-circle",
      unpublish: "minus-circle"
    };
    const icon = computed(() => stateIconMap[props.state]);
    const __returned__ = { props, stateColorMap, stateIconMap, icon, get QIcon() {
      return QIcon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QIcon"], mergeProps({
    name: $setup.icon,
    color: $setup.stateColorMap[$setup.props.state]
  }, _ctx.$attrs), null, 16, ["name", "color"]);
}
const bfEntityState_icon = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-entity-state.icon.vue"]]);
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "bf-entity-state.selector",
  props: {
    modelValue: { type: null, required: false },
    showRescheduledOption: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props = __props;
    const emit = __emit;
    const model = computed({
      get: () => props.modelValue ?? "",
      set: (v) => emit("update:modelValue", v || void 0)
    });
    const { t } = getI18n();
    const getOptions = () => {
      const options = [
        { label: t("entityState.dpAll"), value: "" },
        { label: t("entityState.dpDraft"), value: "draft" },
        { label: t("entityState.dpSchedule"), value: "schedule" },
        { label: t("entityState.dpPublished"), value: "publish" },
        { label: t("entityState.dpExpired"), value: "unpublish" }
      ];
      if (props.showRescheduledOption) {
        options.push({ label: t("entityState.dpRescheduled"), value: "rescheduled" });
      }
      return options;
    };
    const __returned__ = { props, emit, model, t, getOptions, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], mergeProps({
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    "data-qa-state-dropdown": $setup.model,
    options: $setup.getOptions(),
    label: $setup.t("entityState.status"),
    "dropdown-icon": "expand_more",
    "emit-value": "",
    "map-options": "",
    outlined: "",
    dense: ""
  }, _ctx.$attrs), null, 16, ["modelValue", "data-qa-state-dropdown", "options", "label"]);
}
const bfEntityState_selector = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-entity-state.selector.vue"]]);
const getTrackingValuesJobs = async (query) => {
  return (await getClient().get("/cms/tracking-values/bf-jobs", { params: query })).data;
};
const getTrackingContentSources = async () => {
  return (await getClient().get("/cms/tracking-values/article-sources")).data;
};
const PLACEHOLDER_UUID = "00000000-0000-0000-0000-000000000000";
const SEARCH_DEBOUNCE = 300;
const BRANDS = [...BrandList];
const CMS_BRAND_MAP = CmsBrandMap;
const BRAND_CMS_MAP = BrandCmsMap;
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "bf-job-selector",
  props: {
    "modelValue": { type: null, ...{} },
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const bfJobs = ref([]);
    const model = useModel(__props, "modelValue", {
      set: (value2) => value2 || void 0
    });
    const { t } = useI18n();
    const filterBfJobList = async (displayName, updateBfJobList) => {
      const data = await getTrackingValuesJobs({ displayName });
      updateBfJobList(async () => {
        bfJobs.value = data.filter((job) => !job.isDeleted);
      });
    };
    onMounted(async () => {
      bfJobs.value = await getTrackingValuesJobs();
      bfJobs.value = bfJobs.value.filter((job) => !job.isDeleted);
    });
    const __returned__ = { bfJobs, model, t, filterBfJobList, get QSelect() {
      return QSelect;
    }, get SEARCH_DEBOUNCE() {
      return SEARCH_DEBOUNCE;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], mergeProps({
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    "data-qa-bf-dropdown": "",
    options: $setup.bfJobs,
    label: $setup.t("components.bfJob"),
    "option-value": "_id",
    "option-label": "displayName",
    "emit-value": "",
    "map-options": "",
    dense: "",
    flat: "",
    outlined: "",
    "dropdown-icon": "expand_more"
  }, _ctx.$attrs, {
    "use-input": "",
    "input-debounce": $setup.SEARCH_DEBOUNCE,
    onFilter: $setup.filterBfJobList
  }), null, 16, ["modelValue", "options", "label", "input-debounce"]);
}
const bfJobSelector = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-job-selector.vue"]]);
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "bf-limited-text.input",
  props: /* @__PURE__ */ mergeModels({
    maxPerfectLength: { type: Number, required: false, default: void 0 },
    maxLength: { type: Number, required: false, default: void 0 }
  }, {
    "modelValue": { type: String, ...{ default: "" } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const props = __props;
    const model = useModel(__props, "modelValue");
    const getTextLengthStatus = computed(() => {
      if (!props.maxPerfectLength && !props.maxLength) {
        return {
          state: "normal",
          text: `${t("articlesEdit.length")}:`
        };
      }
      if (props.maxPerfectLength && model.value.length <= props.maxPerfectLength) {
        return {
          state: "perfect",
          icon: "check-circle",
          text: t("articlesEdit.seoPerfect")
        };
      }
      if (props.maxLength && model.value.length <= props.maxLength) {
        return {
          state: "okay",
          icon: "check",
          text: t("articlesEdit.seoOkay")
        };
      }
      return {
        state: "long",
        icon: "alert-circle",
        text: t("articlesEdit.seoLong")
      };
    });
    const getTextLengthInfoText = computed(() => {
      const textCountInfo = props.maxPerfectLength ? `(${model.value.length}/${props.maxPerfectLength})` : `${model.value.length}`;
      return `${getTextLengthStatus.value.text} ${textCountInfo}`;
    });
    const __returned__ = { t, props, model, getTextLengthStatus, getTextLengthInfoText, get QIcon() {
      return QIcon;
    }, get QInput() {
      return QInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$5 = ["textContent"];
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QInput"], mergeProps(_ctx.$attrs, {
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    "bottom-slots": ""
  }), {
    counter: withCtx(() => {
      var _a;
      return [
        createElementVNode(
          "div",
          {
            class: normalizeClass(["text-length-info q-mt-xxs", (_a = $setup.getTextLengthStatus) == null ? void 0 : _a.state])
          },
          [
            createVNode($setup["QIcon"], {
              name: $setup.getTextLengthStatus.icon
            }, null, 8, ["name"]),
            createElementVNode("span", {
              "data-qa-article-word-counter": "",
              class: "text-length-info__message",
              textContent: toDisplayString($setup.getTextLengthInfoText)
            }, null, 8, _hoisted_1$5)
          ],
          2
          /* CLASS */
        )
      ];
    }),
    _: 1
    /* STABLE */
  }, 16, ["modelValue"]);
}
const bfLimitedText_input = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i], ["__scopeId", "data-v-02c9ac9f"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-limited-text.input.vue"]]);
const unUsedBunte = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20fill='%23BFBFBF'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M18.0663%2012.5181C18.0033%2012.9534%2017.6252%2013.3264%2017.1841%2013.3886L14.6003%2013.4508V8.29016H17.1211C17.9403%208.29016%2018.0663%208.72539%2018.0663%209.28497V12.5181ZM18.0663%2022.715C18.0663%2022.9637%2018.0033%2023.2124%2017.8143%2023.399C17.6882%2023.5855%2017.4362%2023.7098%2017.1841%2023.7098H14.6003V17.8653H17.058C17.8773%2017.8653%2018.0663%2018.487%2018.0663%2019.171V22.715ZM22.6667%2013.6995V6.6114C22.6667%205.18135%2021.5323%204%2020.0829%204H10V28H20.524C21.3433%2028%2022.6036%2027.0052%2022.6036%2025.7617V17.9275C22.6036%2016.5596%2021.4063%2015.8135%2020.461%2015.7513V15.6891C21.4063%2015.5026%2022.6667%2014.5699%2022.6667%2013.6995Z'%20fill='white'/%3e%3c/svg%3e";
const unUsedFChip = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20fill='%23BFBFBF'/%3e%3cpath%20d='M23.9524%2011.773H27.0371C27.5593%2011.773%2027.9755%2011.3604%2027.9918%2010.8506H28V5.22731C28%204.18355%2027.1432%203.33398%2026.0904%203.33398H5.90955C4.85685%203.33398%204%204.18355%204%205.22731V26.774C4%2027.8177%204.85685%2028.6673%205.90955%2028.6673H26.0823C27.135%2028.6673%2027.9918%2027.8177%2027.9918%2026.774V21.5067C27.9918%2020.9807%2027.5675%2020.56%2027.0371%2020.56H23.9524C23.4301%2020.56%2022.9976%2020.9807%2022.9976%2021.5067L23.0058%2022.5666C23.0058%2023.4404%2022.2958%2024.1444%2021.4145%2024.1444H14.9759C14.1027%2024.1444%2013.3846%2023.4404%2013.3846%2022.5666V17.7847L9.05134%2013.5288V9.37806C9.05134%208.50422%209.76131%207.80029%2010.6426%207.80029H21.4145C22.2877%207.80029%2023.0058%208.50422%2023.0058%209.37806L22.9976%2010.8345C22.9976%2011.3523%2023.422%2011.773%2023.9524%2011.773Z'%20fill='white'/%3e%3c/svg%3e";
const unUsedFocus = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5%2015.52C5%209.15768%2010.1412%204%2016.4833%204C22.8253%204%2027.9665%209.15768%2027.9665%2015.52C27.9665%2021.8823%2022.8253%2027.04%2016.4833%2027.04C10.1412%2027.04%205%2021.8823%205%2015.52ZM27.575%2015.52C27.575%209.37458%2022.6091%204.39273%2016.4833%204.39273C10.3598%204.3985%205.39723%209.37697%205.39147%2015.52C5.39147%2021.6654%2010.3574%2026.6473%2016.4833%2026.6473C22.6091%2026.6473%2027.575%2021.6654%2027.575%2015.52Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M16.8068%2015.7718L17.1304%2015.6881L17.2818%2015.4629L17.2766%2015.2691H17.2714V15.2639L17.4123%2015.0859L17.2505%2014.8921L17.1096%2014.8555L16.9791%2014.9864L16.7442%2015.1382L16.7651%2015.2796H16.7703L16.7912%2015.4001L16.5771%2015.6619L16.8068%2015.7718Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M15.6219%207.25189C15.8717%207.25565%2016.1068%207.13379%2016.2482%206.92724C16.1439%206.95866%2015.4392%206.83822%2015.6219%207.25189Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M16.3059%207.27206L16.1858%207.3506L16.1023%207.27729L16.0344%207.36631C15.9357%207.39631%2015.8304%207.39631%2015.7317%207.36631L15.6638%207.45533H15.5073L15.6221%207.37155C15.524%207.40546%2015.4174%207.40546%2015.3193%207.37155C15.2933%207.44072%2015.2933%207.51706%2015.3193%207.58624L15.4133%207.66478V7.76427L15.502%207.83758C15.5962%207.81801%2015.6874%207.78633%2015.7735%207.74333C16.0083%207.86376%2016.7391%207.6386%2017.0314%207.77998L17.0888%207.74333C17.1932%207.5234%2016.9218%207.38202%2016.8487%207.21969C16.666%207.14115%2016.3006%206.90027%2016.3059%207.27206Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M14.9121%206.93722L14.8442%207.02624L14.9852%207.0629C15.0321%206.99146%2015.0969%206.93366%2015.1731%206.89533H15.2201L15.1574%206.93722V7.03671H15.006C15.0847%207.05758%2015.1675%207.05758%2015.2462%207.03671C15.2582%207.03382%2015.2707%207.03382%2015.2827%207.03671V6.9477L15.3401%206.91104H15.2723C15.2515%206.90458%2015.2332%206.89176%2015.2201%206.87439C15.2181%206.86401%2015.2181%206.85335%2015.2201%206.84297C15.203%206.85818%2015.1836%206.87056%2015.1626%206.87962H15.1V6.82726L15.0008%206.8901L14.9121%206.93722Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M18.4928%208.37166C18.4426%208.35128%2018.3865%208.35128%2018.3363%208.37166L18.2319%208.00512V7.94228C18.117%208.00512%2017.95%207.94228%2017.8352%207.90039V7.95275L17.7516%208.00512H17.7203H17.689C17.4176%207.83755%2017.3863%207.94228%2017.2036%208.00512C17.1262%208.03132%2017.0452%208.04545%2016.9635%208.04701V8.1465C16.739%208.34548%2016.6451%208.1465%2016.4885%208.24599L16.4154%208.32977L16.4572%208.39261L16.2901%208.45545L16.3267%208.51828L16.2432%208.65443H16.3423C16.3676%208.71104%2016.4095%208.75855%2016.4624%208.79057C16.5042%208.88746%2016.5042%208.99739%2016.4624%209.09428C16.358%209.3561%2016.0866%209.61792%2016.0918%209.80119L16.2379%209.83261L16.097%209.96352L15.9039%209.99494L15.836%2010.262L15.9717%2010.3458C15.8047%2010.6181%2015.6586%2010.5709%2015.502%2010.7699C15.3275%2011.0441%2015.2153%2011.3533%2015.1731%2011.6758C15.1255%2011.8353%2015.113%2012.0032%2015.1366%2012.168C15.1728%2012.3177%2015.1972%2012.4701%2015.2097%2012.6236L15.3454%2012.7074L15.4498%2012.6812C15.5536%2012.5008%2015.6668%2012.326%2015.7891%2012.1576C15.9263%2011.9454%2016.0817%2011.7456%2016.2536%2011.5606C16.3856%2011.5431%2016.5198%2011.5574%2016.6451%2011.6025C16.7912%2011.5554%2016.8956%2011.2831%2017.094%2011.1836L17.1775%2011.2569C17.355%2011.2569%2017.6525%2011.037%2017.8091%2010.9375C17.7459%2010.9004%2017.6992%2010.8404%2017.6786%2010.7699C17.6767%2010.7455%2017.6767%2010.721%2017.6786%2010.6966L17.7569%2010.5552L17.783%2010.6704L17.8665%2010.7385L17.95%2010.6024C17.9382%2010.4126%2017.963%2010.2224%2018.0231%2010.0421L18.1536%209.91639L18.2319%209.56555L18.1692%209.39275L18.3467%209.27755C18.2937%209.24009%2018.2535%209.18703%2018.2319%209.1257C18.2596%208.88136%2018.3702%208.65399%2018.545%208.48163L18.4928%208.37166Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M17.1725%2012.5085L17.3291%2012.4876L17.5065%2012.3776L17.6266%2012.1943L17.6527%2012.1524L17.5535%2011.922L17.4961%2011.9587L17.2925%2011.9639L17.209%2011.8906L17.0524%2011.9063L17.0681%2012.0634L17.0472%2012.1682V12.1996L17.042%2012.4195L17.1725%2012.5085Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M17.6056%2016.2794L17.9031%2016.2951L18.2163%2016.2689L18.3468%2016.138L18.4825%2015.96L18.4459%2015.6929L18.2476%2015.4363L18.1745%2015.2688H18.1641L18.1067%2015.1483L18.0284%2014.8132L17.9188%2014.6299L18.0806%2014.3524L17.8039%2014.2372L17.9083%2013.9963L17.7622%2013.9597L17.7152%2013.9492L17.5638%2014.1744L17.496%2014.4781L17.5273%2014.7975L17.616%2015.0803L17.7361%2015.2793H17.7465L17.7674%2015.3159L17.6369%2015.4468L17.5221%2015.7348L17.5273%2015.9443L17.5064%2016.0438L17.2559%2016.248L17.3446%2016.3161L17.6056%2016.2794Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M12.4903%209.23612C12.5313%209.19871%2012.5697%209.15847%2012.6051%209.11569C12.7356%208.93241%2012.7617%208.73867%2012.8974%208.54492C12.7191%208.61851%2012.536%208.67974%2012.3493%208.72819C12.3457%208.80146%2012.3116%208.86985%2012.2554%208.9167L12.5477%208.98478L12.4903%209.12616V9.23612Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M15.2304%207.07962C15.2119%207.08814%2015.1944%207.09867%2015.1782%207.11104C15.1775%207.18169%2015.1494%207.24928%2015.0999%207.29955H14.9486C14.7554%207.45141%2014.9486%207.72893%2015.0164%207.89126L15.1834%207.82319C15.2145%207.75685%2015.2145%207.68007%2015.1834%207.61373L15.0999%207.55613V7.35715L15.2722%207.29431L15.3244%207.04297H15.2461L15.2304%207.07962Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M11.6237%2013.5934C11.7369%2013.5715%2011.8397%2013.5125%2011.916%2013.4258L11.8795%2013.363C11.6903%2013.4399%2011.5056%2013.5273%2011.3262%2013.6248H11.6237V13.5934Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M18.2318%204.37202L18.712%204.48722L19.1087%204.52911L19.5315%204.68096L19.8447%204.86424L20.3667%205.13653V5.18889L20.8469%205.51355L21.2697%205.67064L21.3688%205.76489L21.562%205.94816L21.468%206.13667L21.7603%206.4142L22.0161%206.84882L21.776%206.79122L21.609%206.6446H21.4524V6.85406L21.6664%207.14729L21.9274%207.57667L22.2823%207.97464L22.418%208.26787L22.585%208.20504L22.7521%208.35166H22.6477L22.6685%208.71296L22.5746%208.68678H22.4806L22.9034%209.05333L22.9869%209.1214L23.1331%209.15806L23.4306%209.50889L23.2845%209.34133L23.2114%209.2366H23.1174L23.0339%209.16329H23.0026L22.8565%209.08475L22.251%208.74962L22.2875%208.80722L22.3658%208.93289L22.4493%209.0062L22.6163%209.12664L23.0966%209.47224V9.57696L22.6216%209.67122L22.5485%209.76024L22.7938%2010.0273L22.5381%2010.4881L22.4702%2010.8023L22.4284%2010.9855L22.3345%2010.8075V10.7604H22.0839L22.1153%2010.8127L22.2405%2011.0431L22.3293%2011.1322L22.3658%2011.2945L22.2614%2011.5301L22.3136%2011.7553L22.0892%2011.86L22.2927%2012.0642L22.0056%2011.9962H21.9587L21.8491%2011.8129L21.5463%2011.5825H21.7969L22.0578%2011.5406L22.1622%2011.305L21.8856%2011.0222L21.7447%2010.9855L21.515%2010.8756H21.2645L21.0974%2010.9384H21.0505L20.9408%2010.8075L20.8417%2010.7237H20.5859L20.4867%2010.8127L20.4032%2010.8861L20.2153%2011.0484L20.1579%2011.2997L19.9961%2011.5773L19.8708%2011.9124L19.8134%2012.1637V12.2109L19.7455%2012.5041L19.5942%2012.7345L19.3384%2012.9858L19.2653%2013.0749L19.0461%2013.389V13.609V13.7608L19.0774%2014.0855L19.2966%2014.2426L19.5315%2014.0855L19.756%2013.986L19.8969%2014.2792L20.0326%2014.5777L20.1474%2014.9704H20.3458L20.3928%2014.7714L20.5807%2014.6091V14.5096V14.3473V14.0383L20.6485%2013.9493L20.7321%2013.8132L20.6224%2013.6247L20.4711%2013.0644L20.5859%2012.7764L20.7007%2012.4936V12.2213V12.1375H20.9513V12.2213V12.457L20.7895%2012.7293V13.0434V13.0906L21.0035%2013.5095L21.2749%2013.5933L21.5411%2013.5514L21.7133%2013.4519L21.7551%2013.5357H21.6507H21.4941L21.4263%2013.5775L21.3741%2013.609L21.2592%2013.6875V13.8498L21.3949%2013.9336V13.8813V14.0436L21.4576%2014.2164L21.3375%2014.2949L21.1809%2014.1012L21.0974%2014.2373L21.0661%2014.3892L21.1183%2014.6091L21.1705%2014.829L21.04%2014.9599V15.0594L20.92%2015.1327L20.8469%2015.0123L20.5441%2015.2479L20.3719%2015.3579L20.1161%2015.2479H20.0848L19.9073%2015.405L19.7821%2015.2479V15.2165V14.7453L19.7977%2014.473L19.7038%2014.4468L19.495%2014.7138V15.0856L19.5785%2015.3055L19.6203%2015.4207L19.3958%2015.5255H19.1453L18.9365%2015.7873L18.8217%2016.0753L18.6337%2016.2376L18.4458%2016.4052L18.2057%2016.557L17.9448%2016.5989L17.8717%2016.6932L17.8143%2016.7717L17.522%2016.7037L17.3341%2016.866L17.5063%2017.0126H17.6003L17.8247%2017.3844L17.7934%2017.7457L17.7203%2018.0703L17.4593%2018.1175L17.1879%2018.0599H17.12L16.7703%2018.0285L16.4832%2017.9604L16.3423%2018.0756L16.2431%2018.1594L16.2849%2018.4317L16.217%2018.7301L16.0448%2019.0548L16.097%2019.2799V19.5418L16.3371%2019.5994L16.478%2019.7565L16.572%2019.8612H16.7755H16.9321H17.3393L17.4593%2019.7826L17.5689%2019.7146L17.7568%2019.547L17.8717%2019.259L18.0805%2018.9972L18.378%2018.8034L18.5763%2018.5887L18.6129%2018.4369L18.8373%2018.3322H19.1975L19.4219%2018.2274L19.5837%2018.1227L19.6516%2018.0808L19.7194%2018.1227L19.9126%2018.2431L20.0222%2018.4264L20.1318%2018.6097L20.4502%2018.793L20.6642%2018.9501L20.9043%2019.0077L21.0035%2019.2381L20.9356%2019.5418L21.1496%2019.2747L21.0974%2019.0548L21.3219%2018.9501L21.4419%2018.8715L21.1653%2018.7563L21.0296%2018.6725V18.5678L20.9461%2018.4945H20.7842L20.5702%2018.3374L20.4084%2018.1437V18.1018L20.2884%2017.9028V17.7928L20.4763%2017.6253L20.5598%2017.6986L20.6224%2017.8242L20.8051%2017.9656L21.0296%2018.107L21.0661%2018.1332L21.2018%2018.217L21.4158%2018.3741L21.5881%2018.5207L21.6298%2018.793L21.8021%2018.9396L21.9952%2019.1962V19.3061L22.0839%2019.5889H22.2875V19.4318L22.3397%2019.1805L22.4806%2019.0024L22.2927%2018.9553V18.8453L22.2405%2018.6254L22.418%2018.5102L22.6424%2018.4055H22.846L23.0444%2018.1855V18.1122V18.0389L22.8878%2017.8452L22.9556%2017.5467V17.1749L23.0966%2016.7874V16.7089V16.6408L23.2062%2016.6146L23.4672%2016.5727L23.4097%2016.7089L23.368%2016.8084L23.5037%2016.8817L23.6342%2016.9759L23.7699%2016.7194L23.8012%2016.6565V16.6042L23.6864%2016.4209L23.843%2016.1957L23.9891%2015.9706L24.0779%2016.0386V16.201L24.0204%2016.4523L24.1405%2016.5832L24.4171%2016.7037H24.6207L24.7199%2016.866V16.9759L24.6155%2017.2116L24.4276%2017.3791L24.318%2017.4053H24.0674L23.8534%2017.4629L23.6185%2017.6148L23.3993%2017.929L23.1592%2018.0808L23.013%2018.3322L22.799%2018.3898L22.7468%2018.6359L22.7938%2018.861L22.9295%2018.9448L23.0757%2019.1909H23.2792L23.5246%2018.9867L23.8012%2018.8977L24.0152%2018.8401L24.2136%2018.6254H24.2605L24.2971%2018.683L24.3388%2018.9553L24.3075%2019.1071V19.5784L24.2397%2019.7512L24.1979%2019.8612C24.126%2019.9056%2024.0624%2019.9623%2024.01%2020.0287L23.8169%2019.9816C23.5402%2020.5053%2022.9661%2020.2906%2022.7729%2020.4738C22.418%2020.2958%2021.5933%2020.4162%2021.729%2020.9975L21.5985%2021.1231L21.2175%2021.0289L21.0505%2021.097C20.8977%2021.09%2020.7621%2020.9966%2020.7007%2020.8561C20.5076%2020.809%2020.1422%2020.8561%2020.0065%2020.7933L19.9334%2020.6728H19.7769C19.7769%2020.5105%2019.9126%2020.4005%2019.923%2020.2382L19.8604%2020.0654L19.9021%2019.8664L19.7977%2019.8926L19.6672%2019.8088C19.5712%2019.8275%2019.4781%2019.8592%2019.3906%2019.9031C19.2062%2019.8668%2019.0165%2019.8668%2018.8321%2019.9031C18.2865%2019.8721%2017.7435%2019.9974%2017.2662%2020.2644H17.1722L17.2297%2020.233C17.0531%2020.2329%2016.8775%2020.2082%2016.7077%2020.1597L16.6346%2020.034C16.525%2020.0706%2016.3423%2020.3639%2016.2849%2020.4738C16.021%2020.4603%2015.7673%2020.5778%2015.6063%2020.788C15.5778%2020.9134%2015.5339%2021.0347%2015.4759%2021.1493C15.4709%2021.1735%2015.4709%2021.1985%2015.4759%2021.2226C15.3819%2021.3902%2015.0374%2021.4164%2014.8599%2021.4949H14.7608C14.2471%2021.7659%2013.7801%2022.1177%2013.3775%2022.537C13.3643%2022.5537%2013.3553%2022.5735%2013.3515%2022.5946C13.4179%2022.6496%2013.4728%2022.7172%2013.5133%2022.7935C13.4469%2022.8757%2013.4068%2022.9761%2013.3984%2023.0815L13.4715%2023.202C13.4402%2023.2858%2013.2471%2023.4533%2013.2471%2023.5162C13.1869%2023.5735%2013.1101%2023.6102%2013.0278%2023.6209C13.0341%2023.7082%2013.069%2023.7911%2013.127%2023.8565C13.0017%2024.1393%2013.3045%2024.3069%2013.508%2024.4168V24.532C13.6177%2024.5949%2013.6438%2024.7362%2013.7534%2024.7991C13.7116%2024.8514%2013.8108%2024.9038%2013.7534%2024.9614L13.8264%2025.0818C14.0613%2025.0818%2014.4789%2025.7573%2015.0948%2025.7573C15.4967%2025.7573%2015.836%2025.8463%2016.2327%2025.8725C16.8434%2025.9092%2017.2766%2025.6474%2017.9134%2025.7992L17.9917%2025.9249C18.2156%2025.956%2018.4435%2025.9381%2018.6598%2025.8725L18.7434%2025.9458H18.853C19.0096%2026.082%2018.378%2026.4695%2018.5241%2026.5009H18.6233L18.6598%2026.5637L18.9939%2026.6423L18.9417%2026.7103C21.8303%2026.1026%2024.3671%2024.3847%2026.0091%2021.9243C26.0505%2021.8146%2026.0993%2021.7079%2026.1553%2021.6049C26.197%2021.5473%2026.1918%2021.4845%2026.244%2021.4216C26.2653%2021.3921%2026.2795%2021.358%2026.2858%2021.3221V21.2593V21.1912V21.2174L26.2388%2021.2802L26.1553%2021.4164L26.0143%2021.5944C25.9161%2021.7065%2025.8238%2021.8236%2025.7377%2021.9453L25.5237%2022.2123C25.4611%2022.2856%2025.4245%2022.2123%2025.4036%2022.2123C25.5968%2021.9924%2025.08%2022.0814%2025.0539%2022.0605C24.8921%2021.9191%2025.0539%2021.8562%2024.8138%2021.7934L24.7773%2021.7306C24.8159%2021.6472%2024.814%2021.5505%2024.7722%2021.4687C24.7304%2021.3869%2024.6533%2021.3289%2024.5633%2021.3117C24.532%2021.2593%2024.4954%2021.2069%2024.4693%2021.1546C24.4476%2021.1138%2024.4335%2021.0695%2024.4276%2021.0237H24.3806C24.3082%2020.8579%2024.2035%2020.7083%2024.0726%2020.5838L24.0204%2020.3586C24.104%2020.4162%2024.1457%2020.5105%2024.2292%2020.5681L24.2866%2020.5262L24.3649%2020.1754L24.4537%2020.4634L24.6625%2020.6676L24.7721%2020.8509L24.9182%2020.8875L25.0383%2021.0237L25.0017%2021.1703L25.0905%2021.2436V21.2959L25.2314%2021.3274L25.3567%2021.4635V21.5106L25.4819%2021.6468V21.8091V22.0186V21.9714L25.7325%2021.7672L25.8839%2021.5421L25.9517%2021.453L26.1501%2021.1703V21.1389L26.3223%2020.809L26.4841%2020.5367L26.6094%2020.1963L26.6825%2020.1073L26.8547%2019.7826L26.9539%2019.5575L27.1053%2019.1857V19.0862L27.1836%2018.7354L27.2618%2018.3845L27.2253%2018.3269L27.1053%2018.4002H27.0113L26.9591%2018.1751L26.8808%2018.5259L26.8025%2018.8767L26.6511%2019.1019H26.5572L26.5207%2019.0391L26.4476%2019.1281L26.3745%2019.0024H26.3275L26.2075%2018.8663L26.1657%2018.8087V18.7144L26.3327%2018.4945H26.4215L26.5572%2018.5783L26.7347%2018.4631L26.886%2018.2379L27.0009%2018.1227L27.1105%2018.0965L27.2044%2017.908L27.3401%2017.7352V17.6829L27.4654%2017.3477L27.4967%2017.1959L27.6116%2016.9079L27.6481%2016.9707V16.9183V16.8712L27.6846%2016.9288L27.7212%2016.9917L27.8047%2016.9079C27.8529%2016.4784%2027.8773%2016.0466%2027.8778%2015.6145C27.9329%209.74716%2023.5278%204.80166%2017.7099%204.19922L18.2318%204.37202Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M11.2637%2014.294L11.222%2014.493H11.3734C11.4024%2014.5808%2011.4166%2014.6728%2011.4151%2014.7653C11.5039%2014.7653%2011.6082%2014.6815%2011.65%2014.6134C11.6918%2014.5454%2011.65%2014.4354%2011.603%2014.3883L11.7283%2014.2626V14.1526L11.8014%2014.0636C11.7647%2013.9683%2011.6885%2013.8937%2011.5926%2013.8594L11.65%2013.6133H11.3577C11.2338%2013.6743%2011.1135%2013.7425%2010.9975%2013.8175C10.9245%2014.116%2011.2011%2014.095%2011.2637%2014.294Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M14.4007%206.71266V6.66553C14.3612%206.65671%2014.3202%206.65671%2014.2807%206.66553C14.3478%206.65159%2014.4128%206.6287%2014.4738%206.59746C14.4373%206.59746%2014.3955%206.5608%2014.3903%206.52415C14.4311%206.44395%2014.4972%206.37952%2014.5782%206.34088C14.4813%206.33449%2014.3964%206.27364%2014.359%206.18378C14.2942%206.15488%2014.2202%206.15488%2014.1554%206.18378L14.0876%206.2728V6.17331H13.978C13.9231%206.22072%2013.8909%206.28922%2013.8892%206.36182L13.7692%206.44037L13.8161%206.24138H13.7639C13.6491%206.31993%2013.5238%206.43513%2013.3725%206.41418C13.4508%206.57128%2013.3098%206.58175%2013.4403%206.79644L13.3829%206.88022C13.355%206.92615%2013.3388%206.97833%2013.3359%207.03208C13.3829%207.15775%2013.5238%207.11586%2013.623%207.10015C13.6635%207.01882%2013.7144%206.94313%2013.7744%206.87498C13.9916%206.86168%2014.2043%206.80657%2014.4007%206.71266Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M13.0122%209.05372L12.9026%209.12703L12.8452%209.16369C12.9422%209.23859%2013.0036%209.35077%2013.0145%209.47311C13.0255%209.59544%2012.9849%209.71678%2012.9026%209.80776C12.9026%2010.0067%2012.9653%2010.211%2012.9705%2010.4047C13.0454%2010.3085%2013.0892%2010.1915%2013.0958%2010.0696H13.1949V10.1795L13.3776%2010.279C13.4713%2010.1674%2013.5045%2010.0167%2013.4664%209.87583C13.5499%209.87583%2013.6699%209.6559%2013.7326%209.57212L13.8213%209.64543C13.7664%209.79238%2013.7467%209.95024%2013.7639%2010.1062C13.8891%2010.0067%2014.0457%209.99103%2014.171%209.89154C14.171%209.68209%2014.2545%209.46216%2014.2075%209.26841C14.3165%209.25835%2014.4147%209.19846%2014.4737%209.10609C14.4901%209.08207%2014.5025%209.05554%2014.5103%209.02754C14.479%208.88616%2014.5625%208.72907%2014.5103%208.60863C14.6154%208.45973%2014.7323%208.31964%2014.86%208.18972C14.86%208.18972%2014.86%208.09023%2014.86%208.01169C14.8513%207.97025%2014.8513%207.92745%2014.86%207.88601C14.7034%207.65561%2014.2911%207.84412%2014.1293%207.96979L13.9883%207.93838C14.0249%207.83365%2013.837%207.89125%2013.8317%207.93838C13.8265%207.9855%2013.8317%207.97503%2013.8317%207.99074C13.8317%208.06405%2013.8944%208.13212%2013.9152%208.20543L13.9988%208.27874C14.0029%208.34113%2014.0246%208.40106%2014.0614%208.45154C13.9936%208.53497%2013.9103%208.60434%2013.8161%208.65576L13.8891%208.78143L13.8526%208.92805C13.7482%208.92805%2013.6647%209.03801%2013.5812%209.10609H13.4298L13.3463%209.24747L13.0644%209.23699L13.1271%209.1375V9.10085L13.0122%209.05372Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M15.5017%206.61895H15.3973L15.3243%206.70273C15.4339%206.70273%2015.6688%206.65561%2015.7157%206.53517C15.6792%206.41997%2015.5435%206.56659%2015.5017%206.61895Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M14.4527%205.68542L14.2856%205.7535V5.84251C14.4266%205.84251%2014.5571%206.02055%2014.6249%206.13051H14.7293C14.7981%206.04604%2014.8834%205.97655%2014.9799%205.9263V5.82681C14.9799%205.82681%2014.9799%205.79015%2014.9485%205.77968H14.9068H14.8024L14.4527%205.68542Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M21.1391%206.90551L20.9773%206.97358L20.9251%206.96311L21.0086%207.03642L21.2487%207.09402L21.1391%206.90551Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M21.5933%209.12646H21.5986L21.6455%209.23119L21.6821%209.28879L21.7082%209.40399L21.8595%209.6501L21.943%209.72341L22.1727%209.82813L22.3397%209.76006L22.204%209.67628L22.0005%209.47206L21.8021%209.21548L21.776%209.12646H21.7656L21.7082%208.93271L21.656%208.70755L21.6299%208.59759L21.5307%208.36719L21.4106%208.4405L21.4159%208.64995L21.5046%208.93795L21.5933%209.12646Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M20.3875%205.52444L20.3144%205.61346L20.4397%205.74437L20.5232%205.76531H20.518L20.5336%205.77055L20.6276%205.7915L20.6328%205.76531L20.6485%205.69201L20.5075%205.65535L20.3875%205.52444Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M15.4028%205.95276C15.3424%205.95786%2015.2846%205.97961%2015.2358%206.01559L15.3715%206.10461V6.15174C15.417%206.20689%2015.483%206.24095%2015.5542%206.24599L15.5698%206.09414C15.5176%206.09414%2015.4185%206.02083%2015.4028%205.95276Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M6.32041%2016.5152H6.41958L6.38305%2016.4524C6.38305%2016.3791%206.28387%2015.7245%206.20036%2015.248C6.17908%2015.0856%206.1477%2014.9247%206.1064%2014.7663C6.17426%2014.6825%205.97069%2014.5778%205.96025%2014.5254C5.96737%2014.6392%205.99946%2014.7501%206.05421%2014.85C6.02445%2014.9846%206.02445%2015.124%206.05421%2015.2585C6.06351%2015.3033%206.08122%2015.346%206.1064%2015.3842C6.1064%2015.4784%206.18992%2015.625%206.15338%2015.714L6.21602%2015.8868L6.16904%2016.0858C6.23265%2016.2239%206.28332%2016.3677%206.32041%2016.5152Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M6.47182%2017.4363C6.5188%2017.4363%206.57621%2017.4887%206.60753%2017.5201L6.63363%2017.6301C6.71361%2017.6888%206.76636%2017.7777%206.77978%2017.8762V17.7767C6.67017%2017.5096%206.63363%2017.0174%206.4405%2016.8027C6.40682%2016.8867%206.40682%2016.9805%206.4405%2017.0646H6.3883C6.3717%2016.98%206.33794%2016.8998%206.28913%2016.8289L6.25781%2016.9808C6.40396%2017.0227%206.4405%2017.3054%206.47182%2017.4363Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M19.636%208.69653L19.5368%208.67558L19.3854%208.69129V8.90074L19.636%208.90598V8.69653Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M9.61426%2013.7657L9.73431%2013.8966H9.8909C10.0247%2013.9797%2010.1738%2014.035%2010.3294%2014.0589C10.3208%2013.9274%2010.2695%2013.8023%2010.1832%2013.7028V13.6086H9.82826C9.86888%2013.6457%209.89942%2013.6925%209.917%2013.7447C9.81672%2013.7162%209.70969%2013.7237%209.61426%2013.7657Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M15.956%204.17188C10.9617%204.53047%206.78724%208.1207%205.67108%2013.0174C4.55491%2017.9142%206.75909%2022.9677%2011.1017%2025.4682C11.1036%2025.456%2011.1036%2025.4437%2011.1017%2025.4315C11.0612%2025.3449%2011.0122%2025.2624%2010.9556%2025.1854V25.133C10.5119%2024.8398%2011.013%2024.6408%2011.0965%2024.2743C10.7876%2023.9387%2010.4506%2023.6304%2010.0891%2023.3527C9.63436%2023.1426%209.2124%2022.8674%208.83639%2022.5358C8.71634%2022.4363%208.60672%2022.3316%208.49711%2022.2216C8.44868%2022.2584%208.39065%2022.2802%208.33008%2022.2845L8.3614%2022.1378L8.27788%2022.0645C8.19959%2022.0069%208.07954%2021.9493%208.01168%2021.8917C7.94383%2021.8341%207.98036%2021.7818%208.01168%2021.7922V21.6927C7.95427%2021.6194%207.84465%2021.3943%207.70894%2021.1377C7.46884%2020.6874%207.16088%2020.1533%206.93121%2020.1742C6.87737%2020.1062%206.84307%2020.0247%206.83204%2019.9386L6.74852%2019.8705C6.75914%2019.8275%206.75914%2019.7826%206.74852%2019.7396C6.73165%2019.6857%206.70704%2019.6345%206.67545%2019.5877C6.56062%2019.3992%206.15348%2018.5666%205.89772%2018.0587C5.8341%2017.9254%205.76264%2017.796%205.68371%2017.6712V17.7812C5.68371%2017.5717%205.58454%2017.0481%205.52712%2016.6606C5.52712%2016.4878%205.48015%2016.3464%205.47493%2016.2783C5.6377%2015.9662%205.66416%2015.6002%205.548%2015.2677C5.548%2015.1944%205.51668%2015.1159%205.50625%2015.0426C5.49581%2014.9693%205.67849%2014.7441%205.73069%2014.7284C5.73069%2014.6132%205.84552%2014.5608%205.84552%2014.4456L5.76723%2014.3199C5.81184%2014.1464%205.80088%2013.9632%205.73591%2013.7963C5.69415%2013.8539%205.63674%2013.7963%205.57932%2013.7963C5.60598%2013.7306%205.62524%2013.6621%205.63674%2013.5921C5.67324%2013.2772%205.7255%2012.9644%205.79333%2012.6548C5.85625%2012.4911%205.93676%2012.3349%206.03343%2012.1887C6.07239%2012.1247%206.10725%2012.0582%206.13782%2011.9898C6.15128%2011.9398%206.16174%2011.8891%206.16914%2011.8379L6.29963%2011.7122C6.35705%2011.7122%206.39359%2011.8065%206.41969%2011.8484C6.39952%2011.9626%206.38731%2012.0781%206.38315%2012.194C6.36294%2012.3837%206.36294%2012.575%206.38315%2012.7647L6.43013%2012.7386C6.45571%2012.9279%206.47139%2013.1184%206.4771%2013.3093C6.54731%2013.3832%206.59448%2013.476%206.61281%2013.5764C6.57628%2013.8749%206.34661%2014.3095%206.27354%2014.6237L6.34661%2014.7493C6.63891%2014.4456%206.57106%2013.9115%206.86858%2013.6078L6.97819%2013.5816C7.15566%2013.7282%207.40098%2013.6863%207.57845%2013.833C7.67701%2013.8207%207.765%2013.765%207.81855%2013.6811C7.81313%2013.6429%207.81313%2013.6041%207.81855%2013.5659C7.84987%2013.4664%207.90729%2013.3826%207.93861%2013.2831C7.99063%2013.2212%208.05233%2013.1682%208.1213%2013.1261C8.04679%2013.2254%207.99996%2013.3429%207.98558%2013.4664C7.9471%2013.4878%207.91043%2013.5123%207.87597%2013.5397C7.94843%2013.4999%208.02341%2013.465%208.10042%2013.435C8.10882%2013.3296%208.14886%2013.2292%208.21525%2013.147L8.18393%2013.2989L8.31442%2013.4245C8.63282%2013.2151%208.48145%2013.2413%208.71112%2013.4664V13.3669V13.4769C8.76331%2013.5345%208.88337%2013.6183%208.95122%2013.5345C9.01908%2013.4507%208.95122%2013.4926%208.91468%2013.5083C9.13391%2013.2308%209.00864%2013.3565%209.30616%2013.3041C9.37923%2013.3407%209.69241%2013.4821%209.70285%2013.5711C9.7301%2013.5818%209.75495%2013.5978%209.77593%2013.6183H10.1309V13.4245C10.2348%2013.3249%2010.2996%2013.1911%2010.3136%2013.0475L10.5067%2013.0946L10.6111%2012.9009L10.5015%2012.7176L9.77071%2012.5919C9.95467%2012.5101%2010.1541%2012.469%2010.3553%2012.4715L10.3918%2012.5291H10.6894C10.8929%2012.7386%2011.0391%2012.9899%2011.3209%2013.0999C11.4408%2013.0895%2011.5613%2013.0895%2011.6811%2013.0999L11.8481%2013.2413C11.9779%2013.1494%2012.0895%2013.0339%2012.177%2012.9009L12.1143%2012.7281L12.2083%2012.5396C12.1868%2012.4202%2012.1553%2012.3029%2012.1143%2012.1887V12.1521C12.1143%2011.7908%2012.4745%2011.4295%2012.5162%2011.0367L12.6467%2010.9111C12.438%2010.9111%2012.2814%2011.0786%2012.0621%2011.0367C12.0435%2010.9575%2012.0435%2010.8751%2012.0621%2010.7959C12.0722%2010.7386%2012.088%2010.6825%2012.1091%2010.6283L12.4902%2010.2827C12.4694%2010.1436%2012.501%2010.0017%2012.5789%209.88475L12.4327%209.63864V9.42395C12.083%209.45013%2011.8116%209.85333%2011.4514%209.979L11.4097%2010.178C11.2166%2010.4398%2010.8877%2010.3979%2010.6006%2010.4031C10.4947%2010.5608%2010.3643%2010.7005%2010.2144%2010.8168C10.1797%2010.8384%2010.1403%2010.851%2010.0995%2010.8535V10.8168L10.0526%2010.6911C10.2666%2010.4712%2010.2875%2010.2408%2010.5745%2010.0837L10.6685%209.89522L10.6059%209.71195C10.6528%209.51297%2010.7155%209.32969%2010.7572%209.14118C10.7812%208.99906%2010.7812%208.85392%2010.7572%208.7118C10.891%208.63641%2011.014%208.54304%2011.1226%208.43428V8.33478C11.4482%208.18154%2011.8148%208.13925%2012.1665%208.21435L12.2657%208.18817L12.4014%208.27195V8.32431L12.5789%208.41857C12.7392%208.3594%2012.9031%208.31043%2013.0695%208.27195V8.4814L13.2627%208.52853C13.3966%208.48127%2013.5274%208.4253%2013.6541%208.36097L13.7272%208.18817V8.07297C13.6079%208.11538%2013.483%208.14007%2013.3566%208.14628L13.2261%208.06249L13.3775%207.99966C13.4391%207.95768%2013.4922%207.90438%2013.5341%207.84257L13.4506%207.76926C13.6631%207.64193%2013.8655%207.49838%2014.056%207.33987C13.9143%207.32473%2013.7709%207.3445%2013.6385%207.39748L13.5341%207.57028C13.3859%207.61466%2013.2281%207.61466%2013.08%207.57028L13.3044%207.47078H13.4036L13.5341%207.37129C13.4899%207.31458%2013.4231%207.28013%2013.3514%207.27704L13.1844%207.33987L13.1009%207.26657C13.1009%207.12518%2013.2105%207.01522%2013.2366%206.88431C13.2366%206.88431%2013.2366%206.85289%2013.2366%206.83195L13.1061%206.74817L13.2574%206.61726C13.2859%206.55035%2013.2859%206.47471%2013.2574%206.4078L13.3723%206.32926H13.5289C13.5947%206.16561%2013.7343%206.04314%2013.9047%205.99937V5.89988L14.056%205.81086L14.0039%205.76373L13.9725%205.73755L14.1865%205.68518V5.63806L14.3066%205.56998C14.2126%205.38147%2014.3901%205.3134%2014.3849%205.21915C14.8688%205.01731%2015.3753%204.87489%2015.8934%204.795V4.69551C15.9612%204.66409%2016.17%204.48082%2016.1596%204.3918C15.8882%204.42322%2015.8151%204.30802%2015.8255%204.31326L15.956%204.17188Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M20.6537%207.05249L20.6328%207.15198L20.8103%207.25147L21.0034%207.2986L21.0869%207.15722L20.9042%207.06297L20.6537%207.05249Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M19.5992%2019.3744L19.7767%2019.2592L19.7924%2018.945L19.6828%2018.7617L19.6149%2018.8507L19.5679%2019.0497L19.5992%2019.3744Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M14.4895%207.25641L14.3799%207.28259L14.2128%207.35066L14.265%207.36114L14.3694%207.33495L14.453%207.40826L14.5365%207.47634L14.6095%207.39255L14.6826%207.30354L14.5939%207.23023L14.4895%207.25641Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M13.9307%207.73859L13.9672%207.80143L14.1238%207.78572L14.3587%207.62863H14.5622L14.6197%207.58674L14.4892%207.50296L14.437%207.49248L14.343%207.47154L14.2856%207.50819L14.129%207.5239L14.0142%207.60245L13.9307%207.73859Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M14.4684%207.14127L14.5519%207.21457L14.672%207.14127L14.578%206.99988C14.5102%206.99988%2014.3901%207.07843%2014.317%207.04178L14.3901%206.95276L14.1761%207.01036C14.1208%207.08127%2014.0404%207.12814%2013.9517%207.14127C14.0163%207.19799%2014.0962%207.23441%2014.1813%207.24599C14.283%207.23047%2014.3806%207.19487%2014.4684%207.14127Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M22.6948%2019.7403L22.7%2019.7456L22.7105%2019.7403H22.7209L22.914%2019.6932L22.7836%2019.6094L22.6739%2019.6356L22.4599%2019.688L22.6792%2019.7403H22.6948Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M19.3802%209.12655H19.3906L19.5107%209.28364L19.6568%209.52451L19.7873%209.60829V9.39884L19.8082%209.24698L19.7404%209.12655H19.7299L19.6621%209.00611L19.4742%208.95898L19.3071%209.02706L19.3802%209.12655Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M20.6693%2019.7819L20.7163%2019.74H20.7215L20.8573%2019.6196L20.7476%2019.4363L20.5806%2019.4992L20.4867%2019.4782L20.3927%2019.6667L20.565%2019.74H20.5754L20.6693%2019.7819Z'%20fill='%23BFBFBF'/%3e%3cpath%20d='M19.7247%2018.3531L19.6047%2018.4264L19.5838%2018.5259L19.7039%2018.6621L19.7247%2018.3531Z'%20fill='%23BFBFBF'/%3e%3c/svg%3e";
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "bf-logo.icon",
  props: {
    brands: { type: Array, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const sources = {
      bunte: bunte$1,
      chip: chip$1,
      focus: focus$1
    };
    const notUsedSources = {
      bunte: unUsedBunte,
      chip: unUsedFChip,
      focus: unUsedFocus
    };
    const orderedBrands = ["focus", "bunte", "chip"];
    const getImageSrc = (brand) => {
      return props.brands.includes(brand) ? sources[brand] : notUsedSources[brand];
    };
    const __returned__ = { props, sources, notUsedSources, orderedBrands, getImageSrc };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$4 = ["src", "alt"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    (openBlock(), createElementBlock(
      Fragment,
      null,
      renderList($setup.orderedBrands, (brand) => {
        return createElementVNode("img", mergeProps({
          key: brand,
          src: $setup.getImageSrc(brand),
          alt: brand,
          class: "big q-mr-sm"
        }, { ref_for: true }, _ctx.$attrs), null, 16, _hoisted_1$4);
      }),
      64
      /* STABLE_FRAGMENT */
    ))
  ]);
}
const bfLogo_icon = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h], ["__scopeId", "data-v-e078404a"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-logo.icon.vue"]]);
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "bf-scheduled-change-icon",
  props: {
    scheduleDate: { type: String, required: true },
    index: { type: Number, required: true },
    entity: { type: String, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const __returned__ = { t, get QIcon() {
      return QIcon;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(
    $setup["QIcon"],
    normalizeProps({
      size: "24px",
      [`scheduled-lock-${$props.entity}` || ""]: $props.index,
      name: "schedule-lock"
    }),
    {
      default: withCtx(() => [
        createVNode($setup["QTooltip"], {
          anchor: "top middle",
          self: "top middle",
          offset: [0, 35],
          class: "bg-grey-10 text-white shadow-4 text-caption"
        }, {
          default: withCtx(() => [
            createTextVNode(
              toDisplayString($setup.t("articleList.scheduledChangeToolTipMessage")) + " " + toDisplayString($props.scheduleDate),
              1
              /* TEXT */
            )
          ]),
          _: 1
          /* STABLE */
        })
      ]),
      _: 1
      /* STABLE */
    },
    16
    /* FULL_PROPS */
  );
}
const bfScheduledChangeIcon = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/bf-scheduled-change-icon.vue"]]);
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "brand-dropdown.selector",
  props: {
    modelValue: { type: null, required: true, default: "" },
    label: { type: String, required: false, default: void 0 },
    labelKey: { type: String, required: false, default: "common.brand" },
    multiple: { type: Boolean, required: false },
    rules: { type: Array, required: false, default: void 0 },
    allowBlankOption: { type: Boolean, required: false, default: true },
    blankOptionLabelKey: { type: String, required: false, default: "common.all" },
    blankOptionValue: { type: String, required: false, default: "" },
    onlyBrands: { type: Boolean, required: false },
    disabledBrands: { type: Array, required: false, default: void 0 },
    disable: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const BRAND_OPTIONS = [
      { label: "Bunte.de", value: "bunte" },
      { label: "Chip.de", value: "chip" },
      { label: "Fitforfun.de", value: "fitforfun" },
      { label: "Focus.de", value: "focus" }
    ];
    const { t } = useI18n();
    const props = __props;
    const emit = __emit;
    const value2 = computed({
      get() {
        if (props.multiple && typeof props.modelValue === "string") {
          emit("update:modelValue", [props.modelValue]);
          return [props.modelValue];
        } else {
          return props.modelValue;
        }
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    const filterDisabled = (options) => {
      if (!props.disabledBrands)
        return options;
      return options.filter((option) => {
        var _a;
        return !((_a = props.disabledBrands) == null ? void 0 : _a.includes(option.value));
      });
    };
    const getBrandOptions = computed(() => {
      if (!props.multiple && props.allowBlankOption) {
        return [{ label: t(props.blankOptionLabelKey), value: props.blankOptionValue }, ...filterDisabled(BRAND_OPTIONS)];
      }
      if (props.onlyBrands) {
        return filterDisabled(BRAND_OPTIONS);
      }
      return filterDisabled(BRAND_OPTIONS);
    });
    const __returned__ = { BRAND_OPTIONS, t, props, emit, value: value2, filterDisabled, getBrandOptions, get QChip() {
      return QChip;
    }, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], {
    modelValue: $setup.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.value = $event),
    "data-qa-brand-dropDown": $setup.value,
    options: $setup.getBrandOptions,
    label: $props.label ?? $setup.t($props.labelKey),
    multiple: $props.multiple,
    "use-chips": $props.multiple,
    rules: $props.rules,
    "emit-value": "",
    "map-options": "",
    dense: "",
    flat: "",
    "dropdown-icon": "expand_more",
    outlined: "",
    disable: $props.disable
  }, createSlots({
    _: 2
    /* DYNAMIC */
  }, [
    $props.multiple ? {
      name: "selected-item",
      fn: withCtx((scope) => [
        createVNode($setup["QChip"], {
          "data-qa-pages-brand": "",
          removable: "",
          dense: "",
          tabindex: scope.tabindex,
          color: "cyan-1",
          "text-color": "dark",
          onRemove: ($event) => scope.removeAtIndex(scope.index)
        }, {
          default: withCtx(() => [
            createTextVNode(
              toDisplayString(scope.opt.label),
              1
              /* TEXT */
            )
          ]),
          _: 2
          /* DYNAMIC */
        }, 1032, ["tabindex", "onRemove"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["modelValue", "data-qa-brand-dropDown", "options", "label", "multiple", "use-chips", "rules", "disable"]);
}
const brandDropdown_selector = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/brand-dropdown.selector.vue"]]);
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "card-item",
  props: {
    item: { type: Object, required: true },
    hideButton: { type: Boolean, required: false },
    isClickable: { type: Boolean, required: false },
    disable: { type: Boolean, required: false }
  },
  emits: ["remove-item"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit = __emit;
    const __returned__ = { emit, get QBtn() {
      return QBtn;
    }, get QCard() {
      return QCard;
    }, get QCardActions() {
      return QCardActions;
    }, get QCardSection() {
      return QCardSection;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$3 = ["data-qa-card-item-maintitle", "textContent"];
const _hoisted_2$3 = ["data-qa-card-item-subtitle", "textContent"];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QCard"], {
    flat: "",
    bordered: "",
    class: normalizeClass({ clickable: $props.isClickable }),
    "data-qa-card-item": $props.item._id
  }, {
    default: withCtx(() => [
      $props.item._id ? (openBlock(), createBlock($setup["QCardSection"], {
        key: 0,
        horizontal: "",
        class: "justify-between"
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "image", { item: $props.item }, void 0, true),
          createVNode($setup["QCardSection"], { class: "q-pa-sm text-crop-container" }, {
            default: withCtx(() => [
              createElementVNode("p", {
                class: "q-my-none text-primary text-crop",
                "data-qa-card-item-maintitle": $props.item._id,
                textContent: toDisplayString($props.item.kicker)
              }, null, 8, _hoisted_1$3),
              createElementVNode("p", {
                class: "q-my-none text-crop",
                "data-qa-card-item-subtitle": $props.item._id,
                textContent: toDisplayString($props.item.title)
              }, null, 8, _hoisted_2$3)
            ]),
            _: 1
            /* STABLE */
          }),
          !$props.hideButton ? (openBlock(), createBlock($setup["QCardActions"], {
            key: 0,
            align: "right"
          }, {
            default: withCtx(() => [
              createVNode($setup["QBtn"], {
                icon: "close",
                class: "text-primary",
                outline: "",
                "data-qa-card-item-remove-button": $props.item._id,
                disable: $props.disable,
                onClick: _cache[0] || (_cache[0] = withModifiers(($event) => $setup.emit("remove-item", $props.item._id), ["stop"]))
              }, null, 8, ["data-qa-card-item-remove-button", "disable"])
            ]),
            _: 1
            /* STABLE */
          })) : createCommentVNode("v-if", true)
        ]),
        _: 3
        /* FORWARDED */
      })) : createCommentVNode("v-if", true)
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["class", "data-qa-card-item"]);
}
const CardItem = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e], ["__scopeId", "data-v-f4141885"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/card-item.vue"]]);
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "card-list",
  props: {
    items: { type: Array, required: true },
    hideImage: { type: Boolean, required: false },
    hideButton: { type: Boolean, required: false },
    isClickable: { type: Boolean, required: false },
    disable: { type: Boolean, required: false }
  },
  emits: ["card-click", "remove-item"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit = __emit;
    const __returned__ = { emit, CardItem };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(true), createElementBlock(
    Fragment,
    null,
    renderList($props.items, (item, index) => {
      return openBlock(), createBlock($setup["CardItem"], {
        key: item._id,
        item,
        class: normalizeClass({ "q-mt-md": index }),
        "hide-image": $props.hideImage,
        "hide-button": $props.hideButton,
        "is-clickable": $props.isClickable,
        disable: $props.disable,
        onRemoveItem: _cache[0] || (_cache[0] = (id) => $setup.emit("remove-item", id)),
        onClick: () => $setup.emit("card-click", item._id)
      }, {
        image: withCtx(() => [
          renderSlot(_ctx.$slots, "image", { item })
        ]),
        _: 2
        /* DYNAMIC */
      }, 1032, ["item", "class", "hide-image", "hide-button", "is-clickable", "disable", "onClick"]);
    }),
    128
    /* KEYED_FRAGMENT */
  );
}
const cardList = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/card-list.vue"]]);
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "cms-selector",
  props: /* @__PURE__ */ mergeModels({
    label: { type: String, required: false },
    rules: { type: Array, required: false },
    multiple: { type: Boolean, required: false }
  }, {
    "modelValue": { type: [String, Array], ...{} },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const contentManagementSystems = ["vibe", "bunte-stack", "escenic", "interred"];
    const props = __props;
    const model = useModel(__props, "modelValue", {
      get: (value2) => {
        if (props.multiple) {
          return typeof value2 === "string" ? [value2] : value2;
        }
        return value2;
      }
    });
    const { t } = useI18n();
    const CMS_OPTIONS = contentManagementSystems.map((cms) => ({
      label: cms.charAt(0).toUpperCase() + cms.slice(1),
      value: cms
    }));
    const options = computed(() => props.multiple ? CMS_OPTIONS : [{ label: t("cmsSelector.dpAll"), value: "" }, ...CMS_OPTIONS]);
    const __returned__ = { contentManagementSystems, props, model, t, CMS_OPTIONS, options, get QChip() {
      return QChip;
    }, get QSelect() {
      return QSelect;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], {
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    "data-qa-managed-by-dropdown": "",
    options: $setup.options,
    label: $props.label || $setup.t("cmsSelector.label"),
    rules: $props.rules,
    multiple: $props.multiple,
    "use-chips": $props.multiple,
    "emit-value": "",
    "map-options": "",
    dense: "",
    flat: "",
    "dropdown-icon": "expand_more",
    outlined: ""
  }, createSlots({
    default: withCtx(() => [
      createVNode($setup["QTooltip"], {
        anchor: "top middle",
        self: "top middle",
        offset: [0, 35],
        class: "bg-grey-10 text-white shadow-4 text-caption"
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString($setup.t("cmsSelector.hint")),
            1
            /* TEXT */
          )
        ]),
        _: 1
        /* STABLE */
      })
    ]),
    _: 2
    /* DYNAMIC */
  }, [
    $props.multiple ? {
      name: "selected-item",
      fn: withCtx((scope) => [
        createVNode($setup["QChip"], {
          "data-qa-managed-by-tag": "",
          removable: "",
          dense: "",
          tabindex: scope.tabindex,
          color: "cyan-1",
          "text-color": "dark",
          onRemove: ($event) => scope.removeAtIndex(scope.index)
        }, {
          default: withCtx(() => [
            createTextVNode(
              toDisplayString(scope.opt.label),
              1
              /* TEXT */
            )
          ]),
          _: 2
          /* DYNAMIC */
        }, 1032, ["tabindex", "onRemove"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["modelValue", "options", "label", "rules", "multiple", "use-chips"]);
}
const cmsSelector = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/cms-selector.vue"]]);
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "content-source-selector",
  props: {
    modelValue: { type: String, required: true }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props = __props;
    const emit = __emit;
    const sources = ref([]);
    const source = computed({
      get() {
        return props.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    onBeforeMount(async () => {
      sources.value = await getTrackingContentSources();
    });
    const __returned__ = { props, emit, sources, source, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], {
    modelValue: $setup.source,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.source = $event),
    options: $setup.sources,
    "option-value": "_id",
    "option-label": "displayName",
    "dropdown-icon": "expand_more",
    "emit-value": "",
    "map-options": "",
    dense: "",
    flat: "",
    outlined: ""
  }, null, 8, ["modelValue", "options"]);
}
const contentSourceSelector = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/content-source-selector.vue"]]);
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "date-range.selector",
  props: {
    modelValue: { type: Array, required: true },
    min: { type: Date, required: false, default: void 0 },
    max: { type: Date, required: false, default: void 0 },
    label: { type: String, required: false, default: "Date" },
    required: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit = __emit;
    const props = __props;
    const minDate = computed(() => props.min ? format(new Date(props.min), "yyyy-MM-dd") : null);
    const maxDate = computed(() => props.max ? format(new Date(props.max), "yyyy-MM-dd") : null);
    const model = computed({
      get() {
        if (props.modelValue.length === 2) {
          return { from: format(new Date(props.modelValue[0]), "yyyy-MM-dd"), to: format(new Date(props.modelValue[1]), "yyyy-MM-dd") };
        }
        return { from: "", to: "" };
      },
      set(value2) {
        if (typeof value2 === "string") {
          return emit("update:modelValue", [startOfDay(new Date(value2)), endOfDay(new Date(value2))]);
        }
        if (value2.from === "" && value2.to === "") {
          return emit("update:modelValue", []);
        }
        emit("update:modelValue", [startOfDay(new Date(value2.from)), endOfDay(new Date(value2.to))]);
      }
    });
    const formattedDate = computed(() => {
      if (typeof model.value === "string") {
        return format(new Date(model.value), "dd.MM.yyyy");
      }
      if (model.value.from !== "" && model.value.to !== "") {
        if (model.value.from === model.value.to) {
          return format(new Date(model.value.from), "dd.MM.yyyy");
        }
        return `${format(new Date(model.value.from), "dd.MM.yyyy")}-${format(new Date(model.value.to), "dd.MM.yyyy")}`;
      }
      return "";
    });
    const clear = () => {
      emit("update:modelValue", []);
    };
    const __returned__ = { emit, props, minDate, maxDate, model, formattedDate, clear, get QDate() {
      return QDate;
    }, get QIcon() {
      return QIcon;
    }, get QInput() {
      return QInput;
    }, get QPopupProxy() {
      return QPopupProxy;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QInput"], mergeProps({
    "data-qa-date-range-selector": "",
    class: $props.required ? "required" : "",
    label: $props.label,
    "model-value": $setup.formattedDate,
    "background-color": "white",
    flat: "",
    outlined: ""
  }, _ctx.$attrs, { onClear: $setup.clear }), {
    append: withCtx(() => [
      $setup.formattedDate ? (openBlock(), createBlock($setup["QIcon"], {
        key: 0,
        name: "clear",
        onClick: $setup.clear
      })) : (openBlock(), createBlock($setup["QIcon"], {
        key: 1,
        name: "calendar"
      }))
    ]),
    default: withCtx(() => [
      createVNode($setup["QPopupProxy"], {
        "transition-show": "scale",
        "transition-hide": "scale"
      }, {
        default: withCtx(() => [
          createVNode($setup["QDate"], {
            modelValue: $setup.model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
            "data-qa-date-input": "",
            minimal: "",
            min: $setup.minDate,
            max: $setup.maxDate,
            range: ""
          }, null, 8, ["modelValue", "min", "max"])
        ]),
        _: 1
        /* STABLE */
      })
    ]),
    _: 1
    /* STABLE */
  }, 16, ["class", "label", "model-value"]);
}
const dateRange_selector = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/date-range.selector.vue"]]);
const formatDate = "dd.MM.yyyy";
const formatDateTime = "dd.MM.yyyy HH:mm";
const maskDate = "DD.MM.YYYY";
const maskDateTime = "DD.MM.YYYY HH:mm";
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "datetime-selector",
  props: {
    modelValue: { type: Date, required: false, default: void 0 },
    min: { type: Date, required: false, default: void 0 },
    max: { type: Date, required: false, default: void 0 },
    label: { type: String, required: false, default: "Date" },
    icon: { type: String, required: false, default: "" },
    rules: { type: Array, required: false, default: () => [] },
    required: { type: Boolean, required: false, default: false },
    dateOnly: { type: Boolean, required: false, default: false },
    dense: { type: Boolean, required: false, default: false },
    outlined: { type: Boolean, required: false, default: false },
    disable: { type: Boolean, required: false, default: false },
    noClearButton: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit = __emit;
    const props = __props;
    const { t } = useI18n();
    const fmtDate = (val) => val ? format(val, props.dateOnly ? formatDate : formatDateTime) : "";
    const fmtCompare = (val) => format(val, "yyyy/MM/dd");
    const optionsDate = (candidate) => {
      if (props.min) {
        const min = fmtCompare(props.min);
        if (candidate < min) {
          return false;
        }
      }
      if (props.max) {
        const max = fmtCompare(props.max);
        if (candidate > max) {
          return false;
        }
      }
      return true;
    };
    const model = ref(fmtDate(props.modelValue));
    const optionsTime = (hour, min, sec) => {
      const [day] = model.value.split(" ");
      if (props.min) {
        const minDay = format(props.min, formatDate);
        if (day === minDay) {
          const minHours = props.min.getHours();
          const minMinutes = props.min.getMinutes();
          const minSeconds = props.min.getSeconds();
          if (hour > minHours) {
            return true;
          }
          if (hour === minHours) {
            if (min === null || min > minMinutes) {
              return true;
            }
            if (min === minMinutes && (sec === null || sec >= minSeconds)) {
              return true;
            }
            return false;
          }
          return false;
        }
      }
      if (props.max) {
        const maxDay = format(props.max, formatDate);
        if (day === maxDay) {
          const maxHours = props.max.getHours();
          const maxMinutes = props.max.getMinutes();
          const maxSeconds = props.max.getSeconds();
          if (hour < maxHours) {
            return true;
          }
          if (hour === maxHours) {
            if (min === null || min < maxMinutes) {
              return true;
            }
            if (min === maxMinutes && (sec === null || sec <= maxSeconds)) {
              return true;
            }
            return false;
          }
          return false;
        }
      }
      return true;
    };
    const activeTab = ref("date");
    const getRules = (p) => p.required ? [props.dateOnly ? VuetifyValidationRules.validDate : VuetifyValidationRules.validDateTime, ...props.rules] : p.rules;
    const rules = ref(getRules(props));
    watch(model, (value2) => {
      var _a;
      if (value2 === "") {
        return emit("update:modelValue");
      }
      if (props.dateOnly) {
        const [day2, month2, year2] = value2.split(".").map((i2) => parseInt(i2));
        const date2 = new Date(year2, month2 - 1, day2);
        if (isValid(date2)) {
          return emit("update:modelValue", date2);
        }
      }
      const parsed = (_a = /([0-9]{2})\.([0-9]{2})\.([0-9]{4}) ([0-9]{2}):([0-9]{2})/[Symbol.match](value2)) == null ? void 0 : _a.map((i2) => parseInt(i2));
      if (!parsed)
        return;
      parsed.shift();
      const [day, month, year, hour, minute] = parsed;
      const date = new Date(year, month - 1, day, hour, minute);
      if (isValid(date)) {
        return emit("update:modelValue", date);
      }
    });
    watch(props, (value2) => {
      model.value = fmtDate(value2.modelValue);
      rules.value = getRules(value2);
    });
    const __returned__ = { emit, props, t, formatDate, formatDateTime, maskDate, maskDateTime, fmtDate, fmtCompare, optionsDate, model, optionsTime, activeTab, getRules, rules, get vClosePopup() {
      return ClosePopup;
    }, get QBtn() {
      return QBtn;
    }, get QCard() {
      return QCard;
    }, get QCardActions() {
      return QCardActions;
    }, get QDate() {
      return QDate;
    }, get QIcon() {
      return QIcon;
    }, get QInput() {
      return QInput;
    }, get QPopupProxy() {
      return QPopupProxy;
    }, get QSeparator() {
      return QSeparator;
    }, get QTab() {
      return QTab;
    }, get QTabPanel() {
      return QTabPanel;
    }, get QTabPanels() {
      return QTabPanels;
    }, get QTabs() {
      return QTabs;
    }, get QTime() {
      return QTime;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QInput"], {
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $setup.model = $event),
    "data-qa-dateTime-selector": "",
    dense: $props.dense,
    label: $props.label,
    required: $props.required,
    rules: $setup.rules,
    outlined: $props.outlined,
    class: "q-mr-sm",
    disable: $props.disable,
    readonly: $props.disable
  }, {
    append: withCtx(() => [
      $setup.model === "" && $props.icon ? (openBlock(), createBlock($setup["QIcon"], {
        key: 0,
        name: $props.icon
      }, null, 8, ["name"])) : createCommentVNode("v-if", true),
      $setup.model !== "" && !$props.noClearButton ? (openBlock(), createBlock($setup["QIcon"], {
        key: 1,
        name: "close",
        "cursor-pointer": "",
        onClick: _cache[4] || (_cache[4] = ($event) => $setup.model = "")
      })) : createCommentVNode("v-if", true)
    ]),
    default: withCtx(() => [
      !$props.disable ? (openBlock(), createBlock($setup["QPopupProxy"], {
        key: 0,
        "transition-show": "jump-up",
        "transition-hide": "jump-down"
      }, {
        default: withCtx(() => [
          createVNode($setup["QCard"], null, {
            default: withCtx(() => [
              createVNode($setup["QTabs"], {
                modelValue: $setup.activeTab,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.activeTab = $event)
              }, {
                default: withCtx(() => [
                  createVNode($setup["QTab"], {
                    name: "date",
                    label: $setup.t("components.date")
                  }, null, 8, ["label"]),
                  !$props.dateOnly ? (openBlock(), createBlock($setup["QTab"], {
                    key: 0,
                    name: "time",
                    label: $setup.t("components.time")
                  }, null, 8, ["label"])) : createCommentVNode("v-if", true)
                ]),
                _: 1
                /* STABLE */
              }, 8, ["modelValue"]),
              createVNode($setup["QTabPanels"], {
                modelValue: $setup.activeTab,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $setup.activeTab = $event),
                class: normalizeClass({ "datetime-picker-wrapper": !$props.dateOnly }),
                animated: ""
              }, {
                default: withCtx(() => [
                  createVNode($setup["QTabPanel"], {
                    name: "date",
                    class: "q-pa-none"
                  }, {
                    default: withCtx(() => [
                      createVNode($setup["QSeparator"]),
                      createVNode($setup["QDate"], {
                        modelValue: $setup.model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.model = $event),
                        minimal: "",
                        mask: $props.dateOnly ? $setup.maskDate : $setup.maskDateTime,
                        options: $setup.optionsDate,
                        flat: ""
                      }, null, 8, ["modelValue", "mask"])
                    ]),
                    _: 1
                    /* STABLE */
                  }),
                  !$props.dateOnly ? (openBlock(), createBlock($setup["QTabPanel"], {
                    key: 0,
                    class: "q-pa-none",
                    name: "time"
                  }, {
                    default: withCtx(() => [
                      createVNode($setup["QTime"], {
                        modelValue: $setup.model,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $setup.model = $event),
                        mask: $setup.maskDateTime,
                        options: $setup.optionsTime,
                        flat: "",
                        format24h: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                    /* STABLE */
                  })) : createCommentVNode("v-if", true)
                ]),
                _: 1
                /* STABLE */
              }, 8, ["modelValue", "class"]),
              createVNode($setup["QCardActions"], { align: "right" }, {
                default: withCtx(() => [
                  withDirectives(createVNode($setup["QBtn"], {
                    label: $setup.t("common.close"),
                    color: "primary",
                    flat: ""
                  }, null, 8, ["label"]), [
                    [$setup["vClosePopup"]]
                  ])
                ]),
                _: 1
                /* STABLE */
              })
            ]),
            _: 1
            /* STABLE */
          })
        ]),
        _: 1
        /* STABLE */
      })) : createCommentVNode("v-if", true)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["modelValue", "dense", "label", "required", "rules", "outlined", "disable", "readonly"]);
}
const datetimeSelector = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__scopeId", "data-v-9b929417"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/datetime-selector.vue"]]);
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "item-count-field",
  props: /* @__PURE__ */ mergeModels({
    max: { type: Number, required: false },
    min: { type: Number, required: false },
    label: { type: String, required: false }
  }, {
    "modelValue": { type: Number, ...{} },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const model = useModel(__props, "modelValue", {
      set: (value2) => {
        if (props.min && value2 < props.min) {
          return props.min;
        } else if (props.max && value2 > props.max) {
          return props.max;
        }
        return value2;
      }
    });
    const __returned__ = { props, model, get QInput() {
      return QInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QInput"], mergeProps(_ctx.$attrs, {
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    modelModifiers: { number: true },
    type: "number",
    label: $props.label,
    class: "required",
    outlined: "",
    dense: ""
  }), null, 16, ["modelValue", "label"]);
}
const itemCountField = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/item-count-field.vue"]]);
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "legacy-selector",
  props: /* @__PURE__ */ mergeModels({
    label: { type: String, required: false },
    rules: { type: Array, required: false }
  }, {
    "modelValue": { type: Boolean, skipCheck: true },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const modelValue = useModel(__props, "modelValue");
    const { t } = useI18n();
    const options = [
      { label: t("legacySelector.dpAll"), value: void 0 },
      { label: t("legacySelector.yes"), value: true },
      { label: t("legacySelector.no"), value: false }
    ];
    const __returned__ = { modelValue, t, options, get QSelect() {
      return QSelect;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], {
    modelValue: $setup.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.modelValue = $event),
    "data-qa-legacy-dropdown": "",
    options: $setup.options,
    label: $props.label || $setup.t("legacySelector.label"),
    rules: $props.rules,
    "emit-value": "",
    "map-options": "",
    dense: "",
    flat: "",
    "dropdown-icon": "expand_more",
    outlined: ""
  }, {
    default: withCtx(() => [
      createVNode($setup["QTooltip"], {
        anchor: "top middle",
        self: "top middle",
        offset: [0, 35],
        class: "bg-grey-10 text-white shadow-4 text-caption"
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString($setup.t("legacySelector.hint")),
            1
            /* TEXT */
          )
        ]),
        _: 1
        /* STABLE */
      })
    ]),
    _: 1
    /* STABLE */
  }, 8, ["modelValue", "label", "rules"]);
}
const legacySelector = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/legacy-selector.vue"]]);
class CMSDialog {
  /**
   * Creates a new CMSDialog instance.
   * @param options Predefined dialog type or custom QDialogOptions.
   * @param customId Custom ID to be used as the dialog's unique identifier.
   */
  constructor(options, customId) {
    /** Unique identifier for the dialog. */
    __publicField(this, "id");
    /** Resolved dialog options (predefined or custom). */
    __publicField(this, "options");
    this.id = customId || v4();
    switch (options) {
      case "confirm-remove-block":
        this.options = {
          title: getI18n().t("components.blockRemoveTitle"),
          message: getI18n().t("components.blockRemoveDescription"),
          persistent: true,
          cancel: {
            label: getI18n().t("common.cancel"),
            color: "secondary",
            flat: true
          },
          ok: getI18n().t("common.yesRemove"),
          class: "text-center"
        };
        break;
      default:
        this.options = options;
    }
  }
}
function _attachDismissHandler(store2, dialogItem) {
  if (!dialogItem.hasDismissHandlerAttached) {
    dialogItem.actions.onDismiss(() => _hideDialog(store2, dialogItem.id));
    dialogItem.hasDismissHandlerAttached = true;
  }
}
function _hideDialog(store2, id) {
  const dialogIndex = store2.dialogs.findIndex((dialog) => dialog.id === id);
  if (dialogIndex !== -1) {
    const dialog = store2.dialogs[dialogIndex];
    if (!dialog) {
      const error = new Error(
        `Attempted to hide dialog on index ${dialogIndex} that does not exist in dialog store ${JSON.stringify(store2.dialogs)}`
      );
      error.name = "DialogStoreError:hideDialog";
      throw error;
    }
    dialog.isVisible = false;
    store2.dialogs.splice(dialogIndex, 1);
  }
}
function _updateExistingDialog(store2, dialogItem, options) {
  dialogItem.options = options;
  dialogItem.actions.update(options);
  if (dialogItem.isVisible) {
    return dialogItem.actions;
  }
  dialogItem.isVisible = true;
  dialogItem.actions = Dialog.create(options);
  _attachDismissHandler(store2, dialogItem);
  return dialogItem.actions;
}
function _createNewDialogEntry(store2, id, options) {
  const dialogActions = Dialog.create(options);
  const newDialogEntry = {
    id,
    isVisible: true,
    hasDismissHandlerAttached: false,
    options,
    actions: dialogActions
  };
  _attachDismissHandler(store2, newDialogEntry);
  store2.dialogs.push(newDialogEntry);
  return dialogActions;
}
const store$3 = reactive({
  dialogs: [],
  /**
   * Shows or updates a dialog. If a dialog with the given ID
   * already exists, it will be updated; otherwise, a new
   * dialog will be created.
   * @param dialog A CMSDialog object containing the ID and options.
   * @returns The Quasar DialogChainObject for further handling.
   */
  showDialog(dialog) {
    const { id, options } = dialog;
    const existingDialog = this.dialogs.find((d) => d.id === id);
    if (existingDialog) {
      return _updateExistingDialog(this, existingDialog, options);
    }
    return _createNewDialogEntry(this, id, options);
  },
  updateDialog(dialog) {
    const { id, options } = dialog;
    const existingDialog = this.dialogs.find((d) => d.id === id);
    if (!existingDialog) {
      const error = new Error(
        `Attempted to update non existing dialog with id ${dialog.id} in dialog store ${JSON.stringify(this.dialogs)}`
      );
      error.name = "DialogStoreError:updateDialog";
      throw error;
    }
    return _updateExistingDialog(this, existingDialog, options);
  },
  isDialogVisible(dialog) {
    if (!dialog && !!this.dialogs.length)
      return true;
    if (!dialog)
      return false;
    const id = typeof dialog === "string" ? dialog : dialog.id;
    return this.dialogs.some((d) => d.id === id && d.isVisible);
  }
});
store$3.showDialog = store$3.showDialog.bind(store$3);
store$3.updateDialog = store$3.updateDialog.bind(store$3);
store$3.isDialogVisible = store$3.isDialogVisible.bind(store$3);
const useDialogStore = () => store$3;
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "schedule-change-info-banner",
  props: {
    scheduleDate: { type: String, required: true },
    changedBy: { type: String, required: false, default: "" },
    disableButtonsInBanner: { type: Boolean, required: false },
    showBasicsBanner: { type: Boolean, required: true, default: true }
  },
  emits: ["remove-schedule", "edit-schedule"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const { t } = useI18n();
    const emit = __emit;
    const { showDialog: showDialog2 } = useDialogStore();
    const props = __props;
    const removeScheduledChanges = () => {
      showDialog2(
        new CMSDialog({
          title: t("scheduledChanges.remove.changesTitle"),
          message: t("scheduledChanges.remove.changesText"),
          ok: {
            class: "text-center",
            label: t("common.yes")
          },
          cancel: {
            title: t("common.cancel"),
            color: "secondary",
            flat: true
          },
          focus: "cancel"
        })
      ).onOk(() => {
        emit("remove-schedule");
      });
    };
    const editScheduledChanges = async () => {
      showDialog2(
        new CMSDialog({
          title: t("scheduledChanges.edit.changesTitle"),
          html: true,
          message: `
        ${t("scheduledChanges.edit.changesText.articleScheduledOn")} ${props.scheduleDate} ${t("common.doneBy")} ${props.changedBy}.
        ${t("scheduledChanges.edit.changesText.warningScheduledChangesPresent")}<br><br>
        ${t("scheduledChanges.edit.changesText.questionScheduledChangesWillBeOverwritten")}
      `,
          ok: {
            label: t("common.yes"),
            class: "text-center"
          },
          cancel: {
            title: t("common.cancel"),
            color: "secondary",
            flat: true
          },
          focus: "cancel"
        })
      ).onOk(async () => {
        emit("edit-schedule");
      });
    };
    const __returned__ = { t, emit, showDialog: showDialog2, props, removeScheduledChanges, editScheduledChanges, get QBtn() {
      return QBtn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$2 = {
  key: 0,
  "data-qa-article-schedule-banner": "",
  class: "banner q-py-sm q-px-md align-center q-mb-lg"
};
const _hoisted_2$2 = {
  class: "q-pa-sm text-bold",
  "data-qa-article-schedule-common-banner": ""
};
const _hoisted_3$2 = { class: "button-group" };
const _hoisted_4$1 = { class: "banner q-pa-sm align-center q-mb-lg" };
const _hoisted_5$1 = {
  "data-qa-article-schedule-edit-banner": "",
  class: "q-pa-sm text-bold"
};
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.showBasicsBanner ? (openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode(
      "div",
      _hoisted_2$2,
      toDisplayString($setup.t("common.scheduleBannerText")) + " " + toDisplayString($setup.props.scheduleDate) + " " + toDisplayString($setup.t("common.doneBy")) + " " + toDisplayString($setup.props.changedBy),
      1
      /* TEXT */
    ),
    createElementVNode("div", _hoisted_3$2, [
      createVNode($setup["QBtn"], {
        "data-qa-article-remove-changes": "",
        class: "custom-button",
        outline: "",
        disable: $props.disableButtonsInBanner,
        label: $setup.t("common.removeChange"),
        onClick: $setup.removeScheduledChanges
      }, null, 8, ["disable", "label"]),
      createVNode($setup["QBtn"], {
        disable: $props.disableButtonsInBanner,
        "data-qa-article-edit-changes": "",
        class: "custom-button",
        outline: "",
        label: $setup.t("common.editChange"),
        onClick: $setup.editScheduledChanges
      }, null, 8, ["disable", "label"])
    ])
  ])) : (openBlock(), createElementBlock(
    Fragment,
    { key: 1 },
    [
      createCommentVNode(" Show only when editor is editing it "),
      createElementVNode("div", _hoisted_4$1, [
        createElementVNode(
          "div",
          _hoisted_5$1,
          toDisplayString($setup.t("scheduledChanges.edit.changesText.editingBannerInfo")) + " " + toDisplayString($setup.props.scheduleDate),
          1
          /* TEXT */
        )
      ])
    ],
    2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  ));
}
const scheduleChangeInfoBanner = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__scopeId", "data-v-3701f0e8"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/schedule-change-info-banner.vue"]]);
const MAX_LISTED_PAGES = 6;
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "list-pagination",
  props: {
    pagination: { type: Object, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const paginationModel = computed({
      get() {
        var _a;
        return ((_a = props.pagination) == null ? void 0 : _a.currentPage) ?? 1;
      },
      set(value2) {
        var _a;
        (_a = props.pagination) == null ? void 0 : _a.goToPage(value2);
      }
    });
    const paginationMax = computed(() => {
      var _a, _b;
      const currentPage = ((_a = props.pagination) == null ? void 0 : _a.currentPage) ?? 1;
      const nextPageLink = (_b = props.pagination) == null ? void 0 : _b.nextPageLink;
      const pageRequestQueryParam = "page";
      const nextPageNumber = nextPageLink && Number(new URL(nextPageLink).searchParams.get(pageRequestQueryParam)) > currentPage ? 1 : 0;
      return currentPage + nextPageNumber;
    });
    const paginationMaxPages = computed(() => {
      return paginationMax.value >= MAX_LISTED_PAGES ? MAX_LISTED_PAGES : paginationMax.value;
    });
    const __returned__ = { props, MAX_LISTED_PAGES, paginationModel, paginationMax, paginationMaxPages, get QPagination() {
      return QPagination;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  return openBlock(), createBlock($setup["QPagination"], {
    modelValue: $setup.paginationModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.paginationModel = $event),
    max: $setup.paginationMax,
    "max-pages": $setup.paginationMaxPages,
    disable: (_a = $props.pagination) == null ? void 0 : _a.loading,
    "direction-links": "",
    "boundary-links": "",
    "icon-first": "skip_previous",
    "icon-last": "skip_next",
    "icon-prev": "fast_rewind",
    "icon-next": "fast_forward",
    "active-color": "primary"
  }, null, 8, ["modelValue", "max", "max-pages", "disable"]);
}
const ListPagination = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/list-pagination.vue"]]);
const useLoggedInWatch = (callbackFnc) => {
  const userStore2 = useUserStore();
  watch(
    () => userStore2.loggedIn,
    (newVal, oldVal) => {
      if (oldVal === false && newVal === true && userStore2.wasLoggedIn) {
        callbackFnc();
      }
    },
    { deep: true }
  );
  return {};
};
const serializeDates$1 = (value2) => {
  if (value2 instanceof Date)
    return value2.toISOString();
  if (typeof value2 === "boolean")
    return value2 ? "true" : "false";
  return value2;
};
const serializeParams$1 = (param) => {
  if (Array.isArray(param))
    return param.map(serializeDates$1);
  return serializeDates$1(param);
};
const getPageFromUrl$1 = () => {
  const page = useRouter().currentRoute.value.query.page;
  if (Array.isArray(page))
    return 1;
  return parseInt(page ?? "1");
};
const isParamSet = (value2) => value2 !== void 0 && value2 !== null;
const useEntitySearchList = (apiService, config, defaultState = {}) => {
  const router = useRouter();
  const query = router.currentRoute.value.query;
  const state = reactive({
    loading: false,
    searchFields: config.searchFields,
    parameters: config.defaultParameters ? { ...config.defaultParameters, ...query } : { ...query },
    results: [],
    currentPage: defaultState.currentPage ?? getPageFromUrl$1(),
    previousPageLink: void 0,
    nextPageLink: void 0,
    changedParameters: 0,
    activeFiltersCount: 0,
    async loadResults(resetPage = false) {
      this.loading = true;
      const parametersWithValues = Object.fromEntries(Object.entries(this.parameters).filter(([, value2]) => isParamSet(value2)));
      const { list, page, previous, next } = await apiService.listEntities({
        params: {
          ...parametersWithValues,
          page: resetPage ? 1 : this.currentPage || 1,
          size: config.pageSize
        }
      });
      this.results = list;
      this.currentPage = list.length ? page || 1 : 1;
      this.previousPageLink = previous;
      this.nextPageLink = next;
      await this.updateUrl();
      this.loading = false;
    },
    clearSearch() {
      this.parameters = config.defaultParameters ? { ...config.defaultParameters } : {};
      return this.loadResults(true);
    },
    async updateUrl() {
      if (config.updateUrl) {
        const routeQuery = Object.assign({}, state.parameters, { page: state.currentPage });
        const query2 = Object.fromEntries(
          Object.entries(routeQuery).filter(([, value2]) => isParamSet(value2)).map(([key, value2]) => [key, serializeParams$1(value2)])
        );
        await router.replace({ query: query2 });
      }
    },
    goToPage(page) {
      this.currentPage = page;
    }
  });
  const activeFiltersComputed = computed(() => {
    let count = 0;
    const { dateFrom, dateTo, ...params } = state.parameters;
    if (dateFrom && dateTo)
      count++;
    const searchItems = Object.entries(params);
    return count += searchItems.reduce((currentCount, [key, item]) => {
      if (key === "page")
        return currentCount;
      if (typeof item === "object" && !!item) {
        return Object.keys(item).length !== 0 ? currentCount + 1 : currentCount;
      } else if (typeof item === "string") {
        return item.length !== 0 ? currentCount + 1 : currentCount;
      } else {
        return isParamSet(item) ? currentCount + 1 : currentCount;
      }
    }, 0);
  });
  const loadResults = (resetPage = false) => state.loadResults(resetPage);
  const loadResultsDebounced = debounce((resetPage = false) => state.loadResults(resetPage), 350);
  useLoggedInWatch(loadResults);
  const watchers = [() => state.parameters];
  watch(
    watchers,
    () => {
      return loadResultsDebounced(config.defaultPageReset ?? true);
    },
    { deep: true }
  );
  watch(
    () => state.currentPage,
    (n, o) => {
      if (n !== o) {
        return loadResults();
      }
    },
    { deep: true }
  );
  watch(router.currentRoute, (route, previousRoute) => {
    if (previousRoute.name === route.name && Object.values(route.query).length === 0) {
      state.parameters = {};
    }
  });
  watch(activeFiltersComputed, (newCount) => {
    state.activeFiltersCount = newCount;
  });
  onBeforeMount(loadResults);
  onBeforeUnmount(loadResultsDebounced.cancel);
  return state;
};
const EntityListSearchDefaultProps = {
  dialog: false,
  multi: false
};
const HistoryModelName = "History";
const HistoryService = registerEntityEndpoint(HistoryModelName);
const { listEntities } = HistoryService;
const getLastHistoryEntry = async (entityId) => {
  const lastHistoryArray = await listEntities({
    params: {
      entityId,
      page: 1,
      size: 1
    }
  });
  return (lastHistoryArray.list ?? []).pop();
};
const registerQuasar = (app) => {
  app.use(Quasar, {
    plugins: {
      Notify,
      Dialog,
      Loading
    },
    lang: getQuasarLocale()
  });
};
const stubRule = () => true;
const quasarRulesStub = {
  date: stubRule,
  time: stubRule,
  fulltime: stubRule,
  timeOrFulltime: stubRule,
  email: stubRule,
  hexColor: stubRule,
  hexaColor: stubRule,
  hexOrHexaColor: stubRule,
  rgbColor: stubRule,
  rgbaColor: stubRule,
  rgbOrRgbaColor: stubRule,
  hexOrRgbColor: stubRule,
  hexaOrRgbaColor: stubRule,
  anyColor: stubRule
};
const quasarValidateRules = (value2, rules) => {
  if (!rules) {
    return "";
  }
  let msg;
  rules.reverse().forEach((rule) => {
    if (typeof rule === "function") {
      const ruleResult = rule(value2, quasarRulesStub);
      if (typeof ruleResult === "string" && ruleResult.length)
        msg = ruleResult;
    }
  });
  return msg || "";
};
const extendTableColumnsWithDisabledStyle = (columns, hasRowStyle) => {
  return (columns == null ? void 0 : columns.map((column) => {
    return {
      ...column,
      style: (row) => (hasRowStyle == null ? void 0 : hasRowStyle(row)) ? { background: "var(--app-bg)", cursor: "not-allowed" } : ""
    };
  })) || [];
};
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "history-tab",
  props: {
    entity: { type: String, required: true },
    entityId: { type: String, required: false },
    entityCreateDate: { type: Date, required: false }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const { t } = useI18n();
    const search = useEntitySearchList(HistoryService, {
      updateUrl: false,
      defaultPageReset: false,
      defaultParameters: {
        entityId: props.entityId
      }
    });
    __expose({
      search
    });
    const formatCreateDate = (createDate) => {
      return createDate ? formatDate$1(createDate) : "-";
    };
    const formattedEntityCreateDate = formatCreateDate(props.entityCreateDate);
    const createDescription = (changes) => {
      if (!changes)
        return "";
      let description = "";
      if (changes.state) {
        description = changes.state ? `${changes.state.oldValue} => ${changes.state.newValue}` : "";
      } else if (changes._description) {
        description = t(`historyEntryDescriptions.${changes._description}`);
      }
      return description;
    };
    const columns = extendTableColumnsWithDisabledStyle([
      {
        name: "modifiedBy",
        align: "left",
        label: t("articlesVersions.modifiedBy"),
        field: (row) => row.actorLabel
      },
      {
        name: "action",
        align: "left",
        label: t("common.action"),
        field: (row) => row.action
      },
      {
        name: "description",
        align: "left",
        label: t("common.description"),
        field: (row) => row.changes
      },
      {
        name: "modifiedAt",
        align: "left",
        label: t("articlesVersions.modifiedAt"),
        field: (row) => row.createDate
      }
    ]);
    const __returned__ = { props, t, search, formatCreateDate, formattedEntityCreateDate, createDescription, columns, get QField() {
      return QField;
    }, get QTable() {
      return QTable;
    }, get QTd() {
      return QTd;
    }, get QTh() {
      return QTh;
    }, ListPagination };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$1 = {
  class: "self-center full-width no-outline text-black",
  "data-qa-history-entity-create-date": ""
};
const _hoisted_2$1 = ["data-qa-history-last-change-by-row"];
const _hoisted_3$1 = ["data-qa-history-action-row"];
const _hoisted_4 = ["data-qa-history-description-row"];
const _hoisted_5 = ["data-qa-history-modifiedAt-row"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      $props.entityCreateDate ? (openBlock(), createBlock($setup["QField"], {
        key: 0,
        class: "q-mb-sm",
        standout: "bg-teal-1",
        dense: ""
      }, {
        default: withCtx(() => [
          createElementVNode(
            "div",
            _hoisted_1$1,
            toDisplayString($setup.t("historyEntryDescriptions.createDate", { date: $setup.formattedEntityCreateDate })),
            1
            /* TEXT */
          )
        ]),
        _: 1
        /* STABLE */
      })) : createCommentVNode("v-if", true),
      createVNode($setup["QTable"], {
        columns: $setup.columns,
        rows: $setup.search.results,
        "rows-per-page-options": [0],
        flat: "",
        "hide-bottom": "",
        "row-key": "name",
        "table-header-class": "text-grey-8"
      }, {
        "header-cell": withCtx((props) => [
          createVNode($setup["QTh"], {
            props,
            "data-qa-column-header": props.col.name
          }, {
            default: withCtx(() => [
              createTextVNode(
                toDisplayString(props.col.label),
                1
                /* TEXT */
              )
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["props", "data-qa-column-header"])
        ]),
        "body-cell-modifiedBy": withCtx((data) => [
          createVNode($setup["QTd"], { props: data }, {
            default: withCtx(() => [
              createElementVNode("span", {
                "data-qa-history-last-change-by-row": data == null ? void 0 : data.rowIndex
              }, toDisplayString(data.row.actorLabel), 9, _hoisted_2$1)
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["props"])
        ]),
        "body-cell-action": withCtx((data) => [
          createVNode($setup["QTd"], { props: data }, {
            default: withCtx(() => [
              createElementVNode("span", {
                "data-qa-history-action-row": data == null ? void 0 : data.rowIndex
              }, toDisplayString($props.entity + " " + data.row.action), 9, _hoisted_3$1)
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["props"])
        ]),
        "body-cell-description": withCtx((data) => [
          createVNode($setup["QTd"], { props: data }, {
            default: withCtx(() => [
              createElementVNode("span", {
                "data-qa-history-description-row": data == null ? void 0 : data.rowIndex
              }, toDisplayString($setup.createDescription(data.row.changes)), 9, _hoisted_4)
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["props"])
        ]),
        "body-cell-modifiedAt": withCtx((data) => [
          createVNode($setup["QTd"], { props: data }, {
            default: withCtx(() => [
              createElementVNode("span", {
                "data-qa-history-modifiedAt-row": data == null ? void 0 : data.rowIndex
              }, toDisplayString($setup.formatCreateDate(data.row.createDate)), 9, _hoisted_5)
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["props"])
        ]),
        _: 1
        /* STABLE */
      }, 8, ["columns", "rows"]),
      withDirectives(createVNode($setup["ListPagination"], {
        pagination: $setup.search,
        class: "justify-center"
      }, null, 8, ["pagination"]), [
        [vShow, $setup.search.nextPageLink || $setup.search.previousPageLink]
      ])
    ],
    64
    /* STABLE_FRAGMENT */
  );
}
const historyTab = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/tab/history-tab.vue"]]);
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "tag-input",
  props: /* @__PURE__ */ mergeModels({
    name: { type: String, required: true },
    label: { type: String, required: true },
    disable: { type: Boolean, required: false, default: false },
    readonly: { type: Boolean, required: false, default: false },
    rules: { type: null, required: false, default: () => [] }
  }, {
    "modelValue": { type: null, ...{ default: [] } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const modelValue = useModel(__props, "modelValue");
    const clearTags = ref();
    const addNewTags = (item) => {
      if (item.includes(" ") || item.includes(",")) {
        const itemReplace = item.replace(/[,\s]/g, "");
        if (!modelValue.value.includes(itemReplace))
          modelValue.value.push(itemReplace);
        if (clearTags.value)
          clearTags.value.updateInputValue("");
      }
    };
    const __returned__ = { modelValue, clearTags, addNewTags, get QChip() {
      return QChip;
    }, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], mergeProps({ ref: "clearTags" }, _ctx.$attrs, {
    modelValue: $setup.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.modelValue = $event),
    "use-input": "",
    "use-chips": "",
    multiple: "",
    "new-value-mode": "add-unique",
    dense: "",
    outlined: "",
    "hide-dropdown-icon": "",
    "dropdown-icon": "expand_more",
    label: $props.label,
    "data-qa": `${$props.name}-input`,
    rules: $props.rules,
    disable: $props.disable,
    readonly: $props.readonly,
    onInputValue: $setup.addNewTags
  }), {
    "selected-item": withCtx((scope) => [
      createVNode($setup["QChip"], {
        "data-qa": $props.name,
        removable: "",
        dense: "",
        tabindex: scope.tabindex,
        color: "cyan-1",
        "text-color": "dark",
        onRemove: ($event) => scope.removeAtIndex(scope.index)
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString(scope.opt),
            1
            /* TEXT */
          )
        ]),
        _: 2
        /* DYNAMIC */
      }, 1032, ["data-qa", "tabindex", "onRemove"])
    ]),
    _: 1
    /* STABLE */
  }, 16, ["modelValue", "label", "data-qa", "rules", "disable", "readonly"]);
}
const tagInput = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/tag-input.vue"]]);
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "tag-selector",
  props: /* @__PURE__ */ mergeModels({
    name: { type: String, required: true, default: "" },
    label: { type: String, required: true },
    options: { type: Array, required: false, default: () => [] },
    fetchLabel: { type: Function, required: false, default: void 0 },
    autocomplete: { type: Boolean, required: false, default: false },
    filterFnAsync: { type: Function, required: false, default: void 0 },
    loading: { type: Boolean, required: true, default: false },
    disable: { type: Boolean, required: true, default: false },
    readonly: { type: Boolean, required: true, default: false },
    rules: { type: null, required: false, default: () => [] }
  }, {
    "modelValue": { type: null, ...{ required: true, default: [] } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const modelValue = useModel(__props, "modelValue");
    const filteredOptions = ref([]);
    const selectRef = ref();
    const getEntityLabelById = async (id) => {
      var _a, _b;
      let label = (_a = props.options.find((item) => item.value === id)) == null ? void 0 : _a.label;
      if (!label) {
        label = await ((_b = props.fetchLabel) == null ? void 0 : _b.call(props, id));
      }
      return label || id;
    };
    const addInputValue = (inputValue, done) => {
      var _a;
      const newValue = props.options.find((option) => option.label === inputValue);
      if (newValue) {
        (_a = selectRef.value) == null ? void 0 : _a.updateInputValue("");
        done(newValue);
      }
    };
    const filterFn = (search, update) => {
      update(async () => {
        if (!props.autocomplete)
          return;
        if (props.filterFnAsync) {
          filteredOptions.value = await props.filterFnAsync(search);
          return;
        }
        filteredOptions.value = props.options.filter((option) => option.label.includes(search));
      });
    };
    const clearSearchText = () => {
      var _a;
      (_a = selectRef.value) == null ? void 0 : _a.updateInputValue("");
    };
    const onInputValue = () => {
      var _a;
      (_a = selectRef.value) == null ? void 0 : _a.setOptionIndex(-1);
    };
    watch(
      () => props.options,
      (options) => {
        filteredOptions.value = options;
      }
    );
    const __returned__ = { props, modelValue, filteredOptions, selectRef, getEntityLabelById, addInputValue, filterFn, clearSearchText, onInputValue, get QChip() {
      return QChip;
    }, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], mergeProps({ ref: "selectRef" }, _ctx.$attrs, {
    modelValue: $setup.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.modelValue = $event),
    options: $setup.filteredOptions,
    "use-input": "",
    "use-chips": "",
    multiple: "",
    "new-value-mode": "add-unique",
    dense: "",
    outlined: "",
    label: $props.label,
    "hide-dropdown-icon": "",
    "dropdown-icon": "expand_more",
    "map-options": "",
    [`data-qa-${$props.name}-selector` || ""]: $props.name,
    loading: $props.loading,
    rules: $props.rules,
    disable: $props.disable,
    readonly: $props.readonly,
    onNewValue: $setup.addInputValue,
    onFilter: $setup.filterFn,
    onAdd: $setup.clearSearchText,
    onInputValue: $setup.onInputValue
  }), createSlots({
    "selected-item": withCtx((scope) => [
      createVNode($setup["QChip"], {
        "data-qa-tag": "",
        removable: !$props.disable && !$props.readonly,
        dense: "",
        tabindex: scope.tabindex,
        color: "cyan-1",
        "text-color": "dark",
        onRemove: ($event) => scope.removeAtIndex(scope.index)
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString(scope.opt.label || $setup.getEntityLabelById(scope)),
            1
            /* TEXT */
          )
        ]),
        _: 2
        /* DYNAMIC */
      }, 1032, ["removable", "tabindex", "onRemove"])
    ]),
    _: 2
    /* DYNAMIC */
  }, [
    renderList(_ctx.$slots, (_, slotName) => {
      return {
        name: slotName,
        fn: withCtx((slotProps) => [
          renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps ?? {})))
        ])
      };
    })
  ]), 1040, ["modelValue", "options", "label", "loading", "rules", "disable", "readonly"]);
}
const tagSelector = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/tag-selector.vue"]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "toggle-button",
  props: /* @__PURE__ */ mergeModels({
    options: { type: Array, required: true },
    disable: { type: Boolean, required: false, default: false }
  }, {
    "modelValue": { type: String },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const customSlots = computed(() => {
      return props.options.filter((option) => option.slot && option.tooltip);
    });
    const model = useModel(__props, "modelValue");
    const __returned__ = { props, customSlots, model, get QBtnToggle() {
      return QBtnToggle;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QBtnToggle"], mergeProps(_ctx.$attrs, {
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    unelevated: "",
    outline: "",
    options: $props.options,
    disable: $props.disable,
    class: "toggle-button"
  }), createSlots({
    _: 2
    /* DYNAMIC */
  }, [
    renderList($setup.customSlots, (slotOption) => {
      return {
        name: slotOption.slot,
        fn: withCtx(() => [
          createVNode(
            $setup["QTooltip"],
            null,
            {
              default: withCtx(() => [
                createTextVNode(
                  toDisplayString(slotOption.tooltip),
                  1
                  /* TEXT */
                )
              ]),
              _: 2
              /* DYNAMIC */
            },
            1024
            /* DYNAMIC_SLOTS */
          )
        ])
      };
    })
  ]), 1040, ["modelValue", "options", "disable"]);
}
const toggleButton = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-0a80f376"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/toggle-button.vue"]]);
var lodash_clonedeep = { exports: {} };
lodash_clonedeep.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reFlags = /\w*$/;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var cloneableTags = {};
  cloneableTags[argsTag2] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag2] = cloneableTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  function addMapEntry(map2, pair) {
    map2.set(pair[0], pair[1]);
    return map2;
  }
  function addSetEntry(set, value2) {
    set.add(value2);
    return set;
  }
  function arrayEach(array, iteratee) {
    var index = -1, length2 = array ? array.length : 0;
    while (++index < length2) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  function arrayPush2(array, values) {
    var index = -1, length2 = values.length, offset = array.length;
    while (++index < length2) {
      array[offset + index] = values[index];
    }
    return array;
  }
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length2 = array ? array.length : 0;
    while (++index < length2) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function isHostObject2(value2) {
    var result = false;
    if (value2 != null && typeof value2.toString != "function") {
      try {
        result = !!(value2 + "");
      } catch (e) {
      }
    }
    return result;
  }
  function mapToArray(map2) {
    var index = -1, result = Array(map2.size);
    map2.forEach(function(value2, key) {
      result[++index] = [key, value2];
    });
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value2) {
      result[++index] = value2;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var objectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer2 = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, getPrototype2 = overArg2(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys = overArg2(Object.keys, Object);
  var DataView2 = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set2 = getNative2(root2, "Set"), WeakMap = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString = toSource2(DataView2), mapCtorString = toSource2(Map2), promiseCtorString = toSource2(Promise2), setCtorString = toSource2(Set2), weakMapCtorString = toSource2(WeakMap);
  var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function Hash2(entries) {
    var index = -1, length2 = entries ? entries.length : 0;
    this.clear();
    while (++index < length2) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
  }
  function hashDelete2(key) {
    return this.has(key) && delete this.__data__[key];
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value2) {
    var data = this.__data__;
    data[key] = nativeCreate2 && value2 === void 0 ? HASH_UNDEFINED2 : value2;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length2 = entries ? entries.length : 0;
    this.clear();
    while (++index < length2) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value2) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      data.push([key, value2]);
    } else {
      data[index][1] = value2;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length2 = entries ? entries.length : 0;
    this.clear();
    while (++index < length2) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    return getMapData2(this, key)["delete"](key);
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value2) {
    getMapData2(this, key).set(key, value2);
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function Stack(entries) {
    this.__data__ = new ListCache2(entries);
  }
  function stackClear() {
    this.__data__ = new ListCache2();
  }
  function stackDelete(key) {
    return this.__data__["delete"](key);
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value2) {
    var cache2 = this.__data__;
    if (cache2 instanceof ListCache2) {
      var pairs = cache2.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value2]);
        return this;
      }
      cache2 = this.__data__ = new MapCache2(pairs);
    }
    cache2.set(key, value2);
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value2, inherited) {
    var result = isArray2(value2) || isArguments2(value2) ? baseTimes2(value2.length, String) : [];
    var length2 = result.length, skipIndexes = !!length2;
    for (var key in value2) {
      if (hasOwnProperty2.call(value2, key) && !(skipIndexes && (key == "length" || isIndex2(key, length2)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assignValue(object, key, value2) {
    var objValue = object[key];
    if (!(hasOwnProperty2.call(object, key) && eq2(objValue, value2)) || value2 === void 0 && !(key in object)) {
      object[key] = value2;
    }
  }
  function assocIndexOf2(array, key) {
    var length2 = array.length;
    while (length2--) {
      if (eq2(array[length2][0], key)) {
        return length2;
      }
    }
    return -1;
  }
  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  function baseClone(value2, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) {
      result = object ? customizer(value2, key, object, stack) : customizer(value2);
    }
    if (result !== void 0) {
      return result;
    }
    if (!isObject2(value2)) {
      return value2;
    }
    var isArr = isArray2(value2);
    if (isArr) {
      result = initCloneArray(value2);
      if (!isDeep) {
        return copyArray(value2, result);
      }
    } else {
      var tag = getTag(value2), isFunc = tag == funcTag2 || tag == genTag2;
      if (isBuffer2(value2)) {
        return cloneBuffer(value2, isDeep);
      }
      if (tag == objectTag || tag == argsTag2 || isFunc && !object) {
        if (isHostObject2(value2)) {
          return object ? value2 : {};
        }
        result = initCloneObject(isFunc ? {} : value2);
        if (!isDeep) {
          return copySymbols(value2, baseAssign(result, value2));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value2 : {};
        }
        result = initCloneByTag(value2, tag, baseClone, isDeep);
      }
    }
    stack || (stack = new Stack());
    var stacked = stack.get(value2);
    if (stacked) {
      return stacked;
    }
    stack.set(value2, result);
    if (!isArr) {
      var props = isFull ? getAllKeys(value2) : keys(value2);
    }
    arrayEach(props || value2, function(subValue, key2) {
      if (props) {
        key2 = subValue;
        subValue = value2[key2];
      }
      assignValue(result, key2, baseClone(subValue, isDeep, isFull, customizer, key2, value2, stack));
    });
    return result;
  }
  function baseCreate(proto) {
    return isObject2(proto) ? objectCreate(proto) : {};
  }
  function baseGetAllKeys2(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray2(object) ? result : arrayPush2(result, symbolsFunc(object));
  }
  function baseGetTag(value2) {
    return objectToString2.call(value2);
  }
  function baseIsNative2(value2) {
    if (!isObject2(value2) || isMasked2(value2)) {
      return false;
    }
    var pattern = isFunction2(value2) || isHostObject2(value2) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value2));
  }
  function baseKeys(object) {
    if (!isPrototype2(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty2.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
  }
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
    return result;
  }
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  function cloneMap(map2, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map2), true) : mapToArray(map2);
    return arrayReduce(array, addMapEntry, new map2.constructor());
  }
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor());
  }
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  function copyArray(source, array) {
    var index = -1, length2 = source.length;
    array || (array = Array(length2));
    while (++index < length2) {
      array[index] = source[index];
    }
    return array;
  }
  function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length2 = props.length;
    while (++index < length2) {
      var key = props[index];
      var newValue = void 0;
      assignValue(object, key, newValue === void 0 ? source[key] : newValue);
    }
    return object;
  }
  function copySymbols(source, object) {
    return copyObject(source, getSymbols2(source), object);
  }
  function getAllKeys(object) {
    return baseGetAllKeys2(object, keys, getSymbols2);
  }
  function getMapData2(map2, key) {
    var data = map2.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative2(object, key) {
    var value2 = getValue2(object, key);
    return baseIsNative2(value2) ? value2 : void 0;
  }
  var getSymbols2 = nativeGetSymbols2 ? overArg2(nativeGetSymbols2, Object) : stubArray2;
  var getTag = baseGetTag;
  if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function(value2) {
      var result = objectToString2.call(value2), Ctor = result == objectTag ? value2.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : void 0;
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function initCloneArray(array) {
    var length2 = array.length, result = array.constructor(length2);
    if (length2 && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype2(object) ? baseCreate(getPrototype2(object)) : {};
  }
  function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object);
      case boolTag:
      case dateTag:
        return new Ctor(+object);
      case dataViewTag:
        return cloneDataView(object, isDeep);
      case float32Tag:
      case float64Tag:
      case int8Tag:
      case int16Tag:
      case int32Tag:
      case uint8Tag:
      case uint8ClampedTag:
      case uint16Tag:
      case uint32Tag:
        return cloneTypedArray(object, isDeep);
      case mapTag:
        return cloneMap(object, isDeep, cloneFunc);
      case numberTag:
      case stringTag:
        return new Ctor(object);
      case regexpTag:
        return cloneRegExp(object);
      case setTag:
        return cloneSet(object, isDeep, cloneFunc);
      case symbolTag2:
        return cloneSymbol(object);
    }
  }
  function isIndex2(value2, length2) {
    length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
    return !!length2 && (typeof value2 == "number" || reIsUint2.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
  }
  function isKeyable2(value2) {
    var type = typeof value2;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value2) {
    var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value2 === proto;
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function cloneDeep2(value2) {
    return baseClone(value2, true, true);
  }
  function eq2(value2, other) {
    return value2 === other || value2 !== value2 && other !== other;
  }
  function isArguments2(value2) {
    return isArrayLikeObject2(value2) && hasOwnProperty2.call(value2, "callee") && (!propertyIsEnumerable2.call(value2, "callee") || objectToString2.call(value2) == argsTag2);
  }
  var isArray2 = Array.isArray;
  function isArrayLike2(value2) {
    return value2 != null && isLength2(value2.length) && !isFunction2(value2);
  }
  function isArrayLikeObject2(value2) {
    return isObjectLike2(value2) && isArrayLike2(value2);
  }
  var isBuffer2 = nativeIsBuffer || stubFalse;
  function isFunction2(value2) {
    var tag = isObject2(value2) ? objectToString2.call(value2) : "";
    return tag == funcTag2 || tag == genTag2;
  }
  function isLength2(value2) {
    return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value2) {
    var type = typeof value2;
    return !!value2 && (type == "object" || type == "function");
  }
  function isObjectLike2(value2) {
    return !!value2 && typeof value2 == "object";
  }
  function keys(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeys(object);
  }
  function stubArray2() {
    return [];
  }
  function stubFalse() {
    return false;
  }
  module.exports = cloneDeep2;
})(lodash_clonedeep, lodash_clonedeep.exports);
var lodash_clonedeepExports = lodash_clonedeep.exports;
const cloneDeep = /* @__PURE__ */ getDefaultExportFromCjs(lodash_clonedeepExports);
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function arrayFilter(array, predicate) {
    var index = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length2) {
      var value2 = array[index];
      if (predicate(value2, index, array)) {
        result[resIndex++] = value2;
      }
    }
    return result;
  }
  function arrayPush2(array, values) {
    var index = -1, length2 = values.length, offset = array.length;
    while (++index < length2) {
      array[offset + index] = values[index];
    }
    return array;
  }
  function arraySome(array, predicate) {
    var index = -1, length2 = array == null ? 0 : array.length;
    while (++index < length2) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary(func) {
    return function(value2) {
      return func(value2);
    };
  }
  function cacheHas2(cache2, key) {
    return cache2.has(key);
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function mapToArray(map2) {
    var index = -1, result = Array(map2.size);
    map2.forEach(function(value2, key) {
      result[++index] = [key, value2];
    });
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value2) {
      result[++index] = value2;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var nativeObjectToString = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer2 = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys = overArg2(Object.keys, Object);
  var DataView2 = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set2 = getNative2(root2, "Set"), WeakMap = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString = toSource2(DataView2), mapCtorString = toSource2(Map2), promiseCtorString = toSource2(Promise2), setCtorString = toSource2(Set2), weakMapCtorString = toSource2(WeakMap);
  var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function Hash2(entries) {
    var index = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length2) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value2) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate2 && value2 === void 0 ? HASH_UNDEFINED2 : value2;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length2) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value2) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value2]);
    } else {
      data[index][1] = value2;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length2) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value2) {
    var data = getMapData2(this, key), size = data.size;
    data.set(key, value2);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values) {
    var index = -1, length2 = values == null ? 0 : values.length;
    this.__data__ = new MapCache2();
    while (++index < length2) {
      this.add(values[index]);
    }
  }
  function setCacheAdd2(value2) {
    this.__data__.set(value2, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value2) {
    return this.__data__.has(value2);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack(entries) {
    var data = this.__data__ = new ListCache2(entries);
    this.size = data.size;
  }
  function stackClear() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value2) {
    var data = this.__data__;
    if (data instanceof ListCache2) {
      var pairs = data.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value2]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache2(pairs);
    }
    data.set(key, value2);
    this.size = data.size;
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value2, inherited) {
    var isArr = isArray2(value2), isArg = !isArr && isArguments2(value2), isBuff = !isArr && !isArg && isBuffer2(value2), isType = !isArr && !isArg && !isBuff && isTypedArray2(value2), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value2.length, String) : [], length2 = result.length;
    for (var key in value2) {
      if (hasOwnProperty2.call(value2, key) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length2)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array, key) {
    var length2 = array.length;
    while (length2--) {
      if (eq2(array[length2][0], key)) {
        return length2;
      }
    }
    return -1;
  }
  function baseGetAllKeys2(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray2(object) ? result : arrayPush2(result, symbolsFunc(object));
  }
  function baseGetTag(value2) {
    if (value2 == null) {
      return value2 === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString2(value2);
  }
  function baseIsArguments(value2) {
    return isObjectLike2(value2) && baseGetTag(value2) == argsTag2;
  }
  function baseIsEqual(value2, other, bitmask, customizer, stack) {
    if (value2 === other) {
      return true;
    }
    if (value2 == null || other == null || !isObjectLike2(value2) && !isObjectLike2(other)) {
      return value2 !== value2 && other !== other;
    }
    return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack);
  }
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag2 ? objectTag : objTag;
    othTag = othTag == argsTag2 ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer2(object)) {
      if (!isBuffer2(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  function baseIsNative2(value2) {
    if (!isObject2(value2) || isMasked2(value2)) {
      return false;
    }
    var pattern = isFunction2(value2) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value2));
  }
  function baseIsTypedArray(value2) {
    return isObjectLike2(value2) && isLength2(value2.length) && !!typedArrayTags[baseGetTag(value2)];
  }
  function baseKeys(object) {
    if (!isPrototype2(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty2.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache2() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq2(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result;
      case symbolTag2:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  function getAllKeys(object) {
    return baseGetAllKeys2(object, keys, getSymbols2);
  }
  function getMapData2(map2, key) {
    var data = map2.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative2(object, key) {
    var value2 = getValue2(object, key);
    return baseIsNative2(value2) ? value2 : void 0;
  }
  function getRawTag(value2) {
    var isOwn = hasOwnProperty2.call(value2, symToStringTag), tag = value2[symToStringTag];
    try {
      value2[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString.call(value2);
    if (unmasked) {
      if (isOwn) {
        value2[symToStringTag] = tag;
      } else {
        delete value2[symToStringTag];
      }
    }
    return result;
  }
  var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols2(object), function(symbol) {
      return propertyIsEnumerable2.call(object, symbol);
    });
  };
  var getTag = baseGetTag;
  if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function(value2) {
      var result = baseGetTag(value2), Ctor = result == objectTag ? value2.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function isIndex2(value2, length2) {
    length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
    return !!length2 && (typeof value2 == "number" || reIsUint2.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
  }
  function isKeyable2(value2) {
    var type = typeof value2;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value2) {
    var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value2 === proto;
  }
  function objectToString2(value2) {
    return nativeObjectToString.call(value2);
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function eq2(value2, other) {
    return value2 === other || value2 !== value2 && other !== other;
  }
  var isArguments2 = baseIsArguments(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments : function(value2) {
    return isObjectLike2(value2) && hasOwnProperty2.call(value2, "callee") && !propertyIsEnumerable2.call(value2, "callee");
  };
  var isArray2 = Array.isArray;
  function isArrayLike2(value2) {
    return value2 != null && isLength2(value2.length) && !isFunction2(value2);
  }
  var isBuffer2 = nativeIsBuffer || stubFalse;
  function isEqual2(value2, other) {
    return baseIsEqual(value2, other);
  }
  function isFunction2(value2) {
    if (!isObject2(value2)) {
      return false;
    }
    var tag = baseGetTag(value2);
    return tag == funcTag2 || tag == genTag2 || tag == asyncTag || tag == proxyTag;
  }
  function isLength2(value2) {
    return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value2) {
    var type = typeof value2;
    return value2 != null && (type == "object" || type == "function");
  }
  function isObjectLike2(value2) {
    return value2 != null && typeof value2 == "object";
  }
  var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  function keys(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeys(object);
  }
  function stubArray2() {
    return [];
  }
  function stubFalse() {
    return false;
  }
  module.exports = isEqual2;
})(lodash_isequal, lodash_isequal.exports);
var lodash_isequalExports = lodash_isequal.exports;
const isEqual = /* @__PURE__ */ getDefaultExportFromCjs(lodash_isequalExports);
var LARGE_ARRAY_SIZE = 200;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var MAX_SAFE_INTEGER = 9007199254740991;
var argsTag = "[object Arguments]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var reIsUint = /^(?:0|[1-9]\d*)$/;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function arrayIncludes(array, value2) {
  var length2 = array ? array.length : 0;
  return !!length2 && baseIndexOf(array, value2, 0) > -1;
}
function arrayMap(array, iteratee) {
  var index = -1, length2 = array ? array.length : 0, result = Array(length2);
  while (++index < length2) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function arrayPush(array, values) {
  var index = -1, length2 = values.length, offset = array.length;
  while (++index < length2) {
    array[offset + index] = values[index];
  }
  return array;
}
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length2 = array.length, index = fromIndex + -1;
  while (++index < length2) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
function baseIndexOf(array, value2, fromIndex) {
  if (value2 !== value2) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1, length2 = array.length;
  while (++index < length2) {
    if (array[index] === value2) {
      return index;
    }
  }
  return -1;
}
function baseIsNaN(value2) {
  return value2 !== value2;
}
function baseTimes(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
function cacheHas(cache2, key) {
  return cache2.has(key);
}
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function isHostObject(value2) {
  var result = false;
  if (value2 != null && typeof value2.toString != "function") {
    try {
      result = !!(value2 + "");
    } catch (e) {
    }
  }
  return result;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
var coreJsData = root["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
var funcToString = funcProto.toString;
var hasOwnProperty = objectProto.hasOwnProperty;
var objectToString = objectProto.toString;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
var Symbol$1 = root.Symbol, getPrototype = overArg(Object.getPrototypeOf, Object), propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
var nativeGetSymbols = Object.getOwnPropertySymbols, nativeMax = Math.max;
var Map$1 = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
function Hash(entries) {
  var index = -1, length2 = entries ? entries.length : 0;
  this.clear();
  while (++index < length2) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? void 0 : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : void 0;
}
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
}
function hashSet(key, value2) {
  var data = this.__data__;
  data[key] = nativeCreate && value2 === void 0 ? HASH_UNDEFINED : value2;
  return this;
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function ListCache(entries) {
  var index = -1, length2 = entries ? entries.length : 0;
  this.clear();
  while (++index < length2) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function listCacheClear() {
  this.__data__ = [];
}
function listCacheDelete(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value2) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    data.push([key, value2]);
  } else {
    data[index][1] = value2;
  }
  return this;
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function MapCache(entries) {
  var index = -1, length2 = entries ? entries.length : 0;
  this.clear();
  while (++index < length2) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function mapCacheClear() {
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function mapCacheDelete(key) {
  return getMapData(this, key)["delete"](key);
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value2) {
  getMapData(this, key).set(key, value2);
  return this;
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function SetCache(values) {
  var index = -1, length2 = values ? values.length : 0;
  this.__data__ = new MapCache();
  while (++index < length2) {
    this.add(values[index]);
  }
}
function setCacheAdd(value2) {
  this.__data__.set(value2, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value2) {
  return this.__data__.has(value2);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arrayLikeKeys(value2, inherited) {
  var result = isArray(value2) || isArguments(value2) ? baseTimes(value2.length, String) : [];
  var length2 = result.length, skipIndexes = !!length2;
  for (var key in value2) {
    if (!(skipIndexes && (key == "length" || isIndex(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
function assocIndexOf(array, key) {
  var length2 = array.length;
  while (length2--) {
    if (eq(array[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
function baseDifference(array, values, iteratee, comparator) {
  var index = -1, includes = arrayIncludes, isCommon = true, length2 = array.length, result = [], valuesLength = values.length;
  if (!length2) {
    return result;
  }
  if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
    while (++index < length2) {
      var value2 = array[index], computed2 = value2;
      value2 = value2 !== 0 ? value2 : 0;
      if (isCommon && computed2 === computed2) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed2) {
            continue outer;
          }
        }
        result.push(value2);
      } else if (!includes(values, computed2, comparator)) {
        result.push(value2);
      }
    }
  return result;
}
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1, length2 = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length2) {
    var value2 = array[index];
    if (predicate(value2)) {
      {
        arrayPush(result, value2);
      }
    } else {
      result[result.length] = value2;
    }
  }
  return result;
}
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
function baseIsNative(value2) {
  if (!isObject$1(value2) || isMasked(value2)) {
    return false;
  }
  var pattern = isFunction(value2) || isHostObject(value2) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value2));
}
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value2, key) {
    return key in object;
  });
}
function basePickBy(object, props, predicate) {
  var index = -1, length2 = props.length, result = {};
  while (++index < length2) {
    var key = props[index], value2 = object[key];
    if (predicate(value2, key)) {
      result[key] = value2;
    }
  }
  return result;
}
function baseRest(func, start) {
  start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length2 = nativeMax(args.length - start, 0), array = Array(length2);
    while (++index < length2) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
function getMapData(map2, key) {
  var data = map2.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function getNative(object, key) {
  var value2 = getValue(object, key);
  return baseIsNative(value2) ? value2 : void 0;
}
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};
function isFlattenable(value2) {
  return isArray(value2) || isArguments(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
}
function isIndex(value2, length2) {
  length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
  return !!length2 && (typeof value2 == "number" || reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
}
function isKeyable(value2) {
  var type = typeof value2;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
}
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
function isPrototype(value2) {
  var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
  return value2 === proto;
}
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
function toKey(value2) {
  if (typeof value2 == "string" || isSymbol(value2)) {
    return value2;
  }
  var result = value2 + "";
  return result == "0" && 1 / value2 == -Infinity ? "-0" : result;
}
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
function eq(value2, other) {
  return value2 === other || value2 !== value2 && other !== other;
}
function isArguments(value2) {
  return isArrayLikeObject(value2) && hasOwnProperty.call(value2, "callee") && (!propertyIsEnumerable.call(value2, "callee") || objectToString.call(value2) == argsTag);
}
var isArray = Array.isArray;
function isArrayLike(value2) {
  return value2 != null && isLength(value2.length) && !isFunction(value2);
}
function isArrayLikeObject(value2) {
  return isObjectLike(value2) && isArrayLike(value2);
}
function isFunction(value2) {
  var tag = isObject$1(value2) ? objectToString.call(value2) : "";
  return tag == funcTag || tag == genTag;
}
function isLength(value2) {
  return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
}
function isObject$1(value2) {
  var type = typeof value2;
  return !!value2 && (type == "object" || type == "function");
}
function isObjectLike(value2) {
  return !!value2 && typeof value2 == "object";
}
function isSymbol(value2) {
  return typeof value2 == "symbol" || isObjectLike(value2) && objectToString.call(value2) == symbolTag;
}
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
}
var omit = baseRest(function(object, props) {
  if (object == null) {
    return {};
  }
  props = arrayMap(baseFlatten(props), toKey);
  return basePick(object, baseDifference(getAllKeysIn(object), props));
});
function stubArray() {
  return [];
}
var lodash_omit = omit;
const omit$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_omit);
function useChangesWatch({
  watchedValue,
  ignoredRootKeys = [],
  onValueChange
}) {
  const _getWatchedObjectSubset = (obj) => omit$1(obj, ignoredRootKeys);
  const initValue = ref(cloneDeep(_getWatchedObjectSubset(watchedValue.value)));
  const isWatchedValueChanged = ref(false);
  watch(
    () => _getWatchedObjectSubset(watchedValue.value),
    (newValue, oldValue) => {
      const isChanged = !isEqual(initValue.value, newValue);
      isWatchedValueChanged.value = isChanged;
      if (onValueChange) {
        onValueChange({
          isChanged,
          newValue,
          oldValue,
          initValue
        });
      }
    },
    { deep: true }
  );
  function resetChangesWatcher(newInitialValue = watchedValue) {
    isWatchedValueChanged.value = false;
    initValue.value = cloneDeep(_getWatchedObjectSubset(newInitialValue.value));
  }
  return {
    initValue,
    isWatchedValueChanged,
    resetChangesWatcher
  };
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "changes-watch.dialog",
  props: {
    initValue: { type: Object, required: true },
    currentValue: { type: Object, required: true },
    ignoredRootKeys: { type: Array, required: false }
  },
  emits: [...useDialogPluginComponent.emits],
  setup(__props, { expose: __expose }) {
    __expose();
    const user = useUserStore();
    const isDiffShown = ref(false);
    const hasDiffViewAccess = computed(() => user.hasRight("view_changes_watch_diff"));
    const isDiffVisible = computed(() => isDiffShown.value && hasDiffViewAccess.value);
    const { dialogRef, onDialogCancel, onDialogOK } = useDialogPluginComponent();
    const props = __props;
    function toJsonText(v) {
      return JSON.stringify(v ?? {}, null, 2);
    }
    function downloadJson(filename, content) {
      const blob = new Blob([content], { type: "application/json" });
      const url2 = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url2;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url2);
    }
    async function handleDownload(which) {
      var _a, _b;
      if (which === "initial") {
        downloadJson("initial.json", toJsonText((_a = props.initValue) == null ? void 0 : _a.value));
      }
      if (which === "current") {
        downloadJson("current.json", toJsonText((_b = props.currentValue) == null ? void 0 : _b.value));
      }
    }
    const __returned__ = { user, isDiffShown, hasDiffViewAccess, isDiffVisible, dialogRef, onDialogCancel, onDialogOK, props, toJsonText, downloadJson, handleDownload, get QBtn() {
      return QBtn;
    }, get QCard() {
      return QCard;
    }, get QCardActions() {
      return QCardActions;
    }, get QCardSection() {
      return QCardSection;
    }, get QDialog() {
      return QDialog;
    }, get GitDiffView() {
      return GitDiffView;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = {
  key: 0,
  class: "text-center"
};
const _hoisted_2 = ["textContent"];
const _hoisted_3 = ["textContent"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(
    $setup["QDialog"],
    {
      ref: "dialogRef",
      persistent: ""
    },
    {
      default: withCtx(() => [
        createVNode($setup["QCard"], {
          class: normalizeClass(["changes-dialog", {
            "changes-dialog--diff-shown": $setup.isDiffVisible
          }])
        }, {
          default: withCtx(() => [
            createVNode($setup["QCardSection"], { class: "changes-header" }, {
              default: withCtx(() => [
                !$setup.isDiffVisible ? (openBlock(), createElementBlock("div", _hoisted_1, [
                  createElementVNode("h6", {
                    class: "text-h6 q-pb-md",
                    textContent: toDisplayString(_ctx.$t("changesWatch.dialog.title"))
                  }, null, 8, _hoisted_2),
                  createElementVNode("p", {
                    textContent: toDisplayString(_ctx.$t("changesWatch.dialog.text"))
                  }, null, 8, _hoisted_3)
                ])) : createCommentVNode("v-if", true),
                $setup.isDiffVisible ? (openBlock(), createBlock($setup["QCardActions"], {
                  key: 1,
                  align: "between"
                }, {
                  default: withCtx(() => [
                    createVNode($setup["QBtn"], {
                      dense: "",
                      flat: "",
                      icon: "download",
                      label: _ctx.$t("changesWatch.dialog.downloadInitial"),
                      onClick: _cache[0] || (_cache[0] = ($event) => $setup.handleDownload("initial"))
                    }, null, 8, ["label"]),
                    createVNode($setup["QBtn"], {
                      dense: "",
                      flat: "",
                      icon: "download",
                      label: _ctx.$t("changesWatch.dialog.downloadCurrent"),
                      onClick: _cache[1] || (_cache[1] = ($event) => $setup.handleDownload("current"))
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                  /* STABLE */
                })) : createCommentVNode("v-if", true)
              ]),
              _: 1
              /* STABLE */
            }),
            $setup.isDiffVisible ? (openBlock(), createBlock($setup["QCardSection"], {
              key: 0,
              class: "changes-body q-pa-none"
            }, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent($setup.GitDiffView), {
                  "old-value": $props.initValue,
                  "new-value": $props.currentValue,
                  "ignored-root-keys": $props.ignoredRootKeys
                }, null, 8, ["old-value", "new-value", "ignored-root-keys"]))
              ]),
              _: 1
              /* STABLE */
            })) : createCommentVNode("v-if", true),
            createVNode($setup["QCardActions"], {
              class: "changes-footer",
              align: "right"
            }, {
              default: withCtx(() => [
                createCommentVNode(" Toggle DiffView button "),
                $setup.hasDiffViewAccess ? (openBlock(), createBlock($setup["QBtn"], {
                  key: 0,
                  icon: $setup.isDiffShown ? "eye-off" : "eye",
                  flat: "",
                  label: _ctx.$t("changesWatch.dialog.inspect"),
                  color: "warning",
                  onClick: _cache[2] || (_cache[2] = () => $setup.isDiffShown = !$setup.isDiffShown)
                }, null, 8, ["icon", "label"])) : createCommentVNode("v-if", true),
                createVNode($setup["QBtn"], {
                  flat: "",
                  label: _ctx.$t("changesWatch.dialog.stay"),
                  color: "secondary",
                  onClick: $setup.onDialogCancel
                }, null, 8, ["label", "onClick"]),
                createVNode($setup["QBtn"], {
                  flat: "",
                  label: _ctx.$t("changesWatch.dialog.leave"),
                  color: "primary",
                  onClick: $setup.onDialogOK
                }, null, 8, ["label", "onClick"])
              ]),
              _: 1
              /* STABLE */
            })
          ]),
          _: 1
          /* STABLE */
        }, 8, ["class"])
      ]),
      _: 1
      /* STABLE */
    },
    512
    /* NEED_PATCH */
  );
}
const ChangesWatchDialog = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-4446f4ac"], ["__file", "/builds/CT/content-technology-framework/framework/applications/editor/editor-ui-utils/src/components/dialogs/changes-watch.dialog.vue"]]);
function useConfirmChangesDialog({
  watchedValue,
  ignoredRootKeys = [],
  onValueChange
}) {
  const router = useRouter();
  let preventOnLeaveAlert = false;
  const setPreventOnLeaveAlert = (preventAlert) => {
    preventOnLeaveAlert = preventAlert;
  };
  const setOnLeaveAlert = (isChanged) => {
    window.onbeforeunload = isChanged ? () => isChanged : null;
  };
  const onBeforeDialogLeaveTrigger = (cbParams) => {
    if (onValueChange) {
      onValueChange(cbParams);
    }
    setOnLeaveAlert(cbParams.isChanged);
  };
  const {
    resetChangesWatcher: resetWatcher,
    isWatchedValueChanged,
    initValue
  } = useChangesWatch({
    watchedValue,
    ignoredRootKeys,
    onValueChange: onBeforeDialogLeaveTrigger
  });
  function resetChangesWatcher(newInitialValue) {
    setOnLeaveAlert(false);
    resetWatcher(newInitialValue);
  }
  onBeforeRouteLeave((to, from, next) => {
    if (preventOnLeaveAlert) {
      next();
      return;
    }
    if (!isWatchedValueChanged.value || from.name === to.name) {
      setOnLeaveAlert(isWatchedValueChanged.value);
      next();
      return;
    }
    next(false);
    Dialog.create({
      component: ChangesWatchDialog,
      componentProps: {
        initValue,
        currentValue: watchedValue,
        ignoredRootKeys
      }
    }).onOk(async () => {
      resetChangesWatcher(watchedValue);
      await router.push(to);
    });
  });
  return {
    initValue,
    isWatchedValueChanged,
    resetChangesWatcher,
    setPreventOnLeaveAlert
  };
}
const useDetectOutsideClick = (component, callback) => {
  if (!component)
    return { listener: () => {
    } };
  const listener = (event) => {
    if (event.target !== component.value && event.composedPath().includes(component.value)) {
      return;
    }
    if (typeof callback === "function") {
      callback();
    }
  };
  onMounted(() => {
    window.addEventListener("click", listener);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("click", listener);
  });
  return { listener };
};
async function _executeServerResponseCallbacks(callbacks, callbackInfo) {
  if (callbacks == null ? void 0 : callbacks.length) {
    await Promise.all(callbacks.map((cb) => cb(callbackInfo)));
  }
}
function useEntityQuery(options) {
  const {
    entityId,
    entityEndpoint,
    api,
    entityStore,
    entityStoreDefaults,
    resetStoreOnComponentUnmount = true,
    serverResponseCallbacks
  } = options;
  const queryClient = useQueryClient();
  const _isSameChangeDate = (newStoreData, existingStoreData = entityStore) => {
    var _a, _b;
    return !!(newStoreData == null ? void 0 : newStoreData.changeDate) && !!((_a = existingStoreData == null ? void 0 : existingStoreData.value) == null ? void 0 : _a.changeDate) && new Date(newStoreData == null ? void 0 : newStoreData.changeDate).getTime() === new Date((_b = existingStoreData.value) == null ? void 0 : _b.changeDate).getTime();
  };
  const _updateEntityStore = (newStoreData) => {
    if (!newStoreData)
      return;
    if (entityStore == null ? void 0 : entityStore.value) {
      entityStore.value = { ...entityStore.value, ...newStoreData };
    }
  };
  const {
    data: fetchedEntity,
    isLoading: isFetchingEntity,
    refetch: fetchEntity
  } = useQuery({
    queryKey: [entityEndpoint, entityId.value],
    queryFn: async () => {
      if (!entityId.value)
        throw new Error("Query tried to fetch entity with unknown id");
      try {
        const data = await api.getEntity(entityId.value);
        if (!_isSameChangeDate(data)) {
          _updateEntityStore(data);
          await _executeServerResponseCallbacks(serverResponseCallbacks, {
            method: "GET",
            status: "success",
            payload: data
          });
        }
        return data;
      } catch (error) {
        await _executeServerResponseCallbacks(serverResponseCallbacks, {
          method: "GET",
          status: "error",
          payload: error
        });
        throw error;
      }
    },
    enabled: !!entityId.value
  });
  const { isPending: isPendingEntityCreation, mutateAsync: mutateAsyncCreate } = useMutation({
    mutationKey: [entityEndpoint, entityId.value],
    mutationFn: api.postEntity,
    onSuccess: async (data) => {
      queryClient.setQueryData([entityEndpoint, entityId.value], data);
      _updateEntityStore(data);
      await _executeServerResponseCallbacks(serverResponseCallbacks, {
        method: "POST",
        status: "success",
        payload: data
      });
    },
    onError: async (error) => {
      await _executeServerResponseCallbacks(serverResponseCallbacks, {
        method: "POST",
        status: "error",
        payload: error
      });
    }
  });
  const { isPending: isPendingEntityUpdate, mutateAsync: mutateAsyncUpdate } = useMutation({
    mutationKey: [entityEndpoint, entityId.value],
    mutationFn: (request) => {
      if (!entityId.value) {
        throw new Error(`Attempted ${entityEndpoint} PUT request with undefined uuid!`);
      }
      return api.putEntity(entityId.value, request);
    },
    onSuccess: async (data) => {
      queryClient.setQueryData([entityEndpoint, entityId.value], data);
      _updateEntityStore(data);
      await _executeServerResponseCallbacks(serverResponseCallbacks, {
        method: "PUT",
        status: "success",
        payload: data
      });
    },
    onError: async (error) => {
      await _executeServerResponseCallbacks(serverResponseCallbacks, {
        method: "PUT",
        status: "error",
        payload: error
      });
    }
  });
  const { isPending: isPendingEntityDelete, mutateAsync: mutateAsyncDelete } = useMutation({
    mutationKey: [entityEndpoint, entityId.value],
    mutationFn: (id) => api.deleteEntity(id),
    onSuccess: async () => {
      queryClient.setQueryData([entityEndpoint, entityId.value], void 0);
      _updateEntityStore(cloneDeep(entityStoreDefaults));
      await _executeServerResponseCallbacks(serverResponseCallbacks, {
        method: "DELETE",
        status: "success",
        payload: void 0
      });
    },
    onError: async (error) => {
      await _executeServerResponseCallbacks(serverResponseCallbacks, {
        method: "DELETE",
        status: "error",
        payload: error
      });
    }
  });
  const isPendingEntityChangeRequest = computed(
    () => isPendingEntityCreation.value || isPendingEntityUpdate.value || isPendingEntityDelete.value
  );
  const isPendingEntityRequest = computed(() => isFetchingEntity.value || isPendingEntityChangeRequest.value);
  onUnmounted(() => {
    if (resetStoreOnComponentUnmount) {
      _updateEntityStore(cloneDeep(entityStoreDefaults));
    }
  });
  const createEntity = async (createRequestData) => {
    return await mutateAsyncCreate(createRequestData);
  };
  const updateEntity = async (updateRequestData) => {
    return await mutateAsyncUpdate(updateRequestData);
  };
  const deleteEntity2 = async (id) => {
    await mutateAsyncDelete(id);
  };
  return {
    // Fetched data from server
    fetchedEntity,
    // CRUD actions
    createEntity,
    // POST request
    updateEntity,
    // PUT request
    fetchEntity,
    // GET item request
    deleteEntity: deleteEntity2,
    // DELETE item request
    // Status flags
    isFetchingEntity,
    // Pending GET
    isPendingEntityCreation,
    // Pending POST
    isPendingEntityUpdate,
    // Pending PUT
    isPendingEntityDelete,
    // Pending DELETE
    isPendingEntityChangeRequest,
    // Any pending request that mutates entity
    isPendingEntityRequest
    // Any pending request
  };
}
const serializeDates = (value2) => {
  if (value2 instanceof Date)
    return value2.toISOString();
  if (typeof value2 === "boolean")
    return value2 ? "true" : "false";
  return value2;
};
const serializeParams = (param) => {
  if (Array.isArray(param))
    return param.map(serializeDates);
  return serializeDates(param);
};
const getPageFromUrl = () => {
  const page = useRouter().currentRoute.value.query.page;
  if (Array.isArray(page))
    return 1;
  return parseInt(page ?? "1");
};
const useEntityInfiniteSearchList = (apiService, config, defaultState = {}) => {
  const initialCurrentPage = defaultState.currentPage ?? getPageFromUrl();
  const router = useRouter();
  const query = router.currentRoute.value.query;
  let pollingInterval = null;
  const state = reactive({
    loading: false,
    searchFields: config.searchFields,
    parameters: config.defaultParameters ? { ...config.defaultParameters, ...query } : { ...query },
    results: [],
    resultIds: /* @__PURE__ */ new Set(),
    lastPollResults: [],
    previousPage: initialCurrentPage ? initialCurrentPage - 1 : 0,
    currentPage: initialCurrentPage,
    nextPage: initialCurrentPage ? initialCurrentPage + 1 : 0,
    previousPageLink: void 0,
    nextPageLink: void 0,
    changedParameters: 0,
    activeFiltersCount: 0,
    lastPollDateTime: void 0,
    isPolling: false,
    isPollingActive: false,
    async loadResults(resetPage = false) {
      if (!this.loading) {
        this.loading = true;
        if (resetPage) {
          this.resultIds = /* @__PURE__ */ new Set();
          this.lastPollResults = [];
        }
        const { list, page, previous, next } = await apiService.listEntities({
          params: {
            ...this.parameters,
            page: resetPage ? 1 : this.currentPage || 1,
            size: config.pageSize
          }
        });
        this.dedupAndStoreNewResults(list);
        this.previousPage = page - 1 || 0;
        this.currentPage = page || 1;
        this.nextPage = page + 1 || 2;
        this.previousPageLink = previous;
        this.nextPageLink = next;
        await this.updateUrl();
        this.loading = false;
      }
    },
    clearSearch() {
      this.parameters = config.defaultParameters ? { ...config.defaultParameters } : {};
      return this.loadResults(true);
    },
    async updateUrl() {
      if (config.updateUrl) {
        const routeQuery = Object.assign({}, state.parameters, { page: state.currentPage });
        const query2 = Object.fromEntries(
          Object.entries(routeQuery).filter(([, value2]) => value2 !== void 0).map(([key, value2]) => [key, serializeParams(value2)])
        );
        await router.replace({ query: query2 });
      }
    },
    async goToPage(page) {
      this.currentPage = page;
      await this.loadResults();
    },
    /**
     * Deduplicates and stores new results - newly fetched results are compared with already existing ones by "_id".
     * Any duplicates are removed from the newly fetched results.
     * @param newResults
     * @param addToFront
     */
    dedupAndStoreNewResults(newResults, addToFront = false) {
      const dedupNewResults = newResults.filter((item) => item._id && !this.resultIds.has(item._id));
      this.results = addToFront ? [...dedupNewResults, ...this.results] : [...this.results, ...dedupNewResults];
      if (addToFront)
        this.lastPollResults = dedupNewResults;
      const dedupResultsIds = dedupNewResults.map((item) => item._id).filter((item) => typeof item === "string");
      this.resultIds = new Set(Array.from(this.resultIds).concat(dedupResultsIds));
    },
    async pollForNewResults(pageSize, activePollRouterPath, newerThanQueryParam) {
      if (this.loading || this.isPolling)
        return;
      if (activePollRouterPath !== router.currentRoute.value.path) {
        this.stopPolling();
        return;
      }
      this.isPolling = true;
      try {
        const { list } = await apiService.listEntities({
          params: {
            ...this.parameters,
            page: 1,
            size: pageSize,
            ...newerThanQueryParam ? { [newerThanQueryParam]: this.lastPollDateTime } : {}
          }
        });
        const alreadyExistingIndex = list.findIndex((item) => {
          var _a;
          return item._id === ((_a = this.results[0]) == null ? void 0 : _a._id);
        });
        if (alreadyExistingIndex >= 0)
          list.splice(alreadyExistingIndex);
        this.dedupAndStoreNewResults(list, true);
        this.lastPollDateTime = /* @__PURE__ */ new Date();
        this.isPolling = false;
      } catch (e) {
        console.error(e);
        this.stopPolling();
      }
    },
    /**
     * Initiates automatic polling in specified interval.
     * @param intervalMs - interval of polling (in ms)
     * @param pageSize - what page size should be specified in automatic poll request (default is the same as pageSize in config, but that might not be enough for all the new result - adjust to your needs)
     * @param newerThanQueryParam - if provided, param will be added to the poll query so only items created after last poll are fetched
     * @returns
     */
    startPolling(intervalMs, pageSize = config.pageSize || 20, newerThanQueryParam) {
      if (pollingInterval || !intervalMs)
        return;
      const activePollRouterPath = router.currentRoute.value.path;
      pollingInterval = setInterval(() => {
        state.pollForNewResults(pageSize, activePollRouterPath, newerThanQueryParam).catch((e) => console.error(e));
      }, intervalMs);
      this.isPollingActive = true;
    },
    /**
     * Stops automatic polling by clearing the interval.
     * When using automatic polling in your component, DO NOT FORGET TO EXECUTE THIS FUNCTION onBeforeUnmount() IN YOUR COMPONENT!
     */
    stopPolling() {
      if (pollingInterval) {
        clearInterval(pollingInterval);
        pollingInterval = null;
        this.isPollingActive = false;
        this.lastPollResults = [];
        this.isPolling = false;
      }
    }
  });
  const activeFiltersComputed = computed(() => {
    let count = 0;
    const { dateFrom, dateTo, ...params } = state.parameters;
    if (dateFrom && dateTo)
      count++;
    const searchItems = Object.entries(params);
    return count += searchItems.reduce((currentCount, [key, item]) => {
      if (key === "page")
        return currentCount;
      if (typeof item === "object" && !!item) {
        return Object.keys(item).length !== 0 ? currentCount + 1 : currentCount;
      } else if (typeof item === "string") {
        return item.length !== 0 ? currentCount + 1 : currentCount;
      } else {
        return item !== void 0 ? currentCount + 1 : currentCount;
      }
    }, 0);
  });
  const loadResults = debounce((resetPage = false) => state.loadResults(resetPage), 350);
  useLoggedInWatch(loadResults);
  const watchers = [() => state.parameters];
  watch(
    watchers,
    () => {
      state.results = [];
      state.currentPage = 1;
      state.previousPage = 0;
      return loadResults(true);
    },
    { deep: true }
  );
  watch(router.currentRoute, (route, previousRoute) => {
    if (previousRoute.name === route.name && Object.values(route.query).length === 0) {
      state.parameters = {};
    }
  });
  watch(activeFiltersComputed, (newCount) => {
    state.activeFiltersCount = newCount;
  });
  loadResults();
  return state;
};
const { showDialog } = useDialogStore();
const usePublishStates = (publishable) => {
  const callbacks = {
    publish: [],
    unpublish: [],
    draft: [],
    schedule: [],
    rePublishInFuture: []
  };
  const addCb = (state, cb) => {
    callbacks[state].push(cb);
    return () => {
      callbacks[state] = callbacks[state].filter((fn) => fn !== cb);
    };
  };
  const onDialog = (state, dialog) => addCb(
    state,
    () => new Promise(
      (resolve) => showDialog(dialog).onOk(() => resolve(true)).onCancel(() => resolve(false))
    )
  );
  const checkCallbacks = async (state) => {
    for (const cb of callbacks[state]) {
      const result = await cb(publishable.value);
      if (!result) {
        return false;
      }
    }
    return true;
  };
  const changeState = async (state) => {
    if (publishable.value.state === state)
      return true;
    const result = await checkCallbacks(state);
    if (result) {
      publishable.value.state = state === "rePublishInFuture" ? "schedule" : state;
      return true;
    } else {
      return false;
    }
  };
  return {
    async checkTransition() {
      const { publishDate, unpublishDate, state } = publishable.value;
      if (state === "publish" && publishDate && publishDate > /* @__PURE__ */ new Date()) {
        return changeState("rePublishInFuture");
      } else if (!publishDate) {
        return changeState("draft");
      } else if (publishDate) {
        if (unpublishDate && unpublishDate < /* @__PURE__ */ new Date()) {
          return changeState("unpublish");
        } else {
          return publishDate <= /* @__PURE__ */ new Date() ? changeState("publish") : changeState("schedule");
        }
      }
      return true;
    },
    onDraft(cb) {
      addCb("draft", cb);
      return this;
    },
    onSchedule(cb) {
      addCb("schedule", cb);
      return this;
    },
    onPublish(cb) {
      addCb("publish", cb);
      return this;
    },
    onUnpublish(cb) {
      addCb("draft", cb);
      return this;
    },
    onRePublishInFuture(cb) {
      addCb("rePublishInFuture", cb);
      return this;
    },
    onDraftDialog(dialog) {
      onDialog("draft", dialog);
      return this;
    },
    onScheduleDialog(dialog) {
      onDialog("schedule", dialog);
      return this;
    },
    onPublishDialog(dialog) {
      onDialog("publish", dialog);
      return this;
    },
    onUnpublishDialog(dialog) {
      onDialog("unpublish", dialog);
      return this;
    },
    onRePublishInFutureDialog(dialog) {
      onDialog("rePublishInFuture", dialog);
      return this;
    },
    saveDraft: () => changeState("draft"),
    schedule: () => changeState("schedule"),
    publish: () => changeState("publish"),
    unpublish: () => changeState("unpublish")
  };
};
const _validateFormNextTick = (form, cb) => {
  return new Promise(async (resolve) => {
    await nextTick$1(async () => {
      var _a;
      const isFormValid = await ((_a = form.value) == null ? void 0 : _a.validate(true)) || false;
      if (!isFormValid) {
        resolve({ canProceed: false, isFormValid });
        return;
      }
      resolve({
        canProceed: await cb(),
        isFormValid
      });
    });
  });
};
const usePublishableForm = (form, publishable, modals) => ({
  async saveDraft(setDate = false) {
    return _validateFormNextTick(
      form,
      () => new Promise((resolve) => {
        showDialog(modals.draft()).onOk(async () => {
          if (setDate) {
            publishable.value.publishDate = void 0;
            publishable.value.displayDate = void 0;
            publishable.value.unpublishDate = void 0;
          }
          publishable.value.state = "draft";
          resolve(true);
        }).onCancel(() => resolve(false)).onDismiss(() => resolve(false));
      })
    );
  },
  async schedule() {
    return _validateFormNextTick(
      form,
      () => new Promise((resolve) => {
        showDialog(modals.schedule()).onOk(async () => {
          publishable.value.state = "schedule";
          if (!publishable.value.displayDate) {
            publishable.value.displayDate = publishable.value.publishDate;
          }
          resolve(true);
        }).onCancel(() => resolve(false)).onDismiss(() => resolve(false));
      })
    );
  },
  async publish(setDate = false) {
    return _validateFormNextTick(
      form,
      () => new Promise((resolve) => {
        showDialog(modals.publish()).onOk(async () => {
          if (setDate) {
            if (!publishable.value.publishDate || publishable.value.publishDate < /* @__PURE__ */ new Date()) {
              publishable.value.publishDate = /* @__PURE__ */ new Date();
            }
            if (!publishable.value.displayDate) {
              publishable.value.displayDate = publishable.value.type === "GALLERY" ? void 0 : /* @__PURE__ */ new Date();
            }
            if (publishable.value.unpublishDate && publishable.value.unpublishDate <= /* @__PURE__ */ new Date()) {
              publishable.value.unpublishDate = void 0;
            }
          }
          publishable.value.state = "publish";
          resolve(true);
        }).onCancel(() => resolve(false)).onDismiss(() => resolve(false));
      })
    );
  },
  async unpublish(setDate = false) {
    return _validateFormNextTick(
      form,
      () => new Promise((resolve) => {
        showDialog(modals.unpublish()).onOk(async () => {
          if (setDate) {
            publishable.value.unpublishDate = /* @__PURE__ */ new Date();
          }
          publishable.value.state = "unpublish";
          resolve(true);
        }).onCancel(() => resolve(false)).onDismiss(() => resolve(false));
      })
    );
  }
});
const useTitle = (title) => {
  const change = () => {
    document.title = `${getI18n().t(title)} - Burda Forward Editor`;
  };
  onMounted(change);
  watch(getI18n().locale, change);
};
const PACKET_TYPES = /* @__PURE__ */ Object.create(null);
PACKET_TYPES["open"] = "0";
PACKET_TYPES["close"] = "1";
PACKET_TYPES["ping"] = "2";
PACKET_TYPES["pong"] = "3";
PACKET_TYPES["message"] = "4";
PACKET_TYPES["upgrade"] = "5";
PACKET_TYPES["noop"] = "6";
const PACKET_TYPES_REVERSE = /* @__PURE__ */ Object.create(null);
Object.keys(PACKET_TYPES).forEach((key) => {
  PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
});
const ERROR_PACKET = { type: "error", data: "parser error" };
const withNativeBlob$1 = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const withNativeArrayBuffer$2 = typeof ArrayBuffer === "function";
const isView$1 = (obj) => {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const encodePacket = ({ type, data }, supportsBinary, callback) => {
  if (withNativeBlob$1 && data instanceof Blob) {
    if (supportsBinary) {
      return callback(data);
    } else {
      return encodeBlobAsBase64(data, callback);
    }
  } else if (withNativeArrayBuffer$2 && (data instanceof ArrayBuffer || isView$1(data))) {
    if (supportsBinary) {
      return callback(data);
    } else {
      return encodeBlobAsBase64(new Blob([data]), callback);
    }
  }
  return callback(PACKET_TYPES[type] + (data || ""));
};
const encodeBlobAsBase64 = (data, callback) => {
  const fileReader = new FileReader();
  fileReader.onload = function() {
    const content = fileReader.result.split(",")[1];
    callback("b" + (content || ""));
  };
  return fileReader.readAsDataURL(data);
};
function toArray(data) {
  if (data instanceof Uint8Array) {
    return data;
  } else if (data instanceof ArrayBuffer) {
    return new Uint8Array(data);
  } else {
    return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  }
}
let TEXT_ENCODER;
function encodePacketToBinary(packet, callback) {
  if (withNativeBlob$1 && packet.data instanceof Blob) {
    return packet.data.arrayBuffer().then(toArray).then(callback);
  } else if (withNativeArrayBuffer$2 && (packet.data instanceof ArrayBuffer || isView$1(packet.data))) {
    return callback(toArray(packet.data));
  }
  encodePacket(packet, false, (encoded) => {
    if (!TEXT_ENCODER) {
      TEXT_ENCODER = new TextEncoder();
    }
    callback(TEXT_ENCODER.encode(encoded));
  });
}
const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (let i2 = 0; i2 < chars.length; i2++) {
  lookup$1[chars.charCodeAt(i2)] = i2;
}
const decode$1 = (base64) => {
  let bufferLength = base64.length * 0.75, len = base64.length, i2, p = 0, encoded1, encoded2, encoded3, encoded4;
  if (base64[base64.length - 1] === "=") {
    bufferLength--;
    if (base64[base64.length - 2] === "=") {
      bufferLength--;
    }
  }
  const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
  for (i2 = 0; i2 < len; i2 += 4) {
    encoded1 = lookup$1[base64.charCodeAt(i2)];
    encoded2 = lookup$1[base64.charCodeAt(i2 + 1)];
    encoded3 = lookup$1[base64.charCodeAt(i2 + 2)];
    encoded4 = lookup$1[base64.charCodeAt(i2 + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return arraybuffer;
};
const withNativeArrayBuffer$1 = typeof ArrayBuffer === "function";
const decodePacket = (encodedPacket, binaryType) => {
  if (typeof encodedPacket !== "string") {
    return {
      type: "message",
      data: mapBinary(encodedPacket, binaryType)
    };
  }
  const type = encodedPacket.charAt(0);
  if (type === "b") {
    return {
      type: "message",
      data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
  }
  const packetType = PACKET_TYPES_REVERSE[type];
  if (!packetType) {
    return ERROR_PACKET;
  }
  return encodedPacket.length > 1 ? {
    type: PACKET_TYPES_REVERSE[type],
    data: encodedPacket.substring(1)
  } : {
    type: PACKET_TYPES_REVERSE[type]
  };
};
const decodeBase64Packet = (data, binaryType) => {
  if (withNativeArrayBuffer$1) {
    const decoded = decode$1(data);
    return mapBinary(decoded, binaryType);
  } else {
    return { base64: true, data };
  }
};
const mapBinary = (data, binaryType) => {
  switch (binaryType) {
    case "blob":
      if (data instanceof Blob) {
        return data;
      } else {
        return new Blob([data]);
      }
    case "arraybuffer":
    default:
      if (data instanceof ArrayBuffer) {
        return data;
      } else {
        return data.buffer;
      }
  }
};
const SEPARATOR = String.fromCharCode(30);
const encodePayload = (packets, callback) => {
  const length2 = packets.length;
  const encodedPackets = new Array(length2);
  let count = 0;
  packets.forEach((packet, i2) => {
    encodePacket(packet, false, (encodedPacket) => {
      encodedPackets[i2] = encodedPacket;
      if (++count === length2) {
        callback(encodedPackets.join(SEPARATOR));
      }
    });
  });
};
const decodePayload = (encodedPayload, binaryType) => {
  const encodedPackets = encodedPayload.split(SEPARATOR);
  const packets = [];
  for (let i2 = 0; i2 < encodedPackets.length; i2++) {
    const decodedPacket = decodePacket(encodedPackets[i2], binaryType);
    packets.push(decodedPacket);
    if (decodedPacket.type === "error") {
      break;
    }
  }
  return packets;
};
function createPacketEncoderStream() {
  return new TransformStream({
    transform(packet, controller) {
      encodePacketToBinary(packet, (encodedPacket) => {
        const payloadLength = encodedPacket.length;
        let header;
        if (payloadLength < 126) {
          header = new Uint8Array(1);
          new DataView(header.buffer).setUint8(0, payloadLength);
        } else if (payloadLength < 65536) {
          header = new Uint8Array(3);
          const view = new DataView(header.buffer);
          view.setUint8(0, 126);
          view.setUint16(1, payloadLength);
        } else {
          header = new Uint8Array(9);
          const view = new DataView(header.buffer);
          view.setUint8(0, 127);
          view.setBigUint64(1, BigInt(payloadLength));
        }
        if (packet.data && typeof packet.data !== "string") {
          header[0] |= 128;
        }
        controller.enqueue(header);
        controller.enqueue(encodedPacket);
      });
    }
  });
}
let TEXT_DECODER;
function totalLength(chunks) {
  return chunks.reduce((acc, chunk) => acc + chunk.length, 0);
}
function concatChunks(chunks, size) {
  if (chunks[0].length === size) {
    return chunks.shift();
  }
  const buffer = new Uint8Array(size);
  let j = 0;
  for (let i2 = 0; i2 < size; i2++) {
    buffer[i2] = chunks[0][j++];
    if (j === chunks[0].length) {
      chunks.shift();
      j = 0;
    }
  }
  if (chunks.length && j < chunks[0].length) {
    chunks[0] = chunks[0].slice(j);
  }
  return buffer;
}
function createPacketDecoderStream(maxPayload, binaryType) {
  if (!TEXT_DECODER) {
    TEXT_DECODER = new TextDecoder();
  }
  const chunks = [];
  let state = 0;
  let expectedLength = -1;
  let isBinary2 = false;
  return new TransformStream({
    transform(chunk, controller) {
      chunks.push(chunk);
      while (true) {
        if (state === 0) {
          if (totalLength(chunks) < 1) {
            break;
          }
          const header = concatChunks(chunks, 1);
          isBinary2 = (header[0] & 128) === 128;
          expectedLength = header[0] & 127;
          if (expectedLength < 126) {
            state = 3;
          } else if (expectedLength === 126) {
            state = 1;
          } else {
            state = 2;
          }
        } else if (state === 1) {
          if (totalLength(chunks) < 2) {
            break;
          }
          const headerArray = concatChunks(chunks, 2);
          expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
          state = 3;
        } else if (state === 2) {
          if (totalLength(chunks) < 8) {
            break;
          }
          const headerArray = concatChunks(chunks, 8);
          const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
          const n = view.getUint32(0);
          if (n > Math.pow(2, 53 - 32) - 1) {
            controller.enqueue(ERROR_PACKET);
            break;
          }
          expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
          state = 3;
        } else {
          if (totalLength(chunks) < expectedLength) {
            break;
          }
          const data = concatChunks(chunks, expectedLength);
          controller.enqueue(decodePacket(isBinary2 ? data : TEXT_DECODER.decode(data), binaryType));
          state = 0;
        }
        if (expectedLength === 0 || expectedLength > maxPayload) {
          controller.enqueue(ERROR_PACKET);
          break;
        }
      }
    }
  });
}
const protocol$1 = 4;
function Emitter(obj) {
  if (obj)
    return mixin(obj);
}
function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}
Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
  this._callbacks = this._callbacks || {};
  (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
  return this;
};
Emitter.prototype.once = function(event, fn) {
  function on2() {
    this.off(event, on2);
    fn.apply(this, arguments);
  }
  on2.fn = fn;
  this.on(event, on2);
  return this;
};
Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
  this._callbacks = this._callbacks || {};
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }
  var callbacks = this._callbacks["$" + event];
  if (!callbacks)
    return this;
  if (1 == arguments.length) {
    delete this._callbacks["$" + event];
    return this;
  }
  var cb;
  for (var i2 = 0; i2 < callbacks.length; i2++) {
    cb = callbacks[i2];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i2, 1);
      break;
    }
  }
  if (callbacks.length === 0) {
    delete this._callbacks["$" + event];
  }
  return this;
};
Emitter.prototype.emit = function(event) {
  this._callbacks = this._callbacks || {};
  var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
  for (var i2 = 1; i2 < arguments.length; i2++) {
    args[i2 - 1] = arguments[i2];
  }
  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i2 = 0, len = callbacks.length; i2 < len; ++i2) {
      callbacks[i2].apply(this, args);
    }
  }
  return this;
};
Emitter.prototype.emitReserved = Emitter.prototype.emit;
Emitter.prototype.listeners = function(event) {
  this._callbacks = this._callbacks || {};
  return this._callbacks["$" + event] || [];
};
Emitter.prototype.hasListeners = function(event) {
  return !!this.listeners(event).length;
};
const globalThisShim = (() => {
  if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
})();
function pick(obj, ...attr) {
  return attr.reduce((acc, k) => {
    if (obj.hasOwnProperty(k)) {
      acc[k] = obj[k];
    }
    return acc;
  }, {});
}
const NATIVE_SET_TIMEOUT = globalThisShim.setTimeout;
const NATIVE_CLEAR_TIMEOUT = globalThisShim.clearTimeout;
function installTimerFunctions(obj, opts) {
  if (opts.useNativeTimers) {
    obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim);
    obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim);
  } else {
    obj.setTimeoutFn = globalThisShim.setTimeout.bind(globalThisShim);
    obj.clearTimeoutFn = globalThisShim.clearTimeout.bind(globalThisShim);
  }
}
const BASE64_OVERHEAD = 1.33;
function byteLength(obj) {
  if (typeof obj === "string") {
    return utf8Length(obj);
  }
  return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
}
function utf8Length(str) {
  let c = 0, length2 = 0;
  for (let i2 = 0, l = str.length; i2 < l; i2++) {
    c = str.charCodeAt(i2);
    if (c < 128) {
      length2 += 1;
    } else if (c < 2048) {
      length2 += 2;
    } else if (c < 55296 || c >= 57344) {
      length2 += 3;
    } else {
      i2++;
      length2 += 4;
    }
  }
  return length2;
}
function encode$1(obj) {
  let str = "";
  for (let i2 in obj) {
    if (obj.hasOwnProperty(i2)) {
      if (str.length)
        str += "&";
      str += encodeURIComponent(i2) + "=" + encodeURIComponent(obj[i2]);
    }
  }
  return str;
}
function decode(qs) {
  let qry = {};
  let pairs = qs.split("&");
  for (let i2 = 0, l = pairs.length; i2 < l; i2++) {
    let pair = pairs[i2].split("=");
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
}
class TransportError extends Error {
  constructor(reason, description, context) {
    super(reason);
    this.description = description;
    this.context = context;
    this.type = "TransportError";
  }
}
class Transport extends Emitter {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(opts) {
    super();
    this.writable = false;
    installTimerFunctions(this, opts);
    this.opts = opts;
    this.query = opts.query;
    this.socket = opts.socket;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(reason, description, context) {
    super.emitReserved("error", new TransportError(reason, description, context));
    return this;
  }
  /**
   * Opens the transport.
   */
  open() {
    this.readyState = "opening";
    this.doOpen();
    return this;
  }
  /**
   * Closes the transport.
   */
  close() {
    if (this.readyState === "opening" || this.readyState === "open") {
      this.doClose();
      this.onClose();
    }
    return this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(packets) {
    if (this.readyState === "open") {
      this.write(packets);
    }
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open";
    this.writable = true;
    super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(data) {
    const packet = decodePacket(data, this.socket.binaryType);
    this.onPacket(packet);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(packet) {
    super.emitReserved("packet", packet);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(details) {
    this.readyState = "closed";
    super.emitReserved("close", details);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(onPause) {
  }
  createUri(schema, query = {}) {
    return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
  }
  _hostname() {
    const hostname = this.opts.hostname;
    return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
  }
  _port() {
    if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) {
      return ":" + this.opts.port;
    } else {
      return "";
    }
  }
  _query(query) {
    const encodedQuery = encode$1(query);
    return encodedQuery.length ? "?" + encodedQuery : "";
  }
}
const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), length = 64, map = {};
let seed = 0, i = 0, prev;
function encode(num) {
  let encoded = "";
  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);
  return encoded;
}
function yeast() {
  const now = encode(+/* @__PURE__ */ new Date());
  if (now !== prev)
    return seed = 0, prev = now;
  return now + "." + encode(seed++);
}
for (; i < length; i++)
  map[alphabet[i]] = i;
let value = false;
try {
  value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
}
const hasCORS = value;
function XHR(opts) {
  const xdomain = opts.xdomain;
  try {
    if ("undefined" !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) {
  }
  if (!xdomain) {
    try {
      return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {
    }
  }
}
function createCookieJar() {
}
function empty() {
}
const hasXHR2 = function() {
  const xhr = new XHR({
    xdomain: false
  });
  return null != xhr.responseType;
}();
class Polling extends Transport {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(opts) {
    super(opts);
    this.polling = false;
    if (typeof location !== "undefined") {
      const isSSL = "https:" === location.protocol;
      let port = location.port;
      if (!port) {
        port = isSSL ? "443" : "80";
      }
      this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
    }
    const forceBase64 = opts && opts.forceBase64;
    this.supportsBinary = hasXHR2 && !forceBase64;
    if (this.opts.withCredentials) {
      this.cookieJar = createCookieJar();
    }
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this.poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(onPause) {
    this.readyState = "pausing";
    const pause = () => {
      this.readyState = "paused";
      onPause();
    };
    if (this.polling || !this.writable) {
      let total = 0;
      if (this.polling) {
        total++;
        this.once("pollComplete", function() {
          --total || pause();
        });
      }
      if (!this.writable) {
        total++;
        this.once("drain", function() {
          --total || pause();
        });
      }
    } else {
      pause();
    }
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  poll() {
    this.polling = true;
    this.doPoll();
    this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(data) {
    const callback = (packet) => {
      if ("opening" === this.readyState && packet.type === "open") {
        this.onOpen();
      }
      if ("close" === packet.type) {
        this.onClose({ description: "transport closed by the server" });
        return false;
      }
      this.onPacket(packet);
    };
    decodePayload(data, this.socket.binaryType).forEach(callback);
    if ("closed" !== this.readyState) {
      this.polling = false;
      this.emitReserved("pollComplete");
      if ("open" === this.readyState) {
        this.poll();
      }
    }
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const close = () => {
      this.write([{ type: "close" }]);
    };
    if ("open" === this.readyState) {
      close();
    } else {
      this.once("open", close);
    }
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(packets) {
    this.writable = false;
    encodePayload(packets, (data) => {
      this.doWrite(data, () => {
        this.writable = true;
        this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const schema = this.opts.secure ? "https" : "http";
    const query = this.query || {};
    if (false !== this.opts.timestampRequests) {
      query[this.opts.timestampParam] = yeast();
    }
    if (!this.supportsBinary && !query.sid) {
      query.b64 = 1;
    }
    return this.createUri(schema, query);
  }
  /**
   * Creates a request.
   *
   * @param {String} method
   * @private
   */
  request(opts = {}) {
    Object.assign(opts, { xd: this.xd, cookieJar: this.cookieJar }, this.opts);
    return new Request(this.uri(), opts);
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(data, fn) {
    const req = this.request({
      method: "POST",
      data
    });
    req.on("success", fn);
    req.on("error", (xhrStatus, context) => {
      this.onError("xhr post error", xhrStatus, context);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const req = this.request();
    req.on("data", this.onData.bind(this));
    req.on("error", (xhrStatus, context) => {
      this.onError("xhr poll error", xhrStatus, context);
    });
    this.pollXhr = req;
  }
}
class Request extends Emitter {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(uri, opts) {
    super();
    installTimerFunctions(this, opts);
    this.opts = opts;
    this.method = opts.method || "GET";
    this.uri = uri;
    this.data = void 0 !== opts.data ? opts.data : null;
    this.create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  create() {
    var _a;
    const opts = pick(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    opts.xdomain = !!this.opts.xd;
    const xhr = this.xhr = new XHR(opts);
    try {
      xhr.open(this.method, this.uri, true);
      try {
        if (this.opts.extraHeaders) {
          xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
          for (let i2 in this.opts.extraHeaders) {
            if (this.opts.extraHeaders.hasOwnProperty(i2)) {
              xhr.setRequestHeader(i2, this.opts.extraHeaders[i2]);
            }
          }
        }
      } catch (e) {
      }
      if ("POST" === this.method) {
        try {
          xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch (e) {
        }
      }
      try {
        xhr.setRequestHeader("Accept", "*/*");
      } catch (e) {
      }
      (_a = this.opts.cookieJar) === null || _a === void 0 ? void 0 : _a.addCookies(xhr);
      if ("withCredentials" in xhr) {
        xhr.withCredentials = this.opts.withCredentials;
      }
      if (this.opts.requestTimeout) {
        xhr.timeout = this.opts.requestTimeout;
      }
      xhr.onreadystatechange = () => {
        var _a2;
        if (xhr.readyState === 3) {
          (_a2 = this.opts.cookieJar) === null || _a2 === void 0 ? void 0 : _a2.parseCookies(xhr);
        }
        if (4 !== xhr.readyState)
          return;
        if (200 === xhr.status || 1223 === xhr.status) {
          this.onLoad();
        } else {
          this.setTimeoutFn(() => {
            this.onError(typeof xhr.status === "number" ? xhr.status : 0);
          }, 0);
        }
      };
      xhr.send(this.data);
    } catch (e) {
      this.setTimeoutFn(() => {
        this.onError(e);
      }, 0);
      return;
    }
    if (typeof document !== "undefined") {
      this.index = Request.requestsCount++;
      Request.requests[this.index] = this;
    }
  }
  /**
   * Called upon error.
   *
   * @private
   */
  onError(err) {
    this.emitReserved("error", err, this.xhr);
    this.cleanup(true);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  cleanup(fromError) {
    if ("undefined" === typeof this.xhr || null === this.xhr) {
      return;
    }
    this.xhr.onreadystatechange = empty;
    if (fromError) {
      try {
        this.xhr.abort();
      } catch (e) {
      }
    }
    if (typeof document !== "undefined") {
      delete Request.requests[this.index];
    }
    this.xhr = null;
  }
  /**
   * Called upon load.
   *
   * @private
   */
  onLoad() {
    const data = this.xhr.responseText;
    if (data !== null) {
      this.emitReserved("data", data);
      this.emitReserved("success");
      this.cleanup();
    }
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this.cleanup();
  }
}
Request.requestsCount = 0;
Request.requests = {};
if (typeof document !== "undefined") {
  if (typeof attachEvent === "function") {
    attachEvent("onunload", unloadHandler);
  } else if (typeof addEventListener === "function") {
    const terminationEvent = "onpagehide" in globalThisShim ? "pagehide" : "unload";
    addEventListener(terminationEvent, unloadHandler, false);
  }
}
function unloadHandler() {
  for (let i2 in Request.requests) {
    if (Request.requests.hasOwnProperty(i2)) {
      Request.requests[i2].abort();
    }
  }
}
const nextTick = (() => {
  const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
  if (isPromiseAvailable) {
    return (cb) => Promise.resolve().then(cb);
  } else {
    return (cb, setTimeoutFn) => setTimeoutFn(cb, 0);
  }
})();
const WebSocket = globalThisShim.WebSocket || globalThisShim.MozWebSocket;
const usingBrowserWebSocket = true;
const defaultBinaryType = "arraybuffer";
const isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class WS extends Transport {
  /**
   * WebSocket transport constructor.
   *
   * @param {Object} opts - connection options
   * @protected
   */
  constructor(opts) {
    super(opts);
    this.supportsBinary = !opts.forceBase64;
  }
  get name() {
    return "websocket";
  }
  doOpen() {
    if (!this.check()) {
      return;
    }
    const uri = this.uri();
    const protocols = this.opts.protocols;
    const opts = isReactNative ? {} : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    if (this.opts.extraHeaders) {
      opts.headers = this.opts.extraHeaders;
    }
    try {
      this.ws = usingBrowserWebSocket && !isReactNative ? protocols ? new WebSocket(uri, protocols) : new WebSocket(uri) : new WebSocket(uri, protocols, opts);
    } catch (err) {
      return this.emitReserved("error", err);
    }
    this.ws.binaryType = this.socket.binaryType;
    this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      if (this.opts.autoUnref) {
        this.ws._socket.unref();
      }
      this.onOpen();
    };
    this.ws.onclose = (closeEvent) => this.onClose({
      description: "websocket connection closed",
      context: closeEvent
    });
    this.ws.onmessage = (ev) => this.onData(ev.data);
    this.ws.onerror = (e) => this.onError("websocket error", e);
  }
  write(packets) {
    this.writable = false;
    for (let i2 = 0; i2 < packets.length; i2++) {
      const packet = packets[i2];
      const lastPacket = i2 === packets.length - 1;
      encodePacket(packet, this.supportsBinary, (data) => {
        const opts = {};
        try {
          if (usingBrowserWebSocket) {
            this.ws.send(data);
          }
        } catch (e) {
        }
        if (lastPacket) {
          nextTick(() => {
            this.writable = true;
            this.emitReserved("drain");
          }, this.setTimeoutFn);
        }
      });
    }
  }
  doClose() {
    if (typeof this.ws !== "undefined") {
      this.ws.close();
      this.ws = null;
    }
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const schema = this.opts.secure ? "wss" : "ws";
    const query = this.query || {};
    if (this.opts.timestampRequests) {
      query[this.opts.timestampParam] = yeast();
    }
    if (!this.supportsBinary) {
      query.b64 = 1;
    }
    return this.createUri(schema, query);
  }
  /**
   * Feature detection for WebSocket.
   *
   * @return {Boolean} whether this transport is available.
   * @private
   */
  check() {
    return !!WebSocket;
  }
}
class WT extends Transport {
  get name() {
    return "webtransport";
  }
  doOpen() {
    if (typeof WebTransport !== "function") {
      return;
    }
    this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    this.transport.closed.then(() => {
      this.onClose();
    }).catch((err) => {
      this.onError("webtransport error", err);
    });
    this.transport.ready.then(() => {
      this.transport.createBidirectionalStream().then((stream) => {
        const decoderStream = createPacketDecoderStream(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
        const reader = stream.readable.pipeThrough(decoderStream).getReader();
        const encoderStream = createPacketEncoderStream();
        encoderStream.readable.pipeTo(stream.writable);
        this.writer = encoderStream.writable.getWriter();
        const read = () => {
          reader.read().then(({ done, value: value2 }) => {
            if (done) {
              return;
            }
            this.onPacket(value2);
            read();
          }).catch((err) => {
          });
        };
        read();
        const packet = { type: "open" };
        if (this.query.sid) {
          packet.data = `{"sid":"${this.query.sid}"}`;
        }
        this.writer.write(packet).then(() => this.onOpen());
      });
    });
  }
  write(packets) {
    this.writable = false;
    for (let i2 = 0; i2 < packets.length; i2++) {
      const packet = packets[i2];
      const lastPacket = i2 === packets.length - 1;
      this.writer.write(packet).then(() => {
        if (lastPacket) {
          nextTick(() => {
            this.writable = true;
            this.emitReserved("drain");
          }, this.setTimeoutFn);
        }
      });
    }
  }
  doClose() {
    var _a;
    (_a = this.transport) === null || _a === void 0 ? void 0 : _a.close();
  }
}
const transports = {
  websocket: WS,
  webtransport: WT,
  polling: Polling
};
const re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const parts = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function parse(str) {
  if (str.length > 2e3) {
    throw "URI too long";
  }
  const src = str, b = str.indexOf("["), e = str.indexOf("]");
  if (b != -1 && e != -1) {
    str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
  }
  let m = re.exec(str || ""), uri = {}, i2 = 14;
  while (i2--) {
    uri[parts[i2]] = m[i2] || "";
  }
  if (b != -1 && e != -1) {
    uri.source = src;
    uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
    uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
    uri.ipv6uri = true;
  }
  uri.pathNames = pathNames(uri, uri["path"]);
  uri.queryKey = queryKey(uri, uri["query"]);
  return uri;
}
function pathNames(obj, path) {
  const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
  if (path.slice(0, 1) == "/" || path.length === 0) {
    names.splice(0, 1);
  }
  if (path.slice(-1) == "/") {
    names.splice(names.length - 1, 1);
  }
  return names;
}
function queryKey(uri, query) {
  const data = {};
  query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
    if ($1) {
      data[$1] = $2;
    }
  });
  return data;
}
let Socket$1 = class Socket extends Emitter {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(uri, opts = {}) {
    super();
    this.binaryType = defaultBinaryType;
    this.writeBuffer = [];
    if (uri && "object" === typeof uri) {
      opts = uri;
      uri = null;
    }
    if (uri) {
      uri = parse(uri);
      opts.hostname = uri.host;
      opts.secure = uri.protocol === "https" || uri.protocol === "wss";
      opts.port = uri.port;
      if (uri.query)
        opts.query = uri.query;
    } else if (opts.host) {
      opts.hostname = parse(opts.host).host;
    }
    installTimerFunctions(this, opts);
    this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
    if (opts.hostname && !opts.port) {
      opts.port = this.secure ? "443" : "80";
    }
    this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
    this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
    this.transports = opts.transports || [
      "polling",
      "websocket",
      "webtransport"
    ];
    this.writeBuffer = [];
    this.prevBufferLen = 0;
    this.opts = Object.assign({
      path: "/engine.io",
      agent: false,
      withCredentials: false,
      upgrade: true,
      timestampParam: "t",
      rememberUpgrade: false,
      addTrailingSlash: true,
      rejectUnauthorized: true,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: false
    }, opts);
    this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
    if (typeof this.opts.query === "string") {
      this.opts.query = decode(this.opts.query);
    }
    this.id = null;
    this.upgrades = null;
    this.pingInterval = null;
    this.pingTimeout = null;
    this.pingTimeoutTimer = null;
    if (typeof addEventListener === "function") {
      if (this.opts.closeOnBeforeunload) {
        this.beforeunloadEventListener = () => {
          if (this.transport) {
            this.transport.removeAllListeners();
            this.transport.close();
          }
        };
        addEventListener("beforeunload", this.beforeunloadEventListener, false);
      }
      if (this.hostname !== "localhost") {
        this.offlineEventListener = () => {
          this.onClose("transport close", {
            description: "network connection lost"
          });
        };
        addEventListener("offline", this.offlineEventListener, false);
      }
    }
    this.open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(name) {
    const query = Object.assign({}, this.opts.query);
    query.EIO = protocol$1;
    query.transport = name;
    if (this.id)
      query.sid = this.id;
    const opts = Object.assign({}, this.opts, {
      query,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[name]);
    return new transports[name](opts);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  open() {
    let transport;
    if (this.opts.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) {
      transport = "websocket";
    } else if (0 === this.transports.length) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    } else {
      transport = this.transports[0];
    }
    this.readyState = "opening";
    try {
      transport = this.createTransport(transport);
    } catch (e) {
      this.transports.shift();
      this.open();
      return;
    }
    transport.open();
    this.setTransport(transport);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(transport) {
    if (this.transport) {
      this.transport.removeAllListeners();
    }
    this.transport = transport;
    transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason) => this.onClose("transport close", reason));
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  probe(name) {
    let transport = this.createTransport(name);
    let failed = false;
    Socket.priorWebsocketSuccess = false;
    const onTransportOpen = () => {
      if (failed)
        return;
      transport.send([{ type: "ping", data: "probe" }]);
      transport.once("packet", (msg) => {
        if (failed)
          return;
        if ("pong" === msg.type && "probe" === msg.data) {
          this.upgrading = true;
          this.emitReserved("upgrading", transport);
          if (!transport)
            return;
          Socket.priorWebsocketSuccess = "websocket" === transport.name;
          this.transport.pause(() => {
            if (failed)
              return;
            if ("closed" === this.readyState)
              return;
            cleanup();
            this.setTransport(transport);
            transport.send([{ type: "upgrade" }]);
            this.emitReserved("upgrade", transport);
            transport = null;
            this.upgrading = false;
            this.flush();
          });
        } else {
          const err = new Error("probe error");
          err.transport = transport.name;
          this.emitReserved("upgradeError", err);
        }
      });
    };
    function freezeTransport() {
      if (failed)
        return;
      failed = true;
      cleanup();
      transport.close();
      transport = null;
    }
    const onerror = (err) => {
      const error = new Error("probe error: " + err);
      error.transport = transport.name;
      freezeTransport();
      this.emitReserved("upgradeError", error);
    };
    function onTransportClose() {
      onerror("transport closed");
    }
    function onclose() {
      onerror("socket closed");
    }
    function onupgrade(to) {
      if (transport && to.name !== transport.name) {
        freezeTransport();
      }
    }
    const cleanup = () => {
      transport.removeListener("open", onTransportOpen);
      transport.removeListener("error", onerror);
      transport.removeListener("close", onTransportClose);
      this.off("close", onclose);
      this.off("upgrading", onupgrade);
    };
    transport.once("open", onTransportOpen);
    transport.once("error", onerror);
    transport.once("close", onTransportClose);
    this.once("close", onclose);
    this.once("upgrading", onupgrade);
    if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") {
      this.setTimeoutFn(() => {
        if (!failed) {
          transport.open();
        }
      }, 200);
    } else {
      transport.open();
    }
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open";
    Socket.priorWebsocketSuccess = "websocket" === this.transport.name;
    this.emitReserved("open");
    this.flush();
    if ("open" === this.readyState && this.opts.upgrade) {
      let i2 = 0;
      const l = this.upgrades.length;
      for (; i2 < l; i2++) {
        this.probe(this.upgrades[i2]);
      }
    }
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  onPacket(packet) {
    if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
      this.emitReserved("packet", packet);
      this.emitReserved("heartbeat");
      this.resetPingTimeout();
      switch (packet.type) {
        case "open":
          this.onHandshake(JSON.parse(packet.data));
          break;
        case "ping":
          this.sendPacket("pong");
          this.emitReserved("ping");
          this.emitReserved("pong");
          break;
        case "error":
          const err = new Error("server error");
          err.code = packet.data;
          this.onError(err);
          break;
        case "message":
          this.emitReserved("data", packet.data);
          this.emitReserved("message", packet.data);
          break;
      }
    }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(data) {
    this.emitReserved("handshake", data);
    this.id = data.sid;
    this.transport.query.sid = data.sid;
    this.upgrades = this.filterUpgrades(data.upgrades);
    this.pingInterval = data.pingInterval;
    this.pingTimeout = data.pingTimeout;
    this.maxPayload = data.maxPayload;
    this.onOpen();
    if ("closed" === this.readyState)
      return;
    this.resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  resetPingTimeout() {
    this.clearTimeoutFn(this.pingTimeoutTimer);
    this.pingTimeoutTimer = this.setTimeoutFn(() => {
      this.onClose("ping timeout");
    }, this.pingInterval + this.pingTimeout);
    if (this.opts.autoUnref) {
      this.pingTimeoutTimer.unref();
    }
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  onDrain() {
    this.writeBuffer.splice(0, this.prevBufferLen);
    this.prevBufferLen = 0;
    if (0 === this.writeBuffer.length) {
      this.emitReserved("drain");
    } else {
      this.flush();
    }
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const packets = this.getWritablePackets();
      this.transport.send(packets);
      this.prevBufferLen = packets.length;
      this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  getWritablePackets() {
    const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
    if (!shouldCheckPayloadSize) {
      return this.writeBuffer;
    }
    let payloadSize = 1;
    for (let i2 = 0; i2 < this.writeBuffer.length; i2++) {
      const data = this.writeBuffer[i2].data;
      if (data) {
        payloadSize += byteLength(data);
      }
      if (i2 > 0 && payloadSize > this.maxPayload) {
        return this.writeBuffer.slice(0, i2);
      }
      payloadSize += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} callback function.
   * @return {Socket} for chaining.
   */
  write(msg, options, fn) {
    this.sendPacket("message", msg, options, fn);
    return this;
  }
  send(msg, options, fn) {
    this.sendPacket("message", msg, options, fn);
    return this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  sendPacket(type, data, options, fn) {
    if ("function" === typeof data) {
      fn = data;
      data = void 0;
    }
    if ("function" === typeof options) {
      fn = options;
      options = null;
    }
    if ("closing" === this.readyState || "closed" === this.readyState) {
      return;
    }
    options = options || {};
    options.compress = false !== options.compress;
    const packet = {
      type,
      data,
      options
    };
    this.emitReserved("packetCreate", packet);
    this.writeBuffer.push(packet);
    if (fn)
      this.once("flush", fn);
    this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const close = () => {
      this.onClose("forced close");
      this.transport.close();
    };
    const cleanupAndClose = () => {
      this.off("upgrade", cleanupAndClose);
      this.off("upgradeError", cleanupAndClose);
      close();
    };
    const waitForUpgrade = () => {
      this.once("upgrade", cleanupAndClose);
      this.once("upgradeError", cleanupAndClose);
    };
    if ("opening" === this.readyState || "open" === this.readyState) {
      this.readyState = "closing";
      if (this.writeBuffer.length) {
        this.once("drain", () => {
          if (this.upgrading) {
            waitForUpgrade();
          } else {
            close();
          }
        });
      } else if (this.upgrading) {
        waitForUpgrade();
      } else {
        close();
      }
    }
    return this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  onError(err) {
    Socket.priorWebsocketSuccess = false;
    this.emitReserved("error", err);
    this.onClose("transport error", err);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  onClose(reason, description) {
    if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
      this.clearTimeoutFn(this.pingTimeoutTimer);
      this.transport.removeAllListeners("close");
      this.transport.close();
      this.transport.removeAllListeners();
      if (typeof removeEventListener === "function") {
        removeEventListener("beforeunload", this.beforeunloadEventListener, false);
        removeEventListener("offline", this.offlineEventListener, false);
      }
      this.readyState = "closed";
      this.id = null;
      this.emitReserved("close", reason, description);
      this.writeBuffer = [];
      this.prevBufferLen = 0;
    }
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  filterUpgrades(upgrades) {
    const filteredUpgrades = [];
    let i2 = 0;
    const j = upgrades.length;
    for (; i2 < j; i2++) {
      if (~this.transports.indexOf(upgrades[i2]))
        filteredUpgrades.push(upgrades[i2]);
    }
    return filteredUpgrades;
  }
};
Socket$1.protocol = protocol$1;
function url(uri, path = "", loc) {
  let obj = uri;
  loc = loc || typeof location !== "undefined" && location;
  if (null == uri)
    uri = loc.protocol + "//" + loc.host;
  if (typeof uri === "string") {
    if ("/" === uri.charAt(0)) {
      if ("/" === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }
    if (!/^(https?|wss?):\/\//.test(uri)) {
      if ("undefined" !== typeof loc) {
        uri = loc.protocol + "//" + uri;
      } else {
        uri = "https://" + uri;
      }
    }
    obj = parse(uri);
  }
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = "80";
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = "443";
    }
  }
  obj.path = obj.path || "/";
  const ipv6 = obj.host.indexOf(":") !== -1;
  const host = ipv6 ? "[" + obj.host + "]" : obj.host;
  obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
  obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
  return obj;
}
const withNativeArrayBuffer = typeof ArrayBuffer === "function";
const isView = (obj) => {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const toString2 = Object.prototype.toString;
const withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString2.call(Blob) === "[object BlobConstructor]";
const withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString2.call(File) === "[object FileConstructor]";
function isBinary(obj) {
  return withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)) || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File;
}
function hasBinary(obj, toJSON2) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  if (Array.isArray(obj)) {
    for (let i2 = 0, l = obj.length; i2 < l; i2++) {
      if (hasBinary(obj[i2])) {
        return true;
      }
    }
    return false;
  }
  if (isBinary(obj)) {
    return true;
  }
  if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }
  return false;
}
function deconstructPacket(packet) {
  const buffers = [];
  const packetData = packet.data;
  const pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length;
  return { packet: pack, buffers };
}
function _deconstructPacket(data, buffers) {
  if (!data)
    return data;
  if (isBinary(data)) {
    const placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (Array.isArray(data)) {
    const newData = new Array(data.length);
    for (let i2 = 0; i2 < data.length; i2++) {
      newData[i2] = _deconstructPacket(data[i2], buffers);
    }
    return newData;
  } else if (typeof data === "object" && !(data instanceof Date)) {
    const newData = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        newData[key] = _deconstructPacket(data[key], buffers);
      }
    }
    return newData;
  }
  return data;
}
function reconstructPacket(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  delete packet.attachments;
  return packet;
}
function _reconstructPacket(data, buffers) {
  if (!data)
    return data;
  if (data && data._placeholder === true) {
    const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
    if (isIndexValid) {
      return buffers[data.num];
    } else {
      throw new Error("illegal attachments");
    }
  } else if (Array.isArray(data)) {
    for (let i2 = 0; i2 < data.length; i2++) {
      data[i2] = _reconstructPacket(data[i2], buffers);
    }
  } else if (typeof data === "object") {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        data[key] = _reconstructPacket(data[key], buffers);
      }
    }
  }
  return data;
}
const RESERVED_EVENTS$1 = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
];
const protocol = 5;
var PacketType;
(function(PacketType2) {
  PacketType2[PacketType2["CONNECT"] = 0] = "CONNECT";
  PacketType2[PacketType2["DISCONNECT"] = 1] = "DISCONNECT";
  PacketType2[PacketType2["EVENT"] = 2] = "EVENT";
  PacketType2[PacketType2["ACK"] = 3] = "ACK";
  PacketType2[PacketType2["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
  PacketType2[PacketType2["BINARY_EVENT"] = 5] = "BINARY_EVENT";
  PacketType2[PacketType2["BINARY_ACK"] = 6] = "BINARY_ACK";
})(PacketType || (PacketType = {}));
class Encoder {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(replacer) {
    this.replacer = replacer;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(obj) {
    if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
      if (hasBinary(obj)) {
        return this.encodeAsBinary({
          type: obj.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK,
          nsp: obj.nsp,
          data: obj.data,
          id: obj.id
        });
      }
    }
    return [this.encodeAsString(obj)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(obj) {
    let str = "" + obj.type;
    if (obj.type === PacketType.BINARY_EVENT || obj.type === PacketType.BINARY_ACK) {
      str += obj.attachments + "-";
    }
    if (obj.nsp && "/" !== obj.nsp) {
      str += obj.nsp + ",";
    }
    if (null != obj.id) {
      str += obj.id;
    }
    if (null != obj.data) {
      str += JSON.stringify(obj.data, this.replacer);
    }
    return str;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(obj) {
    const deconstruction = deconstructPacket(obj);
    const pack = this.encodeAsString(deconstruction.packet);
    const buffers = deconstruction.buffers;
    buffers.unshift(pack);
    return buffers;
  }
}
function isObject(value2) {
  return Object.prototype.toString.call(value2) === "[object Object]";
}
class Decoder extends Emitter {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(reviver) {
    super();
    this.reviver = reviver;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(obj) {
    let packet;
    if (typeof obj === "string") {
      if (this.reconstructor) {
        throw new Error("got plaintext data when reconstructing a packet");
      }
      packet = this.decodeString(obj);
      const isBinaryEvent = packet.type === PacketType.BINARY_EVENT;
      if (isBinaryEvent || packet.type === PacketType.BINARY_ACK) {
        packet.type = isBinaryEvent ? PacketType.EVENT : PacketType.ACK;
        this.reconstructor = new BinaryReconstructor(packet);
        if (packet.attachments === 0) {
          super.emitReserved("decoded", packet);
        }
      } else {
        super.emitReserved("decoded", packet);
      }
    } else if (isBinary(obj) || obj.base64) {
      if (!this.reconstructor) {
        throw new Error("got binary data when not reconstructing a packet");
      } else {
        packet = this.reconstructor.takeBinaryData(obj);
        if (packet) {
          this.reconstructor = null;
          super.emitReserved("decoded", packet);
        }
      }
    } else {
      throw new Error("Unknown type: " + obj);
    }
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(str) {
    let i2 = 0;
    const p = {
      type: Number(str.charAt(0))
    };
    if (PacketType[p.type] === void 0) {
      throw new Error("unknown packet type " + p.type);
    }
    if (p.type === PacketType.BINARY_EVENT || p.type === PacketType.BINARY_ACK) {
      const start = i2 + 1;
      while (str.charAt(++i2) !== "-" && i2 != str.length) {
      }
      const buf = str.substring(start, i2);
      if (buf != Number(buf) || str.charAt(i2) !== "-") {
        throw new Error("Illegal attachments");
      }
      p.attachments = Number(buf);
    }
    if ("/" === str.charAt(i2 + 1)) {
      const start = i2 + 1;
      while (++i2) {
        const c = str.charAt(i2);
        if ("," === c)
          break;
        if (i2 === str.length)
          break;
      }
      p.nsp = str.substring(start, i2);
    } else {
      p.nsp = "/";
    }
    const next = str.charAt(i2 + 1);
    if ("" !== next && Number(next) == next) {
      const start = i2 + 1;
      while (++i2) {
        const c = str.charAt(i2);
        if (null == c || Number(c) != c) {
          --i2;
          break;
        }
        if (i2 === str.length)
          break;
      }
      p.id = Number(str.substring(start, i2 + 1));
    }
    if (str.charAt(++i2)) {
      const payload = this.tryParse(str.substr(i2));
      if (Decoder.isPayloadValid(p.type, payload)) {
        p.data = payload;
      } else {
        throw new Error("invalid payload");
      }
    }
    return p;
  }
  tryParse(str) {
    try {
      return JSON.parse(str, this.reviver);
    } catch (e) {
      return false;
    }
  }
  static isPayloadValid(type, payload) {
    switch (type) {
      case PacketType.CONNECT:
        return isObject(payload);
      case PacketType.DISCONNECT:
        return payload === void 0;
      case PacketType.CONNECT_ERROR:
        return typeof payload === "string" || isObject(payload);
      case PacketType.EVENT:
      case PacketType.BINARY_EVENT:
        return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && RESERVED_EVENTS$1.indexOf(payload[0]) === -1);
      case PacketType.ACK:
      case PacketType.BINARY_ACK:
        return Array.isArray(payload);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    if (this.reconstructor) {
      this.reconstructor.finishedReconstruction();
      this.reconstructor = null;
    }
  }
}
class BinaryReconstructor {
  constructor(packet) {
    this.packet = packet;
    this.buffers = [];
    this.reconPack = packet;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(binData) {
    this.buffers.push(binData);
    if (this.buffers.length === this.reconPack.attachments) {
      const packet = reconstructPacket(this.reconPack, this.buffers);
      this.finishedReconstruction();
      return packet;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null;
    this.buffers = [];
  }
}
const parser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder,
  Encoder,
  get PacketType() {
    return PacketType;
  },
  protocol
}, Symbol.toStringTag, { value: "Module" }));
function on(obj, ev, fn) {
  obj.on(ev, fn);
  return function subDestroy() {
    obj.off(ev, fn);
  };
}
const RESERVED_EVENTS = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class Socket2 extends Emitter {
  /**
   * `Socket` constructor.
   */
  constructor(io, nsp, opts) {
    super();
    this.connected = false;
    this.recovered = false;
    this.receiveBuffer = [];
    this.sendBuffer = [];
    this._queue = [];
    this._queueSeq = 0;
    this.ids = 0;
    this.acks = {};
    this.flags = {};
    this.io = io;
    this.nsp = nsp;
    if (opts && opts.auth) {
      this.auth = opts.auth;
    }
    this._opts = Object.assign({}, opts);
    if (this.io._autoConnect)
      this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const io = this.io;
    this.subs = [
      on(io, "open", this.onopen.bind(this)),
      on(io, "packet", this.onpacket.bind(this)),
      on(io, "error", this.onerror.bind(this)),
      on(io, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    if (this.connected)
      return this;
    this.subEvents();
    if (!this.io["_reconnecting"])
      this.io.open();
    if ("open" === this.io._readyState)
      this.onopen();
    return this;
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...args) {
    args.unshift("message");
    this.emit.apply(this, args);
    return this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(ev, ...args) {
    if (RESERVED_EVENTS.hasOwnProperty(ev)) {
      throw new Error('"' + ev.toString() + '" is a reserved event name');
    }
    args.unshift(ev);
    if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
      this._addToQueue(args);
      return this;
    }
    const packet = {
      type: PacketType.EVENT,
      data: args
    };
    packet.options = {};
    packet.options.compress = this.flags.compress !== false;
    if ("function" === typeof args[args.length - 1]) {
      const id = this.ids++;
      const ack = args.pop();
      this._registerAckCallback(id, ack);
      packet.id = id;
    }
    const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
    const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
    if (discardPacket)
      ;
    else if (this.connected) {
      this.notifyOutgoingListeners(packet);
      this.packet(packet);
    } else {
      this.sendBuffer.push(packet);
    }
    this.flags = {};
    return this;
  }
  /**
   * @private
   */
  _registerAckCallback(id, ack) {
    var _a;
    const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
    if (timeout === void 0) {
      this.acks[id] = ack;
      return;
    }
    const timer = this.io.setTimeoutFn(() => {
      delete this.acks[id];
      for (let i2 = 0; i2 < this.sendBuffer.length; i2++) {
        if (this.sendBuffer[i2].id === id) {
          this.sendBuffer.splice(i2, 1);
        }
      }
      ack.call(this, new Error("operation has timed out"));
    }, timeout);
    this.acks[id] = (...args) => {
      this.io.clearTimeoutFn(timer);
      ack.apply(this, [null, ...args]);
    };
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(ev, ...args) {
    const withErr = this.flags.timeout !== void 0 || this._opts.ackTimeout !== void 0;
    return new Promise((resolve, reject) => {
      args.push((arg1, arg2) => {
        if (withErr) {
          return arg1 ? reject(arg1) : resolve(arg2);
        } else {
          return resolve(arg1);
        }
      });
      this.emit(ev, ...args);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(args) {
    let ack;
    if (typeof args[args.length - 1] === "function") {
      ack = args.pop();
    }
    const packet = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: false,
      args,
      flags: Object.assign({ fromQueue: true }, this.flags)
    };
    args.push((err, ...responseArgs) => {
      if (packet !== this._queue[0]) {
        return;
      }
      const hasError = err !== null;
      if (hasError) {
        if (packet.tryCount > this._opts.retries) {
          this._queue.shift();
          if (ack) {
            ack(err);
          }
        }
      } else {
        this._queue.shift();
        if (ack) {
          ack(null, ...responseArgs);
        }
      }
      packet.pending = false;
      return this._drainQueue();
    });
    this._queue.push(packet);
    this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(force = false) {
    if (!this.connected || this._queue.length === 0) {
      return;
    }
    const packet = this._queue[0];
    if (packet.pending && !force) {
      return;
    }
    packet.pending = true;
    packet.tryCount++;
    this.flags = packet.flags;
    this.emit.apply(this, packet.args);
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(packet) {
    packet.nsp = this.nsp;
    this.io._packet(packet);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    if (typeof this.auth == "function") {
      this.auth((data) => {
        this._sendConnectPacket(data);
      });
    } else {
      this._sendConnectPacket(this.auth);
    }
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(data) {
    this.packet({
      type: PacketType.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, data) : data
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(err) {
    if (!this.connected) {
      this.emitReserved("connect_error", err);
    }
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(reason, description) {
    this.connected = false;
    delete this.id;
    this.emitReserved("disconnect", reason, description);
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(packet) {
    const sameNamespace = packet.nsp === this.nsp;
    if (!sameNamespace)
      return;
    switch (packet.type) {
      case PacketType.CONNECT:
        if (packet.data && packet.data.sid) {
          this.onconnect(packet.data.sid, packet.data.pid);
        } else {
          this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
        }
        break;
      case PacketType.EVENT:
      case PacketType.BINARY_EVENT:
        this.onevent(packet);
        break;
      case PacketType.ACK:
      case PacketType.BINARY_ACK:
        this.onack(packet);
        break;
      case PacketType.DISCONNECT:
        this.ondisconnect();
        break;
      case PacketType.CONNECT_ERROR:
        this.destroy();
        const err = new Error(packet.data.message);
        err.data = packet.data.data;
        this.emitReserved("connect_error", err);
        break;
    }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(packet) {
    const args = packet.data || [];
    if (null != packet.id) {
      args.push(this.ack(packet.id));
    }
    if (this.connected) {
      this.emitEvent(args);
    } else {
      this.receiveBuffer.push(Object.freeze(args));
    }
  }
  emitEvent(args) {
    if (this._anyListeners && this._anyListeners.length) {
      const listeners = this._anyListeners.slice();
      for (const listener of listeners) {
        listener.apply(this, args);
      }
    }
    super.emit.apply(this, args);
    if (this._pid && args.length && typeof args[args.length - 1] === "string") {
      this._lastOffset = args[args.length - 1];
    }
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(id) {
    const self2 = this;
    let sent = false;
    return function(...args) {
      if (sent)
        return;
      sent = true;
      self2.packet({
        type: PacketType.ACK,
        id,
        data: args
      });
    };
  }
  /**
   * Called upon a server acknowlegement.
   *
   * @param packet
   * @private
   */
  onack(packet) {
    const ack = this.acks[packet.id];
    if ("function" === typeof ack) {
      ack.apply(this, packet.data);
      delete this.acks[packet.id];
    }
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(id, pid) {
    this.id = id;
    this.recovered = pid && this._pid === pid;
    this._pid = pid;
    this.connected = true;
    this.emitBuffered();
    this.emitReserved("connect");
    this._drainQueue(true);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((args) => this.emitEvent(args));
    this.receiveBuffer = [];
    this.sendBuffer.forEach((packet) => {
      this.notifyOutgoingListeners(packet);
      this.packet(packet);
    });
    this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy();
    this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    if (this.subs) {
      this.subs.forEach((subDestroy) => subDestroy());
      this.subs = void 0;
    }
    this.io["_destroy"](this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    if (this.connected) {
      this.packet({ type: PacketType.DISCONNECT });
    }
    this.destroy();
    if (this.connected) {
      this.onclose("io client disconnect");
    }
    return this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(compress) {
    this.flags.compress = compress;
    return this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    this.flags.volatile = true;
    return this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(timeout) {
    this.flags.timeout = timeout;
    return this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(listener) {
    this._anyListeners = this._anyListeners || [];
    this._anyListeners.push(listener);
    return this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(listener) {
    this._anyListeners = this._anyListeners || [];
    this._anyListeners.unshift(listener);
    return this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(listener) {
    if (!this._anyListeners) {
      return this;
    }
    if (listener) {
      const listeners = this._anyListeners;
      for (let i2 = 0; i2 < listeners.length; i2++) {
        if (listener === listeners[i2]) {
          listeners.splice(i2, 1);
          return this;
        }
      }
    } else {
      this._anyListeners = [];
    }
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(listener) {
    this._anyOutgoingListeners = this._anyOutgoingListeners || [];
    this._anyOutgoingListeners.push(listener);
    return this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(listener) {
    this._anyOutgoingListeners = this._anyOutgoingListeners || [];
    this._anyOutgoingListeners.unshift(listener);
    return this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(listener) {
    if (!this._anyOutgoingListeners) {
      return this;
    }
    if (listener) {
      const listeners = this._anyOutgoingListeners;
      for (let i2 = 0; i2 < listeners.length; i2++) {
        if (listener === listeners[i2]) {
          listeners.splice(i2, 1);
          return this;
        }
      }
    } else {
      this._anyOutgoingListeners = [];
    }
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(packet) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const listeners = this._anyOutgoingListeners.slice();
      for (const listener of listeners) {
        listener.apply(this, packet.data);
      }
    }
  }
}
function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 1e4;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}
Backoff.prototype.duration = function() {
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand = Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};
Backoff.prototype.reset = function() {
  this.attempts = 0;
};
Backoff.prototype.setMin = function(min) {
  this.ms = min;
};
Backoff.prototype.setMax = function(max) {
  this.max = max;
};
Backoff.prototype.setJitter = function(jitter) {
  this.jitter = jitter;
};
class Manager extends Emitter {
  constructor(uri, opts) {
    var _a;
    super();
    this.nsps = {};
    this.subs = [];
    if (uri && "object" === typeof uri) {
      opts = uri;
      uri = void 0;
    }
    opts = opts || {};
    opts.path = opts.path || "/socket.io";
    this.opts = opts;
    installTimerFunctions(this, opts);
    this.reconnection(opts.reconnection !== false);
    this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
    this.reconnectionDelay(opts.reconnectionDelay || 1e3);
    this.reconnectionDelayMax(opts.reconnectionDelayMax || 5e3);
    this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
    this.backoff = new Backoff({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    });
    this.timeout(null == opts.timeout ? 2e4 : opts.timeout);
    this._readyState = "closed";
    this.uri = uri;
    const _parser = opts.parser || parser;
    this.encoder = new _parser.Encoder();
    this.decoder = new _parser.Decoder();
    this._autoConnect = opts.autoConnect !== false;
    if (this._autoConnect)
      this.open();
  }
  reconnection(v) {
    if (!arguments.length)
      return this._reconnection;
    this._reconnection = !!v;
    return this;
  }
  reconnectionAttempts(v) {
    if (v === void 0)
      return this._reconnectionAttempts;
    this._reconnectionAttempts = v;
    return this;
  }
  reconnectionDelay(v) {
    var _a;
    if (v === void 0)
      return this._reconnectionDelay;
    this._reconnectionDelay = v;
    (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
    return this;
  }
  randomizationFactor(v) {
    var _a;
    if (v === void 0)
      return this._randomizationFactor;
    this._randomizationFactor = v;
    (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
    return this;
  }
  reconnectionDelayMax(v) {
    var _a;
    if (v === void 0)
      return this._reconnectionDelayMax;
    this._reconnectionDelayMax = v;
    (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
    return this;
  }
  timeout(v) {
    if (!arguments.length)
      return this._timeout;
    this._timeout = v;
    return this;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) {
      this.reconnect();
    }
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(fn) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new Socket$1(this.uri, this.opts);
    const socket = this.engine;
    const self2 = this;
    this._readyState = "opening";
    this.skipReconnect = false;
    const openSubDestroy = on(socket, "open", function() {
      self2.onopen();
      fn && fn();
    });
    const onError = (err) => {
      this.cleanup();
      this._readyState = "closed";
      this.emitReserved("error", err);
      if (fn) {
        fn(err);
      } else {
        this.maybeReconnectOnOpen();
      }
    };
    const errorSub = on(socket, "error", onError);
    if (false !== this._timeout) {
      const timeout = this._timeout;
      const timer = this.setTimeoutFn(() => {
        openSubDestroy();
        onError(new Error("timeout"));
        socket.close();
      }, timeout);
      if (this.opts.autoUnref) {
        timer.unref();
      }
      this.subs.push(() => {
        this.clearTimeoutFn(timer);
      });
    }
    this.subs.push(openSubDestroy);
    this.subs.push(errorSub);
    return this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(fn) {
    return this.open(fn);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup();
    this._readyState = "open";
    this.emitReserved("open");
    const socket = this.engine;
    this.subs.push(on(socket, "ping", this.onping.bind(this)), on(socket, "data", this.ondata.bind(this)), on(socket, "error", this.onerror.bind(this)), on(socket, "close", this.onclose.bind(this)), on(this.decoder, "decoded", this.ondecoded.bind(this)));
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(data) {
    try {
      this.decoder.add(data);
    } catch (e) {
      this.onclose("parse error", e);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(packet) {
    nextTick(() => {
      this.emitReserved("packet", packet);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(err) {
    this.emitReserved("error", err);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(nsp, opts) {
    let socket = this.nsps[nsp];
    if (!socket) {
      socket = new Socket2(this, nsp, opts);
      this.nsps[nsp] = socket;
    } else if (this._autoConnect && !socket.active) {
      socket.connect();
    }
    return socket;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(socket) {
    const nsps = Object.keys(this.nsps);
    for (const nsp of nsps) {
      const socket2 = this.nsps[nsp];
      if (socket2.active) {
        return;
      }
    }
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(packet) {
    const encodedPackets = this.encoder.encode(packet);
    for (let i2 = 0; i2 < encodedPackets.length; i2++) {
      this.engine.write(encodedPackets[i2], packet.options);
    }
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((subDestroy) => subDestroy());
    this.subs.length = 0;
    this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = true;
    this._reconnecting = false;
    this.onclose("forced close");
    if (this.engine)
      this.engine.close();
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called upon engine close.
   *
   * @private
   */
  onclose(reason, description) {
    this.cleanup();
    this.backoff.reset();
    this._readyState = "closed";
    this.emitReserved("close", reason, description);
    if (this._reconnection && !this.skipReconnect) {
      this.reconnect();
    }
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const self2 = this;
    if (this.backoff.attempts >= this._reconnectionAttempts) {
      this.backoff.reset();
      this.emitReserved("reconnect_failed");
      this._reconnecting = false;
    } else {
      const delay = this.backoff.duration();
      this._reconnecting = true;
      const timer = this.setTimeoutFn(() => {
        if (self2.skipReconnect)
          return;
        this.emitReserved("reconnect_attempt", self2.backoff.attempts);
        if (self2.skipReconnect)
          return;
        self2.open((err) => {
          if (err) {
            self2._reconnecting = false;
            self2.reconnect();
            this.emitReserved("reconnect_error", err);
          } else {
            self2.onreconnect();
          }
        });
      }, delay);
      if (this.opts.autoUnref) {
        timer.unref();
      }
      this.subs.push(() => {
        this.clearTimeoutFn(timer);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const attempt = this.backoff.attempts;
    this._reconnecting = false;
    this.backoff.reset();
    this.emitReserved("reconnect", attempt);
  }
}
const cache = {};
function lookup(uri, opts) {
  if (typeof uri === "object") {
    opts = uri;
    uri = void 0;
  }
  opts = opts || {};
  const parsed = url(uri, opts.path || "/socket.io");
  const source = parsed.source;
  const id = parsed.id;
  const path = parsed.path;
  const sameNamespace = cache[id] && path in cache[id]["nsps"];
  const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
  let io;
  if (newConnection) {
    io = new Manager(source, opts);
  } else {
    if (!cache[id]) {
      cache[id] = new Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.queryKey;
  }
  return io.socket(parsed.path, opts);
}
Object.assign(lookup, {
  Manager,
  Socket: Socket2,
  io: lookup,
  connect: lookup
});
const connected = ref(false);
const store$2 = {
  io: {},
  connected
};
const connectSockets = async (url2, opts, failOnError = true) => {
  store$2.io = new Manager(url2, opts);
  return new Promise((resolve, reject) => {
    store$2.io.once("open", () => resolve(void 0));
    if (failOnError) {
      store$2.io.once("error", reject);
    }
    store$2.io.on("open", () => {
      connected.value = true;
    });
    store$2.io.on("close", () => {
      connected.value = false;
    });
  });
};
const useSockets = () => store$2.io;
const useSocketConnected = () => store$2.connected;
const isApiError = (res) => {
  return "statusCode" in res && res.statusCode >= 400;
};
const isApiResponse = (res) => {
  return "code" in res && res.code < 400;
};
const restSearch = async (entityName, query) => {
  const resp = await getClient().get(`/cms/${entityName}`, { params: query });
  return resp.data;
};
const store$1 = reactive({
  modules: /* @__PURE__ */ new Set(),
  addModule(module) {
    if (module.contentBlocks) {
      for (const block of module.contentBlocks) {
        block.component = markRaw(block.component);
      }
    }
    this.modules.add(module);
  },
  getModules() {
    return Array.from(this.modules);
  }
});
const useModuleStore = () => store$1;
const store = reactive({
  refs: /* @__PURE__ */ new Set(),
  onMount(self2) {
    this.refs.add(self2);
  },
  onUnmount(self2) {
    this.refs.delete(self2);
  },
  words: computed(() => Array.from(store.refs).reduce((sum, c) => {
    var _a;
    return sum + (((_a = c.value.wordCharCount) == null ? void 0 : _a.words) || 0);
  }, 0)),
  characters: computed(() => Array.from(store.refs).reduce((sum, c) => {
    var _a;
    return sum + (((_a = c.value.wordCharCount) == null ? void 0 : _a.characters) || 0);
  }, 0))
});
const useWordCountStore = () => store;
const brandUrls = {
  BUNTE: GLOBAL_CONFIG.URL_BUNTE,
  BUNTE_PUBLISH: GLOBAL_CONFIG.URL_BUNTE_PUBLISH,
  CHIP: GLOBAL_CONFIG.URL_CHIP,
  CHIP_PUBLISH: GLOBAL_CONFIG.URL_CHIP_PUBLISH,
  FOCUS: GLOBAL_CONFIG.URL_FOCUS,
  FOCUS_PUBLISH: GLOBAL_CONFIG.URL_FOCUS_PUBLISH,
  FITFORFUN: GLOBAL_CONFIG.URL_FITFORFUN,
  FITFORFUN_PUBLISH: GLOBAL_CONFIG.URL_FITFORFUN_PUBLISH
};
const getBaseUrlForBrand = (brand, state) => {
  if (GLOBAL_CONFIG.NODE_ENV === "sandbox") {
    return brandUrls[brand.toUpperCase()];
  } else {
    return (state == null ? void 0 : state.toUpperCase()) === "PUBLISH" ? brandUrls[`${brand.toUpperCase()}_${state.toUpperCase()}`] : brandUrls[brand.toUpperCase()];
  }
};
const userStore = useUserStore();
const isAllowed = (right) => {
  return userStore.hasRight(right);
};
const isDocumentActionAllowed = (action, documentAccessRightPostfix, document2) => {
  const actionType = `${action}_${documentAccessRightPostfix}`;
  if (documentAccessRightPostfix === "article" && document2 && "scheduledUpdates" in document2 && action === "edit") {
    const hasScheduledUpdates = document2.scheduledUpdates && document2.scheduledUpdates.length > 0;
    if (hasScheduledUpdates) {
      return false;
    }
  }
  if (document2 && document2.legacy && action === "edit") {
    return document2.legacy.isEditableInCTF && isAllowed(actionType);
  }
  return isAllowed(actionType);
};
const isDocumentEditable = (documentAccessRightPostfix, document2) => {
  return isDocumentActionAllowed("edit", documentAccessRightPostfix, document2);
};
const isDocumentVisitable = (documentAccessRightPostfix, document2) => {
  return isDocumentActionAllowed("navigate", documentAccessRightPostfix, document2);
};
const isSafari = typeof window.safari !== "undefined";
const convertToBool = (stringBoolean, defaultValue2 = false) => {
  switch (stringBoolean) {
    case typeof stringBoolean === "boolean":
      return stringBoolean;
    case "true":
      return true;
    case "false":
      return false;
  }
  return defaultValue2;
};
registerErrorInterceptor(userErrorInterceptor);
const GitDiffView = defineAsyncComponent({
  loader: () => import("./git-diff.view-DODk5Tp3.js"),
  loadingComponent: () => h("div", { class: "row items-center justify-center q-pa-lg" }, [h(QSpinner, { color: "primary", size: "3em" })])
});
const ValidationRules = VuetifyValidationRules;
export {
  useSocketConnected as $,
  datetimeSelector as A,
  itemCountField as B,
  CMSNotification as C,
  legacySelector as D,
  scheduleChangeInfoBanner as E,
  historyTab as F,
  GitDiffView as G,
  tagInput as H,
  tagSelector as I,
  toggleButton as J,
  useChangesWatch as K,
  ListPagination as L,
  useConfirmChangesDialog as M,
  setDefaultRouter as N,
  useDefaultRouter as O,
  useDetectOutsideClick as P,
  useEntityQuery as Q,
  useEntityInfiniteSearchList as R,
  usePublishStates as S,
  usePublishableForm as T,
  useEntitySearchList as U,
  ValidationRules as V,
  EntityListSearchDefaultProps as W,
  useTitle as X,
  connectSockets as Y,
  useSockets as Z,
  _export_sfc as _,
  bfCheckbox as a,
  ROUTES as a0,
  quasarLocales as a1,
  getQuasarLocale as a2,
  createVueI18n as a3,
  getI18n as a4,
  registerErrorInterceptor as a5,
  getEntityAPIClient as a6,
  getClient as a7,
  getEntity$2 as a8,
  postEntity as a9,
  getBaseUrlForBrand as aA,
  PLACEHOLDER_UUID as aB,
  SEARCH_DEBOUNCE as aC,
  BRANDS as aD,
  CMS_BRAND_MAP as aE,
  BRAND_CMS_MAP as aF,
  dateRegex as aG,
  formatDate$1 as aH,
  formatDateDots as aI,
  formatDateddMMyy as aJ,
  formatDateddMMyyyy as aK,
  formatTime as aL,
  formatDateTimeSeconds as aM,
  serializeDates$2 as aN,
  resetDateTimeUnits as aO,
  omitDateTimeSeconds as aP,
  deserializeDatesInObject as aQ,
  formatDuration as aR,
  isDocumentEditable as aS,
  isDocumentVisitable as aT,
  isSafari as aU,
  registerQuasar as aV,
  quasarRulesStub as aW,
  quasarValidateRules as aX,
  extendTableColumnsWithDisabledStyle as aY,
  convertToBool as aZ,
  isAllowed as a_,
  putEntity$1 as aa,
  deleteEntity as ab,
  listEntities$2 as ac,
  registerEntityEndpoint as ad,
  isApiError as ae,
  isApiResponse as af,
  HistoryModelName as ag,
  HistoryService as ah,
  getLastHistoryEntry as ai,
  restSearch as aj,
  UserService as ak,
  getUser as al,
  getUsers as am,
  getCurrentUser as an,
  updateUser as ao,
  authenticate as ap,
  logout as aq,
  CMSDialog as ar,
  useDialogStore as as,
  browserLang as at,
  DEFAULT_HEADER_NAV_HEIGHT as au,
  DEFAULT_SIDEBAR_NAV_WIDTH as av,
  DEFAULT_SHRUNK_SIDEBAR_NAV_WIDTH as aw,
  useGlobalStore as ax,
  useModuleStore as ay,
  useWordCountStore as az,
  bunte$1 as b,
  chip$1 as c,
  useUserStore as d,
  VuetifyValidationRules as e,
  focus$1 as f,
  getDefaultExportFromCjs as g,
  bfBrand_icon as h,
  bfBrandBasedState as i,
  bfEntityNoEditIcon as j,
  bfEntityState_icon as k,
  languageSelector as l,
  modalReload as m,
  bfEntityState_selector as n,
  bfJobSelector as o,
  bfLimitedText_input as p,
  bfLogo_icon as q,
  bfScheduledChangeIcon as r,
  sanitizePathUrl as s,
  brandDropdown_selector as t,
  useNotificationStore as u,
  CardItem as v,
  cardList as w,
  cmsSelector as x,
  contentSourceSelector as y,
  dateRange_selector as z
};
//# sourceMappingURL=index-CVKrhR-K.js.map
